import * as i0 from '@angular/core';
import { Directive, EventEmitter, Input, Output, Injectable, Component, forwardRef, ViewChild, HostListener, NgModule, Inject, Pipe, ContentChildren } from '@angular/core';
import * as i2 from '@angular/forms';
import { NgControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Subject, of, takeWhile, debounceTime, takeUntil, distinctUntilChanged, tap, switchMap, BehaviorSubject, filter, map, withLatestFrom, first, take } from 'rxjs';
import * as i1 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i3 from '@angular/flex-layout/flex';
import * as i1$2 from '@angular/cdk/overlay';
import { OverlayModule, OverlayContainer, Overlay } from '@angular/cdk/overlay';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import { DateTime, Interval } from 'luxon';
import * as i3$1 from '@angular/cdk/bidi';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1$3 from '@angular/platform-browser';
import * as i1$4 from '@angular/cdk/dialog';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import * as i3$2 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$5 from '@angular/router';
import * as ValidatorJs from 'validator';
import * as i3$4 from '@angular/flex-layout/extended';
import * as i3$3 from '@angular/cdk/menu';
import { CdkMenuModule } from '@angular/cdk/menu';
import * as i5 from 'ngx-quill';
import { QuillModule } from 'ngx-quill';
import * as i6 from '@angular/cdk/table';
import { CdkTableModule } from '@angular/cdk/table';
import { ArrayDataSource } from '@angular/cdk/collections';
import * as i3$5 from '@angular/cdk/tree';
import { NestedTreeControl, CdkTreeModule } from '@angular/cdk/tree';

var IconName;
(function (IconName) {
    IconName["PLUS"] = "plus";
    IconName["MINUS"] = "minus";
    IconName["PLUS_CIRCLE"] = "circle-plus";
    IconName["DOWNLOAD"] = "download";
    IconName["UP"] = "caret-up";
    IconName["DOWN"] = "caret-down";
    IconName["ARROW_UP"] = "arrow-up";
    IconName["ARROW_RIGHT"] = "arrow-right";
    IconName["ARROW_DOWN"] = "arrow-down";
    IconName["ARROW_LEFT"] = "arrow-left";
    IconName["ANGLE_UP"] = "angle-up";
    IconName["ANGLE_RIGHT"] = "angle-right";
    IconName["ANGLES_RIGHT"] = "angles-right";
    IconName["ANGLE_DOWN"] = "angle-down";
    IconName["ANGLE_LEFT"] = "angle-left";
    IconName["ANGLES_LEFT"] = "angles-left";
    IconName["ARROW_CIRCLE_UP"] = "circle-arrow-up";
    IconName["ARROW_CIRCLE_RIGHT"] = "circle-arrow-right";
    IconName["ARROW_CIRCLE_DOWN"] = "circle-arrow-down";
    IconName["ARROW_CIRCLE_LEFT"] = "circle-arrow-left";
    IconName["CHECK"] = "check";
    IconName["CHECK_CIRCLE"] = "circle-check";
    IconName["CLOSE"] = "xmark";
    IconName["CLOSE_CIRCLE"] = "circle-xmark";
    IconName["CHEVRON_UP"] = "chevron-up";
    IconName["CHEVRON_DOWN"] = "chevron-down";
    IconName["CHEVRON_RIGHT"] = "chevron-right";
    IconName["CHEVRON_LEFT"] = "chevron-left";
    IconName["SORT"] = "sort";
    IconName["SORT_DOWN"] = "sort-down";
    IconName["SORT_UP"] = "sort-up";
    IconName["WARNING"] = "exclamation-triangle";
    IconName["INFO"] = "info-circle";
    IconName["LAST"] = "step-forward";
    IconName["NEXT"] = "caret-right";
    IconName["PREVIOUS"] = "caret-left";
    IconName["FIRST"] = "step-backward";
    IconName["FULLSCREEN"] = "expand";
    IconName["CAMERA_ROTATE"] = "camera-rotate";
    IconName["REMOVE_FILE"] = "file-circle-xmark";
    IconName["MENU"] = "ellipsis-vertical";
    IconName["MENU_BAR"] = "bars";
    IconName["FILE"] = "file-lines";
    IconName["USER"] = "user";
    IconName["USER_GROUP"] = "user-group";
    IconName["USER_TIE"] = "user-tie";
    IconName["ADDRESS"] = "address-card";
    IconName["LOCK"] = "lock";
    IconName["CONFIG"] = "gear";
    IconName["SHIELD"] = "shield";
    IconName["CALENDAR"] = "calendar";
    IconName["CALENDAR_MONTH"] = "calendar-days";
    IconName["CALENDAR_DAY"] = "calendar-day";
    IconName["CALENDAR_WEEK"] = "calendar-week";
    IconName["CALENDAR_PLUS"] = "calendar-plus";
    IconName["CALENDAR_MINUS"] = "calendar-minus";
    IconName["DELETE"] = "trash-can";
    IconName["NOTIFICATION"] = "bell";
    IconName["QUESTION"] = "circle-question";
    IconName["EMAIL"] = "envelope";
    IconName["BALANCE"] = "scale-balanced";
    IconName["HOME"] = "house";
    IconName["DOUBLE_BACK"] = "backward";
    IconName["DOUBLE_NEXT"] = "forward";
    IconName["SEARCH"] = "magnifying-glass";
    IconName["HOSPITAL"] = "hospital";
    IconName["PDF"] = "file-pdf";
    IconName["CSV"] = "file-csv";
    IconName["EXCEL"] = "file-excel";
    IconName["WORD"] = "file-word";
    IconName["DOCTOR"] = "user-doctor";
    IconName["NURSE"] = "user-nurse";
    IconName["LOCATE_ME"] = "location-crosshairs";
    IconName["LOCATION"] = "location-dot";
    IconName["MAP"] = "map-location-dot";
    IconName["ATTACHMENT"] = "paperclip";
    IconName["FILE_ADD"] = "file-circle-plus";
    IconName["FILE_WAVE"] = "file-waveform";
    IconName["FILE_INVOICE"] = "file-invoice";
    IconName["FILE_IMAGE"] = "file-image";
    IconName["BED"] = "bed";
    IconName["CHART_PIE"] = "chart-pie";
    IconName["USERS"] = "users";
    IconName["DISPLAY"] = "display";
    IconName["TIME"] = "clock";
    IconName["EDIT"] = "pencil";
    IconName["OFF"] = "power-off";
    IconName["USER_CLOCK"] = "user-clock";
    IconName["PHONE"] = "phone";
    IconName["PHONE_FLIP"] = "phone-flip";
    IconName["COPY"] = "copy";
    IconName["FOLDER"] = "folder";
    IconName["FOLDER_OPEN"] = "folder-open";
    IconName["FOLDER_ADD"] = "folder-plus";
    IconName["EYE"] = "eye";
    IconName["ID_CARD"] = "id-card";
    IconName["IMAGE_PORTRAIT"] = "image-portrait";
    IconName["GRADUATE"] = "graduation-cap";
    IconName["STAR"] = "star";
    IconName["CUBES"] = "cubes";
    IconName["MEDAL"] = "medal";
    IconName["TOGGLE_ON"] = "toggle-on";
    IconName["TOGGLE_OFF"] = "toggle-off";
    IconName["SAND_END"] = "hourglass-end";
    IconName["SAND_HALF"] = "hourglass-half";
    IconName["LINK"] = "link";
})(IconName || (IconName = {}));

class BaseComponent {
    destroy$;
    constructor() {
        this.destroy$ = new Subject();
    }
    get destroy() {
        return this.destroy$;
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.0", type: BaseComponent, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [] });

class BaseFormControl extends BaseComponent {
    injector;
    static nextID = 0;
    idControl = `form-control-${BaseFormControl.nextID++}`;
    messageGroupKey = 'validation';
    readonly = false;
    label = '';
    withIcon = false;
    icon = IconName.INFO;
    required = false;
    clearable = true;
    classes = '';
    clickOnSuffix = new EventEmitter;
    placeHolder;
    suffixText;
    formControl;
    _value;
    _onChange = (_) => {
        // no content
    };
    _onTouched = () => {
        // no content
    };
    translationService;
    constructor(injector) {
        super();
        this.injector = injector;
        this.translationService = this.injector.get(TranslateService);
    }
    ngOnChanges(changes) {
        if (changes && (changes['required'] || changes['readonly'])) {
            this.updateStates();
        }
    }
    ngOnInit() {
        this.formControl = this.injector.get(NgControl);
    }
    suffixClick() {
        this.clickOnSuffix.next(this.value);
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.readonly = disabled;
    }
    onChange(value) {
        this._onChange(value);
    }
    onKeyup() {
        this._onTouched();
        this._onChange(this.value);
    }
    onChangeValue() {
        this._onTouched();
        this.onChange(this.value);
    }
    onBlur() {
        this._onTouched();
    }
    clearValue(elt) {
        this.value = null;
        if (elt) {
            elt.value = null;
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.onChange(value);
    }
    get suffix() {
        return this.suffixText ? this.translationService.instant(this.suffixText) : '';
    }
    set suffix(suf) {
        this.suffixText = suf;
    }
    get placeholder() {
        return this.placeHolder ? this.translationService.instant(this.placeHolder) : '';
    }
    set placeholder(plh) {
        this.placeHolder = plh;
    }
    canClear(value) {
        return this.clearable && !this.readonly && value?.toString()?.length > 0;
    }
    get isRequired() {
        return this.field?.hasValidator(Validators.required);
    }
    get field() {
        return this.formControl?.control;
    }
    get errors() {
        return this.field?.errors;
    }
    ngAfterViewInit() {
        this.updateStates();
    }
    updateStates() {
        if (this.field) {
            setTimeout(() => {
                this.readonly = this.readonly || this.field.disabled;
                if (this.readonly) {
                    this.field.disable({ emitEvent: false });
                }
                else {
                    this.field.enable({ emitEvent: false });
                }
                this.required = this.isRequired;
                if (this.required) {
                    this.field.addValidators(Validators.required);
                }
                else {
                    this.field.removeValidators(Validators.required);
                }
            });
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseFormControl, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.0", type: BaseFormControl, inputs: { idControl: "idControl", messageGroupKey: "messageGroupKey", readonly: "readonly", label: "label", withIcon: "withIcon", icon: "icon", required: "required", clearable: "clearable", classes: "classes", value: "value", suffix: "suffix", placeholder: "placeholder" }, outputs: { clickOnSuffix: "clickOnSuffix" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseFormControl, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { idControl: [{
                type: Input
            }], messageGroupKey: [{
                type: Input
            }], readonly: [{
                type: Input
            }], label: [{
                type: Input
            }], withIcon: [{
                type: Input
            }], icon: [{
                type: Input
            }], required: [{
                type: Input
            }], clearable: [{
                type: Input
            }], classes: [{
                type: Input
            }], clickOnSuffix: [{
                type: Output
            }], value: [{
                type: Input
            }], suffix: [{
                type: Input
            }], placeholder: [{
                type: Input
            }] } });

class SanTemplateService {
    trackByFn(index, obj) {
        if (obj['id']) {
            return obj['id'];
        }
        if (obj['code']) {
            return obj['code'];
        }
        if (obj['value']) {
            const v = obj['value'];
            const code = v.code ? v.code : index;
            return v.id ? v.id : code;
        }
        return index;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTemplateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTemplateService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTemplateService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

var FormErrors;
(function (FormErrors) {
    FormErrors["INVALID_DATE"] = "notDateTime";
    FormErrors["REQUIRED"] = "required";
    FormErrors["NUMBER"] = "notNumber";
    FormErrors["DECIMAL"] = "notDecimal";
    FormErrors["MIN"] = "min";
    FormErrors["MAX"] = "max";
    FormErrors["EMAIL"] = "email";
    FormErrors["TEL"] = "tel";
    FormErrors["PATTERN"] = "pattern";
    FormErrors["NOT_EQUAL"] = "notEqual";
    FormErrors["NOT_SAME"] = "notSame";
    FormErrors["PASSWORD"] = "password";
    FormErrors["MINLENGTH"] = "minlength";
    FormErrors["MAXLENGTH"] = "maxlength";
    FormErrors["MAX_FILES"] = "maxFilesError";
    FormErrors["FILES"] = "filesError";
    FormErrors["FILES_SIZE"] = "totalSizeFilesError";
})(FormErrors || (FormErrors = {}));

class SanFormErrorsComponent extends BaseComponent {
    translationService;
    field;
    messageGroupKey = 'validation';
    globalErrors = null;
    globalError = '';
    subscription;
    constructor(translationService) {
        super();
        this.translationService = translationService;
    }
    get errors() {
        return this.field?.errors;
    }
    get minlength() {
        return this.errors[FormErrors.MINLENGTH]?.requiredLength;
    }
    get maxlength() {
        return this.errors[FormErrors.MAXLENGTH]?.requiredLength;
    }
    get value() {
        return this.errors[FormErrors.NOT_EQUAL]?.value;
    }
    get min() {
        return this.errors[FormErrors.MIN]?.min;
    }
    get max() {
        return this.errors[FormErrors.MAX]?.max;
    }
    get message() {
        const keys = Object.keys(this.errors);
        const fErrors = [
            { key: FormErrors.INVALID_DATE },
            { key: FormErrors.REQUIRED },
            { key: FormErrors.NUMBER },
            { key: FormErrors.DECIMAL },
            { key: FormErrors.MIN, params: { min: this.min } },
            { key: FormErrors.MAX, params: { max: this.max } },
            { key: FormErrors.EMAIL },
            { key: FormErrors.TEL },
            { key: FormErrors.PATTERN },
            { key: FormErrors.NOT_EQUAL, params: { value: this.value } },
            { key: FormErrors.NOT_SAME },
            { key: FormErrors.PASSWORD },
            { key: FormErrors.MINLENGTH, params: { minlength: this.minlength } },
            { key: FormErrors.MAXLENGTH, params: { maxlength: this.maxlength } },
            { key: FormErrors.MAX_FILES },
            { key: FormErrors.FILES },
            { key: FormErrors.FILES_SIZE },
        ];
        for (const error of fErrors) {
            if (keys.includes(error.key)) {
                return of(this.translationService.instant(`${this.messageGroupKey}.${error.key}`, error.params ?? null));
            }
        }
        return of(null);
    }
    ngAfterViewInit() {
        if (this.field?.parent) {
            this.field.parent.valueChanges.pipe(takeWhile(() => !!this.globalErrors?.length), debounceTime(100), takeUntil(this.destroy))
                .subscribe(() => {
                const keys = Array.isArray(this.globalErrors) ? this.globalErrors : [this.globalErrors];
                this.globalError = '';
                const errors = this.field.parent?.errors;
                if (errors) {
                    const error = keys.find(key => !!errors[key]);
                    if (error) {
                        this.globalError = `${this.messageGroupKey}.${error}`;
                    }
                }
            });
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.globalErrors = null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsComponent, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: { field: "field", messageGroupKey: "messageGroupKey", globalErrors: "globalErrors" }, usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"errors && field.touched; else global\" class=\"form-errors\">\n  {{message | async}}\n</div>\n<ng-template #global>\n  <div *ngIf=\"globalError?.length\" class=\" form-errors\">{{globalError | translate}}</div>\n</ng-template>", styles: [":host{width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-form-errors', template: "<div *ngIf=\"errors && field.touched; else global\" class=\"form-errors\">\n  {{message | async}}\n</div>\n<ng-template #global>\n  <div *ngIf=\"globalError?.length\" class=\" form-errors\">{{globalError | translate}}</div>\n</ng-template>", styles: [":host{width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1.TranslateService }], propDecorators: { field: [{
                type: Input
            }], messageGroupKey: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }] } });

class SanIconComponent {
    static nextID = 0;
    name;
    id = `icon-${SanIconComponent.nextID++}`;
    style = 'solid';
    size = 'xl';
    classes = '';
    color = '';
    clickable = true;
    disabled = false;
    onclick = new EventEmitter();
    clickOnIcon() {
        if (this.clickable && !this.disabled) {
            this.onclick.next();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanIconComponent, selector: "san-icon", inputs: { name: "name", id: "id", style: "style", size: "size", classes: "classes", color: "color", clickable: "clickable", disabled: "disabled" }, outputs: { onclick: "onclick" }, ngImport: i0, template: "<i [id]=\"id\" class=\"san-icon fa-{{style}} fa-{{name}} fa-{{size}} {{classes}} text-{{color}}\"\n  [class.disabled]=\"disabled\" [class.pointer]=\"!disabled && clickable\" (click)=\"clickOnIcon()\"></i>" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-icon', template: "<i [id]=\"id\" class=\"san-icon fa-{{style}} fa-{{name}} fa-{{size}} {{classes}} text-{{color}}\"\n  [class.disabled]=\"disabled\" [class.pointer]=\"!disabled && clickable\" (click)=\"clickOnIcon()\"></i>" }]
        }], propDecorators: { name: [{
                type: Input
            }], id: [{
                type: Input
            }], style: [{
                type: Input
            }], size: [{
                type: Input
            }], classes: [{
                type: Input
            }], color: [{
                type: Input
            }], clickable: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onclick: [{
                type: Output
            }] } });

class SanAutocompleteComponent extends BaseFormControl {
    injector;
    cd;
    templateService;
    set labelField(field) {
        this.labelIndex = field?.length ? field : 'label';
    }
    set valueField(field) {
        this.valueIndex = field?.length ? field : 'value';
    }
    sources = [];
    filterFn;
    globalErrors;
    manageObject = false;
    nbResult = 10;
    showNothing = true;
    wrapper;
    selected;
    width;
    labelIndex = 'label';
    valueIndex = 'value';
    searching = new Subject();
    options = [];
    term = '';
    isOpen = false;
    IconName = IconName;
    constructor(injector, cd, templateService) {
        super(injector);
        this.injector = injector;
        this.cd = cd;
        this.templateService = templateService;
    }
    ngOnChanges(changes) {
        if (changes) {
            super.ngOnChanges(changes);
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.computeMenuWidth();
        this.searching.pipe(distinctUntilChanged(), takeUntil(this.destroy), tap(term => this.term = term), debounceTime(500), switchMap(() => this.dataSource)).subscribe(data => {
            this.options = data;
            this.openResult();
        });
    }
    writeValue(value) {
        this.selected = !this.manageObject ? this.sources?.find(o => o[this.valueIndex] === value) : value;
        this.value = this.selectedValue;
    }
    get dataSource() {
        return this.filterFn ? this.filterFn(this.term, this.nbResult) : of(this.filteredSources);
    }
    get filteredSources() {
        return this.sources.filter(s => this.isInResult(s)).slice(0, this.nbResult);
    }
    openResult() {
        this.isOpen = true;
        this.cd.detectChanges();
    }
    isInResult(option) {
        const label = option[this.labelIndex] ?? option;
        return label?.toString()?.toLocaleLowerCase().includes(this.term?.toLocaleLowerCase());
    }
    search(event) {
        this.searching.next(event.target.value);
    }
    computeMenuWidth() {
        this.width = this.wrapper.nativeElement.getBoundingClientRect().width;
    }
    get selectedLabel() {
        return this.selected && this.selected[this.valueIndex] ? this.selected[this.labelIndex] : '';
    }
    get selectedValue() {
        return !this.manageObject && this.selected ? this.selected[this.valueIndex] : this.selected;
    }
    onBlurSearch() {
        if (this.term?.length && !this.selectedValue && !this.showNothing) {
            this.field.setValidators(null);
            this.field.setErrors(null);
        }
        else if (this.required) {
            this.field.addValidators([Validators.required]);
        }
        this.field.updateValueAndValidity();
        this.onBlur();
    }
    select(option) {
        this.selected = option;
        this.value = this.selectedValue;
        this.onChangeValue();
    }
    onWinResize() {
        this.wrapper?.nativeElement?.click();
    }
    onClick() {
        if (this.isOpen) {
            this.isOpen = false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteComponent, deps: [{ token: i0.Injector }, { token: i0.ChangeDetectorRef }, { token: SanTemplateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanAutocompleteComponent, selector: "san-autocomplete", inputs: { labelField: "labelField", valueField: "valueField", sources: "sources", filterFn: "filterFn", globalErrors: "globalErrors", manageObject: "manageObject", nbResult: "nbResult", showNothing: "showNothing" }, host: { listeners: { "window:resize": "onWinResize()", "document:click": "onClick()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanAutocompleteComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-autocomplete control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input #valueInput class=\"san-form-control-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      (keyup)=\"search($event)\" [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\"\n      [value]=\"selectedLabel | translate\" [placeholder]=\"placeholder\" [readonly]=\"readonly\" (blur)=\"onBlurSearch()\"\n      [required]=\"required\" cdkOverlayOrigin #trigger=\"cdkOverlayOrigin\" />\n\n    <san-icon *ngIf=\"canClear(valueInput.value)\" (onclick)=\"clearValue(valueInput);term='';\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"trigger\" [cdkConnectedOverlayOpen]=\"isOpen\">\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" *ngIf=\"options?.length || showNothing\"\n      class=\"san-autocomplete-options full-width\" cdkMenu>\n      <span *ngIf=\"!options?.length && showNothing\" class=\"option full-width placeholder\" cdkMenuItem>\n        {{ 'shared.aucunElement' | translate}}\n      </span>\n      <span class=\"option auto-complete-option pointer full-width\" (click)=\"select(op)\"\n        *ngFor=\"let op of options;trackBy:templateService.trackByFn\" cdkMenuItem>{{op[labelIndex] | translate}}</span>\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i1$2.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$2.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-autocomplete', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanAutocompleteComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-autocomplete control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input #valueInput class=\"san-form-control-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      (keyup)=\"search($event)\" [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\"\n      [value]=\"selectedLabel | translate\" [placeholder]=\"placeholder\" [readonly]=\"readonly\" (blur)=\"onBlurSearch()\"\n      [required]=\"required\" cdkOverlayOrigin #trigger=\"cdkOverlayOrigin\" />\n\n    <san-icon *ngIf=\"canClear(valueInput.value)\" (onclick)=\"clearValue(valueInput);term='';\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"trigger\" [cdkConnectedOverlayOpen]=\"isOpen\">\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" *ngIf=\"options?.length || showNothing\"\n      class=\"san-autocomplete-options full-width\" cdkMenu>\n      <span *ngIf=\"!options?.length && showNothing\" class=\"option full-width placeholder\" cdkMenuItem>\n        {{ 'shared.aucunElement' | translate}}\n      </span>\n      <span class=\"option auto-complete-option pointer full-width\" (click)=\"select(op)\"\n        *ngFor=\"let op of options;trackBy:templateService.trackByFn\" cdkMenuItem>{{op[labelIndex] | translate}}</span>\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: i0.ChangeDetectorRef }, { type: SanTemplateService }], propDecorators: { labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], sources: [{
                type: Input
            }], filterFn: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], manageObject: [{
                type: Input
            }], nbResult: [{
                type: Input
            }], showNothing: [{
                type: Input
            }], wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }], onClick: [{
                type: HostListener,
                args: ['document:click']
            }] } });

class SanFormErrorsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsModule, declarations: [SanFormErrorsComponent], imports: [CommonModule, i1.TranslateModule, FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule], exports: [CommonModule,
            FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule,
            SanFormErrorsComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule, CommonModule,
            FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormErrorsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FormsModule,
                        FlexLayoutModule,
                        ReactiveFormsModule
                    ],
                    declarations: [
                        SanFormErrorsComponent
                    ],
                    exports: [
                        CommonModule,
                        FormsModule,
                        FlexLayoutModule,
                        ReactiveFormsModule,
                        SanFormErrorsComponent
                    ]
                }]
        }] });

class SanIconModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanIconModule, declarations: [SanIconComponent], imports: [CommonModule], exports: [SanIconComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanIconModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        SanIconComponent
                    ],
                    exports: [
                        SanIconComponent
                    ]
                }]
        }] });

class SanAutocompleteModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteModule, declarations: [SanAutocompleteComponent], imports: [i1.TranslateModule, SanFormErrorsModule,
            SanIconModule,
            OverlayModule], exports: [SanAutocompleteComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule,
            SanIconModule,
            OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule,
                        SanIconModule,
                        OverlayModule
                    ],
                    declarations: [
                        SanAutocompleteComponent
                    ],
                    exports: [
                        SanAutocompleteComponent
                    ]
                }]
        }] });

class SanBlocComponent {
    header;
    width = 'auto';
    icon;
    retractable = false;
    opened = true;
    actionIcon;
    actionTitle;
    classes = '';
    action = new EventEmitter();
    statusChange = new EventEmitter();
    get statusIcon() {
        return this.opened ? IconName.ANGLE_UP : IconName.ANGLE_DOWN;
    }
    changeStatus() {
        this.opened = !this.opened;
        this.statusChange.next(this.opened);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanBlocComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanBlocComponent, selector: "san-bloc", inputs: { header: "header", width: "width", icon: "icon", retractable: "retractable", opened: "opened", actionIcon: "actionIcon", actionTitle: "actionTitle", classes: "classes" }, outputs: { action: "action", statusChange: "statusChange" }, ngImport: i0, template: "<div class=\"san-bloc {{classes}}\" [style.width]=\"width\">\n  <div *ngIf=\"header?.length\" class=\"bloc-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <san-icon *ngIf=\"icon\" [clickable]=\"false\" [name]=\"icon\"></san-icon> <span>{{header | translate}}</span>\n    <div class=\"app-spacer\"></div>\n    <san-icon *ngIf=\"actionIcon\" [title]=\"(actionTitle ?? '') | translate\" [clickable]=\"true\" (onclick)=\"action.next()\"\n      [name]=\"actionIcon\"></san-icon>\n    <san-icon *ngIf=\"retractable\" [clickable]=\"true\" [name]=\"statusIcon\" (onclick)=\"changeStatus()\"></san-icon>\n  </div>\n  <div class=\"bloc-body\" [class.hidden]=\"!opened && retractable\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanBlocComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-bloc', template: "<div class=\"san-bloc {{classes}}\" [style.width]=\"width\">\n  <div *ngIf=\"header?.length\" class=\"bloc-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <san-icon *ngIf=\"icon\" [clickable]=\"false\" [name]=\"icon\"></san-icon> <span>{{header | translate}}</span>\n    <div class=\"app-spacer\"></div>\n    <san-icon *ngIf=\"actionIcon\" [title]=\"(actionTitle ?? '') | translate\" [clickable]=\"true\" (onclick)=\"action.next()\"\n      [name]=\"actionIcon\"></san-icon>\n    <san-icon *ngIf=\"retractable\" [clickable]=\"true\" [name]=\"statusIcon\" (onclick)=\"changeStatus()\"></san-icon>\n  </div>\n  <div class=\"bloc-body\" [class.hidden]=\"!opened && retractable\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n</div>" }]
        }], propDecorators: { header: [{
                type: Input
            }], width: [{
                type: Input
            }], icon: [{
                type: Input
            }], retractable: [{
                type: Input
            }], opened: [{
                type: Input
            }], actionIcon: [{
                type: Input
            }], actionTitle: [{
                type: Input
            }], classes: [{
                type: Input
            }], action: [{
                type: Output
            }], statusChange: [{
                type: Output
            }] } });

class SanBlocModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanBlocModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanBlocModule, declarations: [SanBlocComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule], exports: [SanBlocComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanBlocModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanBlocModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanBlocComponent
                    ],
                    exports: [
                        SanBlocComponent
                    ]
                }]
        }] });

class SanButtonIconComponent {
    static nextID = 0;
    idControl = `san-button-icon-${SanButtonIconComponent.nextID++}`;
    color = 'primary';
    label;
    icon = IconName.INFO;
    disabled = false;
    borderless = false;
    upper = false;
    iconSize = 'lg';
    classes = '';
    onclick = new EventEmitter();
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanButtonIconComponent, selector: "san-button-icon", inputs: { idControl: "idControl", color: "color", label: "label", icon: "icon", disabled: "disabled", borderless: "borderless", upper: "upper", iconSize: "iconSize", classes: "classes" }, outputs: { onclick: "onclick" }, ngImport: i0, template: "<button type=\"button\" [id]=\"idControl\" class=\"icon-san-button form-margin icon-btn-{{color}} {{classes}} pointer\"\n  [class.disabled]=\"disabled\" [class.borderless]=\"borderless\" role=\"button\" [disabled]=\"disabled\"\n  (click)=\"onclick.next()\">\n  <san-icon name=\"{{icon}}\" [size]=\"iconSize\"></san-icon>\n  <span [class.text-upper]=\"upper\" *ngIf=\"label?.length\"> {{label | translate}}</span>\n</button>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-button-icon', template: "<button type=\"button\" [id]=\"idControl\" class=\"icon-san-button form-margin icon-btn-{{color}} {{classes}} pointer\"\n  [class.disabled]=\"disabled\" [class.borderless]=\"borderless\" role=\"button\" [disabled]=\"disabled\"\n  (click)=\"onclick.next()\">\n  <san-icon name=\"{{icon}}\" [size]=\"iconSize\"></san-icon>\n  <span [class.text-upper]=\"upper\" *ngIf=\"label?.length\"> {{label | translate}}</span>\n</button>" }]
        }], propDecorators: { idControl: [{
                type: Input
            }], color: [{
                type: Input
            }], label: [{
                type: Input
            }], icon: [{
                type: Input
            }], disabled: [{
                type: Input
            }], borderless: [{
                type: Input
            }], upper: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], classes: [{
                type: Input
            }], onclick: [{
                type: Output
            }] } });

class SanButtonIconModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconModule, declarations: [SanButtonIconComponent], imports: [CommonModule, i1.TranslateModule, SanIconModule], exports: [SanButtonIconComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconModule, imports: [CommonModule,
            TranslateModule.forChild(),
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        SanIconModule
                    ],
                    declarations: [
                        SanButtonIconComponent
                    ],
                    exports: [
                        SanButtonIconComponent
                    ]
                }]
        }] });

class SanButtonToggleComponent extends BaseFormControl {
    injector;
    options = [];
    direction = 'horizontal';
    set labelField(field) {
        this.labelIndex = field?.length ? field : 'label';
    }
    set valueField(field) {
        this.valueIndex = field?.length ? field : 'value';
    }
    globalErrors;
    manageObject = false;
    selected;
    labelIndex = 'label';
    valueIndex = 'value';
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnChanges(changes) {
        if (changes) {
            super.ngOnChanges(changes);
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    writeValue(value) {
        this.selected = !this.manageObject ? this.options?.find(o => o[this.valueIndex] === value) : value;
        this.value = this.selectedValue;
    }
    get selectedLabel() {
        return this.selected && this.selected[this.valueIndex] ? this.selected[this.labelIndex] : '';
    }
    get selectedValue() {
        return !this.manageObject && this.selected ? this.selected[this.valueIndex] : this.selected;
    }
    get isVertical() {
        return this.direction === 'vertical';
    }
    get flexDirection() {
        return this.isVertical ? 'column' : 'row';
    }
    get flexAlign() {
        return this.isVertical ? 'space-around start' : 'space-between center';
    }
    isChecked(option) {
        return this.selected && this.selected[this.valueIndex] === option[this.valueIndex];
    }
    select(option) {
        this.selected = option;
        this.value = this.selectedValue;
        this.onChangeValue();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanButtonToggleComponent, selector: "san-button-toggle", inputs: { options: "options", direction: "direction", labelField: "labelField", valueField: "valueField", globalErrors: "globalErrors", manageObject: "manageObject" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanButtonToggleComponent),
                multi: true
            }
        ], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"{{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div *ngIf=\"options?.length\" [fxLayout]=\"flexDirection\" [fxLayoutAlign]=\"flexAlign\"\n    class=\"san-button-toggle form-margin {{classes}} full-width\" (mouseleave)=\"onBlur()\" [class.disabled]=\"readonly\">\n    <input [hidden]=\"true\" [id]=\"idControl\" [name]=\"idControl\" [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <button type=\"button\" *ngFor=\"let op of options;let i=index;\" [id]=\"idControl+i\" class=\"btn-toggle pointer\"\n      [class.horizontal]=\"!isVertical\" [class.btn-toggle-selected]=\"isChecked(op)\" [class.disabled]=\"readonly\"\n      role=\"button\" [disabled]=\"readonly\" (click)=\"select(op)\">\n      {{op[labelIndex] | translate}}\n    </button>\n    <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n    </san-form-errors>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-button-toggle', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanButtonToggleComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"{{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div *ngIf=\"options?.length\" [fxLayout]=\"flexDirection\" [fxLayoutAlign]=\"flexAlign\"\n    class=\"san-button-toggle form-margin {{classes}} full-width\" (mouseleave)=\"onBlur()\" [class.disabled]=\"readonly\">\n    <input [hidden]=\"true\" [id]=\"idControl\" [name]=\"idControl\" [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <button type=\"button\" *ngFor=\"let op of options;let i=index;\" [id]=\"idControl+i\" class=\"btn-toggle pointer\"\n      [class.horizontal]=\"!isVertical\" [class.btn-toggle-selected]=\"isChecked(op)\" [class.disabled]=\"readonly\"\n      role=\"button\" [disabled]=\"readonly\" (click)=\"select(op)\">\n      {{op[labelIndex] | translate}}\n    </button>\n    <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n    </san-form-errors>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { options: [{
                type: Input
            }], direction: [{
                type: Input
            }], labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], manageObject: [{
                type: Input
            }] } });

class SanButtonToggleModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleModule, declarations: [SanButtonToggleComponent], imports: [SanFormErrorsModule, i1.TranslateModule, FlexLayoutModule], exports: [SanButtonToggleComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleModule, imports: [SanFormErrorsModule,
            TranslateModule.forChild(),
            FlexLayoutModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        SanFormErrorsModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule
                    ],
                    declarations: [
                        SanButtonToggleComponent
                    ],
                    exports: [
                        SanButtonToggleComponent
                    ]
                }]
        }] });

class SanButtonComponent {
    static nextID = 0;
    idControl = `san-button-${SanButtonComponent.nextID++}`;
    color = 'primary';
    label = 'Label';
    disabled = false;
    borderless = false;
    upper = false;
    classes = '';
    onclick = new EventEmitter();
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanButtonComponent, selector: "san-button", inputs: { idControl: "idControl", color: "color", label: "label", disabled: "disabled", borderless: "borderless", upper: "upper", classes: "classes" }, outputs: { onclick: "onclick" }, ngImport: i0, template: "<button type=\"button\" [id]=\"idControl\" class=\"san-button form-margin btn-{{color}} pointer {{classes}}\"\n  [class.disabled]=\"disabled\" [class.text-upper]=\"upper\" [class.borderless]=\"borderless\" role=\"button\"\n  [disabled]=\"disabled\" (click)=\"onclick.next()\">\n  {{label | translate}}\n</button>", dependencies: [{ kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-button', template: "<button type=\"button\" [id]=\"idControl\" class=\"san-button form-margin btn-{{color}} pointer {{classes}}\"\n  [class.disabled]=\"disabled\" [class.text-upper]=\"upper\" [class.borderless]=\"borderless\" role=\"button\"\n  [disabled]=\"disabled\" (click)=\"onclick.next()\">\n  {{label | translate}}\n</button>" }]
        }], propDecorators: { idControl: [{
                type: Input
            }], color: [{
                type: Input
            }], label: [{
                type: Input
            }], disabled: [{
                type: Input
            }], borderless: [{
                type: Input
            }], upper: [{
                type: Input
            }], classes: [{
                type: Input
            }], onclick: [{
                type: Output
            }] } });

class SanButtonModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanButtonModule, declarations: [SanButtonComponent], imports: [CommonModule, i1.TranslateModule], exports: [SanButtonComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonModule, imports: [CommonModule,
            TranslateModule.forChild()] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [
                        SanButtonComponent
                    ],
                    exports: [
                        SanButtonComponent
                    ]
                }]
        }] });

const CALENDAR_OFFSET = 10;
var SanCalendarMode;
(function (SanCalendarMode) {
    SanCalendarMode["DAY"] = "DAY";
    SanCalendarMode["WEEK"] = "WEEK";
    SanCalendarMode["MONTH"] = "MONTH";
})(SanCalendarMode || (SanCalendarMode = {}));

var FormatDate;
(function (FormatDate) {
    FormatDate["DayMonthYear"] = "DayMonthYear";
    FormatDate["MonthYear"] = "MonthYear";
    FormatDate["DayMonthYearHourMinSec"] = "DayMonthYearHourMinSec";
    FormatDate["DayMonthYearHourMin"] = "DayMonthYearHourMin";
    FormatDate["MonthYearHourMinSec"] = "MonthYearHourMinSec";
    FormatDate["MonthYearHourMin"] = "MonthYearHourMin";
    FormatDate["HourMin"] = "HourMin";
    FormatDate["HourMinSec"] = "HourMinSec";
})(FormatDate || (FormatDate = {}));

const OVERLAY_BTRG = { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top' };
const OVERLAY_TPRG = { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'bottom' };
const OVERLAY_BTLF = { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' };
const OVERLAY_TPLF = { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' };
const OVERLAY_BTCO = { originX: 'center', originY: 'bottom', overlayX: 'start', overlayY: 'top' };
const OVERLAY_BTCR = { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' };
const OVERLAY_TPCO = { originX: 'center', originY: 'top', overlayX: 'start', overlayY: 'bottom' };
const OVERLAY_TPCR = { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' };
const OVERLAY_POSITIONS = [OVERLAY_BTRG, OVERLAY_TPRG, OVERLAY_BTLF, OVERLAY_TPLF, OVERLAY_BTCO, OVERLAY_BTCR, OVERLAY_TPCO, OVERLAY_TPCR];

var ColumnType;
(function (ColumnType) {
    ColumnType["NUMBER"] = "NUMBER";
    ColumnType["STRING"] = "STRING";
    ColumnType["BOOLEEN"] = "BOOLEEN";
    ColumnType["EMAIL"] = "EMAIL";
    ColumnType["LINK"] = "LINK";
    ColumnType["TEL"] = "TEL";
    ColumnType["DATE"] = "DATE";
    ColumnType["HTML"] = "HTML";
})(ColumnType || (ColumnType = {}));
var ExportType;
(function (ExportType) {
    ExportType["ALL"] = "all";
    ExportType["PDF"] = "pdf";
    ExportType["CSV"] = "csv";
})(ExportType || (ExportType = {}));
const ACTION_COL = { field: 'actions' };

var PageSize;
(function (PageSize) {
    PageSize[PageSize["SIZE_20"] = 20] = "SIZE_20";
    PageSize[PageSize["SIZE_50"] = 50] = "SIZE_50";
    PageSize[PageSize["SIZE_100"] = 100] = "SIZE_100";
    PageSize[PageSize["SIZE_150"] = 150] = "SIZE_150";
})(PageSize || (PageSize = {}));
class Page {
    currentPage = 1;
    pageSize;
    nbPage;
    nbRows;
    skip;
    constructor(pageSize = PageSize.SIZE_20) {
        this.pageSize = pageSize;
    }
    static build(page) {
        page = page ?? { currentPage: 1, pageSize: PageSize.SIZE_20 };
        page.skip = (page.currentPage - 1) * page.pageSize;
        return page;
    }
}
var SearchOperator;
(function (SearchOperator) {
    SearchOperator["EQUAL"] = "EQUAL";
    SearchOperator["SUPERIOR"] = "SUPERIOR";
    SearchOperator["INFERIOR"] = "INFERIOR";
    SearchOperator["SUPERIOR_EQUAL"] = "SUPERIOR_EQUAL";
    SearchOperator["INFERIOR_EQUAL"] = "INFERIOR_EQUAL";
    SearchOperator["CONTAINS"] = "CONTAINS";
    SearchOperator["STARTS_WITH"] = "STARTS_WITH";
    SearchOperator["FINISH_WITH"] = "FINISH_WITH";
    SearchOperator["DIFFERENT"] = "DIFFERENT";
    SearchOperator["NOT_NULL"] = "NOT_NULL";
    SearchOperator["IS_NULL"] = "IS_NULL";
    SearchOperator["INCLUDES"] = "INCLUDES";
    SearchOperator["NOT_INCLUDES"] = "NOT_INCLUDES";
    SearchOperator["BETWEEN"] = "BETWEEN";
})(SearchOperator || (SearchOperator = {}));
var SearchType;
(function (SearchType) {
    SearchType["STRING"] = "STRING";
    SearchType["NUMBER"] = "NUMBER";
    SearchType["BOOLEEN"] = "BOOLEEN";
    SearchType["DATE"] = "DATE";
})(SearchType || (SearchType = {}));
var SearchCondition;
(function (SearchCondition) {
    SearchCondition["AND"] = "AND";
    SearchCondition["OR"] = "OR";
})(SearchCondition || (SearchCondition = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));

var ListItemAction;
(function (ListItemAction) {
    ListItemAction["ALL"] = "ALL";
    ListItemAction["VIEW"] = "VIEW";
    ListItemAction["VALIDATE"] = "VALIDATE";
    ListItemAction["EDIT"] = "EDIT";
    ListItemAction["DUPLICATE"] = "DUPLICATE";
    ListItemAction["DELETE"] = "DELETE";
    ListItemAction["TOGGLE"] = "TOGGLE";
})(ListItemAction || (ListItemAction = {}));

class SanDividerComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanDividerComponent, selector: "san-divider", ngImport: i0, template: "<div class=\"san-divider\"></div>" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-divider', template: "<div class=\"san-divider\"></div>" }]
        }] });

class SanInformationComponent {
    message;
    classes = '';
    icon = IconName.INFO;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanInformationComponent, selector: "san-information", inputs: { message: "message", classes: "classes", icon: "icon" }, ngImport: i0, template: "<div *ngIf=\"message?.length\" fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px grid\"\n  class=\"information {{classes}}\">\n  <san-icon [clickable]=\"false\" [name]=\"icon\"></san-icon>\n  <span>{{message | translate}}</span>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-information', template: "<div *ngIf=\"message?.length\" fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px grid\"\n  class=\"information {{classes}}\">\n  <san-icon [clickable]=\"false\" [name]=\"icon\"></san-icon>\n  <span>{{message | translate}}</span>\n</div>" }]
        }], propDecorators: { message: [{
                type: Input
            }], classes: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

class SanSpinnerComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanSpinnerComponent, selector: "san-spinner", ngImport: i0, template: "<div class=\"san-spinner\"></div>", styles: [".san-spinner{width:24px;height:24px;border-radius:50%;background:radial-gradient(farthest-side,var(--accent-color) 94%,rgba(0,0,0,0)) top/3.8px 3.8px no-repeat,conic-gradient(rgba(0,0,0,0) 30%,var(--accent-color));-webkit-mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 3.8px),#000 0);animation:san-spinner-anim 1s infinite linear}@keyframes san-spinner-anim{to{transform:rotate(1turn)}}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-spinner', template: "<div class=\"san-spinner\"></div>", styles: [".san-spinner{width:24px;height:24px;border-radius:50%;background:radial-gradient(farthest-side,var(--accent-color) 94%,rgba(0,0,0,0)) top/3.8px 3.8px no-repeat,conic-gradient(rgba(0,0,0,0) 30%,var(--accent-color));-webkit-mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 3.8px),#000 0);animation:san-spinner-anim 1s infinite linear}@keyframes san-spinner-anim{to{transform:rotate(1turn)}}\n"] }]
        }] });

class DynamicOverlayContainer extends OverlayContainer {
    setContainerElement(elt) {
        this._containerElement = elt;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlayContainer, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlayContainer, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlayContainer, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class DynamicOverlay extends Overlay {
    container;
    renderer;
    constructor(scroll, overlayContainer, cmpFtrResolver, posBuilder, kbDispatcher, injector, ngZone, document, directionnaly, location, outsideClickDispatcher, rendererFactory) {
        super(scroll, overlayContainer, cmpFtrResolver, posBuilder, kbDispatcher, injector, ngZone, document, directionnaly, location, outsideClickDispatcher);
        this.renderer = rendererFactory.createRenderer(null, null);
        this.container = overlayContainer;
    }
    setContainerElement(elt) {
        this.renderer.setStyle(elt, 'transform', 'translateZ(0)');
        this.container.setContainerElement(elt);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlay, deps: [{ token: i1$2.ScrollStrategyOptions }, { token: DynamicOverlayContainer }, { token: i0.ComponentFactoryResolver }, { token: i1$2.OverlayPositionBuilder }, { token: i1$2.OverlayKeyboardDispatcher }, { token: i0.Injector }, { token: i0.NgZone }, { token: DOCUMENT }, { token: i3$1.Directionality }, { token: i1$1.Location }, { token: i1$2.OverlayOutsideClickDispatcher }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlay, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DynamicOverlay, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.ScrollStrategyOptions }, { type: DynamicOverlayContainer }, { type: i0.ComponentFactoryResolver }, { type: i1$2.OverlayPositionBuilder }, { type: i1$2.OverlayKeyboardDispatcher }, { type: i0.Injector }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i3$1.Directionality }, { type: i1$1.Location }, { type: i1$2.OverlayOutsideClickDispatcher }, { type: i0.RendererFactory2 }] });

class SanLoaderDirective {
    targetEl;
    dynamicOverlay;
    isLoading = false;
    hasBackdrop = true;
    overlayRef;
    constructor(targetEl, dynamicOverlay) {
        this.targetEl = targetEl;
        this.dynamicOverlay = dynamicOverlay;
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.isLoading?.currentValue) {
            this.showLoader();
        }
        else {
            this.hideLoader();
        }
    }
    showLoader() {
        this.dynamicOverlay.setContainerElement(this.targetEl.nativeElement);
        this.overlayRef = this.dynamicOverlay.create({
            positionStrategy: this.dynamicOverlay.position().global().centerHorizontally().centerVertically(),
            hasBackdrop: this.hasBackdrop,
            backdropClass: 'san-spinner-loader'
        });
        this.overlayRef.attach(new ComponentPortal(SanSpinnerComponent));
    }
    hideLoader() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanLoaderDirective, deps: [{ token: i0.ElementRef }, { token: DynamicOverlay }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.0", type: SanLoaderDirective, selector: "[isLoading]", inputs: { isLoading: "isLoading", hasBackdrop: "hasBackdrop" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanLoaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[isLoading]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: DynamicOverlay }], propDecorators: { isLoading: [{
                type: Input
            }], hasBackdrop: [{
                type: Input
            }] } });

class DatePipe {
    dateService;
    constructor(dateService) {
        this.dateService = dateService;
    }
    transform(date, format) {
        return this.dateService.format(date, format);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DatePipe, deps: [{ token: SanDateService }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: DatePipe, name: "synDate", pure: false });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'synDate', pure: false }]
        }], ctorParameters: () => [{ type: SanDateService }] });
class DateIsTodayPipe {
    transform(date) {
        return SanDateService.equal(date);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DateIsTodayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: DateIsTodayPipe, name: "isToday" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DateIsTodayPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'isToday' }]
        }] });
class DateIsCurrentMonthPipe {
    transform(date, monthDate) {
        return SanDateService.isCurrentMonth(date, monthDate);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DateIsCurrentMonthPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: DateIsCurrentMonthPipe, name: "isCurrentMonth" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: DateIsCurrentMonthPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'isCurrentMonth' }]
        }] });

class SanFileService {
    static formatSize(bytes) {
        const size = SanFileService.convertSize(bytes);
        return size > 1 ? `${size.toFixed(2)} Mo` : `${(size * 1000).toFixed(2)} Kb`;
    }
    static convertSize(bytes) {
        return bytes > 0 ? (bytes / (1000 * 1000)) : 0;
    }
    static totalSize(files) {
        const size = files.reduce((currentSize, file) => file.size + currentSize, 0);
        return this.convertSize(size);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class PreviewFilePipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return url ? this.sanitizer.bypassSecurityTrustUrl(url) : './assets/images/photo.svg';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: PreviewFilePipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: PreviewFilePipe, name: "previewFile" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: PreviewFilePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'previewFile' }]
        }], ctorParameters: () => [{ type: i1$3.DomSanitizer }] });
class FileSizePipe {
    transform(size) {
        return SanFileService.formatSize(size);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: FileSizePipe, name: "fileSize" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'fileSize' }]
        }] });

class HasItemActionPipe {
    transform(item, action) {
        return item?.actions?.includes(ListItemAction.ALL) || item?.actions?.includes(action);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: HasItemActionPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: HasItemActionPipe, name: "hasItemAction" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: HasItemActionPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'hasItemAction' }]
        }] });

class SafeHtmlPipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SafeHtmlPipe, name: "safeHtml" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safeHtml' }]
        }], ctorParameters: () => [{ type: i1$3.DomSanitizer }] });
class SafeUrlPipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SafeUrlPipe, name: "safeUrl" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safeUrl' }]
        }], ctorParameters: () => [{ type: i1$3.DomSanitizer }] });

const exportables = [
    DatePipe,
    PreviewFilePipe,
    FileSizePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    DateIsTodayPipe,
    HasItemActionPipe,
    DateIsCurrentMonthPipe
];
class SanPipeModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanPipeModule, declarations: [DatePipe,
            PreviewFilePipe,
            FileSizePipe,
            SafeHtmlPipe,
            SafeUrlPipe,
            DateIsTodayPipe,
            HasItemActionPipe,
            DateIsCurrentMonthPipe], exports: [DatePipe,
            PreviewFilePipe,
            FileSizePipe,
            SafeHtmlPipe,
            SafeUrlPipe,
            DateIsTodayPipe,
            HasItemActionPipe,
            DateIsCurrentMonthPipe] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPipeModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...exportables
                    ],
                    exports: [
                        ...exportables
                    ]
                }]
        }] });

class SanSharedModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanSharedModule, declarations: [SanSpinnerComponent,
            SanInformationComponent,
            SanDividerComponent,
            SanLoaderDirective], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanPipeModule, i1.TranslateModule], exports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanSpinnerComponent,
            SanInformationComponent,
            SanDividerComponent,
            SanPipeModule,
            SanLoaderDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSharedModule, imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanPipeModule,
            TranslateModule.forChild(), CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanPipeModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SanSpinnerComponent,
                        SanInformationComponent,
                        SanDividerComponent,
                        SanLoaderDirective
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FlexLayoutModule,
                        SanIconModule,
                        SanPipeModule,
                        TranslateModule.forChild()
                    ],
                    exports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FlexLayoutModule,
                        SanIconModule,
                        SanSpinnerComponent,
                        SanInformationComponent,
                        SanDividerComponent,
                        SanPipeModule,
                        SanLoaderDirective
                    ],
                    providers: []
                }]
        }] });

class BaseDialogComponent extends BaseComponent {
    injector;
    dialogRef;
    data;
    closeIcon;
    constructor(injector) {
        super();
        this.injector = injector;
        this.dialogRef = this.injector.get((DialogRef));
        this.data = this.injector.get(DIALOG_DATA);
        this.closeIcon = !this.dialogRef.disableClose;
    }
    close(data) {
        this.dialogRef.close(data);
    }
    onEsc() {
        if (this.closeIcon) {
            this.close();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.dialogRef?.containerInstance?.dispose();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseDialogComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.0", type: BaseDialogComponent, host: { listeners: { "keydown.esc": "onEsc()" } }, usesInheritance: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: BaseDialogComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { data: [{
                type: Inject,
                args: [DIALOG_DATA]
            }], onEsc: [{
                type: HostListener,
                args: ['keydown.esc']
            }] } });

class SanModalComponent {
    header = '';
    hasFooter = true;
    draggable = true;
    closable = true;
    closeModal = new EventEmitter();
    get hasHeader() {
        return this.header?.length > 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanModalComponent, selector: "san-modal", inputs: { header: "header", hasFooter: "hasFooter", draggable: "draggable", closable: "closable" }, outputs: { closeModal: "closeModal" }, ngImport: i0, template: "<div class=\"san-modal\" cdkDrag cdkDragRootElement=\".san-dialog-container\" [cdkDragDisabled]=\"!draggable || !hasHeader\">\n  <div *ngIf=\"hasHeader\" [class.mouse-drag]=\"draggable\" class=\"modal-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\"\n    cdkDragHandle>\n    <label>{{header | translate}}</label>\n    <div class=\"app-spacer\"></div>\n    <span *ngIf=\"closable\" (click)=\"closeModal.next()\" class=\"close\">&times;</span>\n  </div>\n  <div class=\"modal-body\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"modal-footer\">\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i3$2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i3$2.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-modal', template: "<div class=\"san-modal\" cdkDrag cdkDragRootElement=\".san-dialog-container\" [cdkDragDisabled]=\"!draggable || !hasHeader\">\n  <div *ngIf=\"hasHeader\" [class.mouse-drag]=\"draggable\" class=\"modal-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\"\n    cdkDragHandle>\n    <label>{{header | translate}}</label>\n    <div class=\"app-spacer\"></div>\n    <span *ngIf=\"closable\" (click)=\"closeModal.next()\" class=\"close\">&times;</span>\n  </div>\n  <div class=\"modal-body\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"modal-footer\">\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>" }]
        }], propDecorators: { header: [{
                type: Input
            }], hasFooter: [{
                type: Input
            }], draggable: [{
                type: Input
            }], closable: [{
                type: Input
            }], closeModal: [{
                type: Output
            }] } });

class SanDialogComponent extends BaseDialogComponent {
    injector;
    sanitizer;
    IconName = IconName;
    constructor(injector, sanitizer) {
        super(injector);
        this.injector = injector;
        this.sanitizer = sanitizer;
    }
    cancel() {
        if (this.data?.noAction) {
            this.data.noAction();
        }
        this.close();
    }
    valid() {
        if (this.data?.yesAction) {
            this.data.yesAction();
        }
        this.close({ content: true });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogComponent, deps: [{ token: i0.Injector }, { token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanDialogComponent, selector: "san-dialog", usesInheritance: true, ngImport: i0, template: "<san-modal [header]=\"data?.header ? data.header : ''\" [closable]=\"closeIcon\" (closeModal)=\"close()\">\n  <div class=\"dialog-content\" *ngIf=\"data.content\" [innerHTML]=\"sanitizer.bypassSecurityTrustHtml(data.content)\"\n    content>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"end center\" footer>\n    <san-button-icon *ngIf=\"data?.noLabel\" [icon]=\"IconName.CLOSE_CIRCLE\" color=\"warn\" [label]=\"data.noLabel\"\n      (onclick)=\"cancel()\">\n    </san-button-icon>\n    <san-button-icon color=\"primary\" [icon]=\"IconName.CHECK_CIRCLE\" *ngIf=\"data?.yesLabel\" [label]=\"data.yesLabel\"\n      (onclick)=\"valid()\">\n    </san-button-icon>\n  </div>\n</san-modal>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanButtonIconComponent, selector: "san-button-icon", inputs: ["idControl", "color", "label", "icon", "disabled", "borderless", "upper", "iconSize", "classes"], outputs: ["onclick"] }, { kind: "component", type: SanModalComponent, selector: "san-modal", inputs: ["header", "hasFooter", "draggable", "closable"], outputs: ["closeModal"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-dialog', template: "<san-modal [header]=\"data?.header ? data.header : ''\" [closable]=\"closeIcon\" (closeModal)=\"close()\">\n  <div class=\"dialog-content\" *ngIf=\"data.content\" [innerHTML]=\"sanitizer.bypassSecurityTrustHtml(data.content)\"\n    content>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"end center\" footer>\n    <san-button-icon *ngIf=\"data?.noLabel\" [icon]=\"IconName.CLOSE_CIRCLE\" color=\"warn\" [label]=\"data.noLabel\"\n      (onclick)=\"cancel()\">\n    </san-button-icon>\n    <san-button-icon color=\"primary\" [icon]=\"IconName.CHECK_CIRCLE\" *ngIf=\"data?.yesLabel\" [label]=\"data.yesLabel\"\n      (onclick)=\"valid()\">\n    </san-button-icon>\n  </div>\n</san-modal>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: i1$3.DomSanitizer }] });

class SanDialogService {
    dialog;
    dialogRef;
    toggleMainDialog = new Subject();
    defaultConf = {
        closeOnNavigation: true,
        hasBackdrop: true,
        panelClass: 'san-dialog-container',
        disableClose: false
    };
    constructor(dialog) {
        this.dialog = dialog;
    }
    confirm(header, content, yesAction, noAction, yesLabel, noLabel) {
        return this.open(SanDialogComponent, this.setConfirmData(header, content, yesAction, noAction, yesLabel, noLabel));
    }
    /**
     * Parametre pour une confirm dialog
     * @param header
     * @param content
     * @param yesAction
     * @param noAction
     * @returns
     */
    setConfirmData(header, content, yesAction, noAction, yesLabel, noLabel) {
        return {
            data: {
                header: header,
                content: content,
                yesLabel: yesLabel ?? 'shared.oui',
                noLabel: noLabel ?? 'shared.non',
                yesAction: () => yesAction(),
                noAction: () => noAction ? noAction() : {}
            },
            hasBackdrop: true
        };
    }
    /**
     * Ouvre une dialog
     * @param comp
     * @param param
     * @returns
     */
    open(comp, param) {
        param = param ? { ...this.defaultConf, ...param } : this.defaultConf;
        return this.dialog.open(comp, param);
    }
    initMainDialog() {
        this.toggleMainDialog.pipe(debounceTime(500)).subscribe(({ state, data }) => {
            if (state) {
                this.dialogRef = this.open(SanDialogComponent, {
                    data: data,
                    hasBackdrop: true,
                    disableClose: true
                });
            }
            else if (this.dialogRef) {
                this.dialogRef.close();
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogService, deps: [{ token: i1$4.Dialog }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$4.Dialog }] });

class SanNavigationService {
    route;
    router;
    constructor(route, router) {
        this.route = route;
        this.router = router;
    }
    navigate(url, extras) {
        this.router.navigateByUrl(url, extras);
    }
    goHome() {
        this.router.navigateByUrl('/');
    }
    readQueryParam(key) {
        return this.route.snapshot.queryParamMap.get(key);
    }
    readPathParam(key) {
        return this.route.snapshot.paramMap.get(key);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanNavigationService, deps: [{ token: i1$5.ActivatedRoute }, { token: i1$5.Router }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanNavigationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$5.ActivatedRoute }, { type: i1$5.Router }] });

class SanTreeService {
    getChildren = (node) => node.children ?? [];
    hasChild = (_, nodeData) => nodeData.children?.length > 0;
    hasNoContent = (_, nodeData) => nodeData.label === '';
    static updateChildrenState(children, state) {
        children?.forEach(c => c.checked = state);
    }
    static findParent(node, nodes, parent) {
        let found = null;
        for (let i = 0; i < nodes.length && !found; i++) {
            const n = nodes[i];
            if (n.id === node.id) {
                return parent;
            }
            else if (n?.children?.length) {
                found = SanTreeService.findParent(node, n.children, n);
            }
        }
        return found;
    }
    static updateLevel(nodes = [], level = 1) {
        for (const node of nodes) {
            node.level = level;
            node.children = SanTreeService.updateLevel(node.children, level + 1);
        }
        return nodes;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SanValidatorService {
    translationService;
    static ERROR_NOT_SAME = 'notSame';
    static ERROR_REQUIRED = 'required';
    static ERROR_EQUAL = 'notEqual';
    static ERROR_EMAIL = 'email';
    static ERROR_NUMBER = 'notNumber';
    static ERROR_DECIMAL = 'notDecimal';
    static ERROR_MIN_LENGTH = 'minlength';
    static ERROR_MAX_LENGTH = 'maxlength';
    static ERROR_MAX = 'max';
    static ERROR_MIN = 'min';
    static ERROR_PATTERN = 'pattern';
    static ERROR_MAX_FILES = 'maxFilesError';
    static ERROR_FILES = 'filesError';
    static ERROR_FILES_SIZE = 'totalSizeFilesError';
    constructor(translationService) {
        this.translationService = translationService;
    }
    handleMessage(errors) {
        const keys = Object.keys(errors);
        let message = '';
        switch (keys[0]) {
            case SanValidatorService.ERROR_MIN_LENGTH:
                message = this.translationService.instant(`validation.${keys[0]}`, { min: errors[SanValidatorService.ERROR_MIN_LENGTH].requiredLength });
                break;
            case SanValidatorService.ERROR_MAX_LENGTH:
                message = this.translationService.instant(`validation.${keys[0]}`, { min: errors[SanValidatorService.ERROR_MAX_LENGTH].requiredLength });
                break;
            case SanValidatorService.ERROR_MAX:
                message = this.translationService.instant(`validation.${keys[0]}`, { max: errors[SanValidatorService.ERROR_MAX].max });
                break;
            case SanValidatorService.ERROR_MIN:
                message = this.translationService.instant(`validation.${keys[0]}`, { min: errors[SanValidatorService.ERROR_MIN].min });
                break;
            case SanValidatorService.ERROR_NOT_SAME:
            case SanValidatorService.ERROR_EMAIL:
            case SanValidatorService.ERROR_NUMBER:
            case SanValidatorService.ERROR_DECIMAL:
            case SanValidatorService.ERROR_PATTERN:
            case SanValidatorService.ERROR_FILES:
            case SanValidatorService.ERROR_MAX_FILES:
            case SanValidatorService.ERROR_FILES_SIZE:
                message = this.translationService.instant(`validation.${keys[0]}`);
                break;
            case SanValidatorService.ERROR_REQUIRED:
            default:
                break;
        }
        return message;
    }
    static isEmail(value) {
        return value?.length && ValidatorJs.isEmail(value);
    }
    static isNumber(value) {
        return !!value?.match(/^\d+$/);
    }
    static isDecimal(value) {
        return SanValidatorService.isNumber(value) || !!value?.match(/^\d+\.\d+$/);
    }
    static numberPattern(digit) {
        return digit ? `^[0-9]{${digit}}$` : '^[0-9]$';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanValidatorService, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanValidatorService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.TranslateService }] });

class ObjectUtils {
    static formatTel(tel = '', portable = '') {
        return [tel, portable].filter(s => s?.length).join(' / ');
    }
    static truncate(text, size = 10) {
        if (text?.length > size) {
            return `${text.substring(0, size)}...`;
        }
        return text;
    }
    static isNullOrUndefined(value) {
        return value === null || value === undefined;
    }
    static generateArray(start = 0, end = 10, step = 1) {
        return _.range(start, end, step);
    }
    static hasProperty(obj, key) {
        return Object.keys(obj).includes(key);
    }
    static sort(data, field, direction) {
        if (field?.length && data?.length) {
            data.sort((a, b) => {
                let vA = _.cloneDeep(_.get(a, field, null));
                let vB = _.cloneDeep(_.get(b, field, null));
                if (typeof vA === 'boolean' || typeof vB === 'boolean') {
                    return !vA ? -1 : 1;
                }
                else if (typeof vA === 'number' || typeof vB === 'number') {
                    vA = vA ?? 0;
                    vB = vB ?? 0;
                    return Number(vA) > Number(vB) ? 1 : -1;
                }
                else if (typeof vA === 'string' || typeof vB === 'string') {
                    vA = vA ?? 'ZZ';
                    vB = vB ?? 'ZZ';
                    return vA.toString().localeCompare(vB.toString());
                }
                else {
                    return vA > vB ? 1 : -1;
                }
            });
            if (direction === SortDirection.DESC) {
                data.reverse();
            }
        }
        return _.cloneDeep(data);
    }
}

class SanDateService {
    translationService;
    constructor(translationService) {
        this.translationService = translationService;
    }
    format(date, format) {
        if (date) {
            format = format ?? FormatDate.DayMonthYear;
            return DateTime.fromISO(date.toISOString()).toFormat(this.translationService.instant(`shared.dateFormat.${format}`));
        }
        return '';
    }
    static formatJS(date, format) {
        if (date) {
            return DateTime.fromISO(date.toISOString()).toFormat(format ?? 'dd/MM/yyyy');
        }
        return '';
    }
    transform(date, format) {
        format = format ?? FormatDate.DayMonthYear;
        try {
            const dt = DateTime.fromFormat(date, this.translationService.instant(`shared.dateFormat.${format}`));
            return dt.isValid ? dt.toJSDate() : null;
        }
        catch (error) {
            return null;
        }
    }
    getDateSize(format) {
        return this.translationService.instant(`shared.dateFormat.${format}`).toString().length;
    }
    /**
     * Convertit toutes les dates en string en OmpDate
     * @param item
     */
    static recursiveForEach(item) {
        if (!ObjectUtils.isNullOrUndefined(item)) {
            if (Array.isArray(item)) {
                // Array
                item.forEach(v => SanDateService.recursiveForEach(v));
            }
            else if (typeof item === 'string' && SanDateService.isDateRegexMatch(item)) {
                item = new Date(item);
            }
            else if (typeof item === 'object') {
                // Object
                SanDateService.interceptDatesInObject(item);
            }
        }
    }
    /**
     * Intercepte toutes les dates en string en Date dans un object
     * @param item
     */
    static interceptDatesInObject(item) {
        const keys = Object.keys(item);
        for (const key of keys) {
            const value = item[key];
            if (!value || value === '' || key === 'Build-DateTime' || key === 'buildTime') {
                // Date de construction de l'application ou pas de value, on ne traite pas
                continue;
            }
            if (typeof value === 'string' && SanDateService.isDateRegexMatch(value)) {
                item[key] = new Date(value);
            }
            else {
                SanDateService.recursiveForEach(value);
            }
        }
    }
    /**
     * Check if string is on date format
     *
     * @param item
     */
    static isDateRegexMatch(item) {
        return item.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([+-](\d{2}):(\d{2}))?Z?/);
    }
    static dateDiff(start = new Date(), end = new Date(), units = 'hours') {
        return Interval.fromDateTimes(start, end).length(units);
    }
    static setHours(hour, minute, second, date) {
        return SanDateService.dateTime(date).set({ hour, minute, second }).toJSDate();
    }
    static goToMonthYear(year, month, day) {
        const date = new Date();
        date.setDate(day ?? 1);
        if (month) {
            date.setMonth(month - 1);
        }
        if (year) {
            date.setFullYear(year);
        }
        return DateTime.fromJSDate(date);
    }
    static dateTime(date) {
        return DateTime.fromJSDate(cloneDeep(date) ?? new Date());
    }
    static daysNumberInMonth(month, year) {
        return SanDateService.goToMonthYear(year, month).daysInMonth;
    }
    static daysNumberInYear(year) {
        return SanDateService.goToMonthYear(year).daysInYear;
    }
    static firstDateOfMonth(month, year) {
        return SanDateService.goToMonthYear(year, month).startOf('month').toJSDate();
    }
    static lastDateOfMonth(month, year) {
        return SanDateService.goToMonthYear(year, month).endOf('month').toJSDate();
    }
    static firstDayOfMonth(date) {
        return SanDateService.dateTime(date).startOf('month').toJSDate();
    }
    static lastDayOfMonth(date) {
        return SanDateService.dateTime(date).endOf('month').toJSDate();
    }
    static weekOfFirstDateOfMonth(month, year) {
        return SanDateService.goToMonthYear(year, month).startOf('month').weekNumber;
    }
    static weekOfLastDateOfMonth(month, year) {
        return SanDateService.goToMonthYear(year, month).endOf('month').weekNumber;
    }
    static firstWeekOfYear(year) {
        return SanDateService.goToMonthYear(year).startOf('year').weekNumber;
    }
    static firstDateOfWeek(date) {
        return SanDateService.dateTime(date).startOf('week').toJSDate();
    }
    static lastDateOfWeek(date) {
        return SanDateService.dateTime(date).endOf('week').toJSDate();
    }
    static lastWeekOfYear(year) {
        return SanDateService.goToMonthYear(year).endOf('year').weekNumber;
    }
    static currentDate() {
        return DateTime.now().day;
    }
    static currentMonth() {
        return DateTime.now().month;
    }
    static currentYear() {
        return DateTime.now().year;
    }
    static currentHour() {
        return DateTime.now().hour;
    }
    static currentMinute() {
        return DateTime.now().minute;
    }
    static currentSecond() {
        return DateTime.now().second;
    }
    static monthName(month) {
        return SanDateService.goToMonthYear(2020, month).monthLong;
    }
    static dayName(date) {
        return SanDateService.dateTime(date).weekdayShort;
    }
    static dayNumber(date) {
        return SanDateService.dateTime(date).weekday;
    }
    static tommorow() {
        return SanDateService.dateTime().plus({ day: 1 }).toJSDate();
    }
    static yesterday() {
        return SanDateService.dateTime().minus({ day: 1 }).toJSDate();
    }
    static nextMonth(month, year) {
        return SanDateService.goToMonthYear(year, month, 1).plus({ month: 1 }).toJSDate();
    }
    static previousMonth(month, year) {
        return SanDateService.goToMonthYear(year, month, 1).minus({ month: 1 }).toJSDate();
    }
    static dateAfterDays(days, date = new Date()) {
        return SanDateService.dateTime(date).plus({ days }).toJSDate();
    }
    static dateBeforeDays(days, date = new Date()) {
        return SanDateService.dateTime(date).minus({ days }).toJSDate();
    }
    static dateAfterWeeks(weeks, date = new Date()) {
        return SanDateService.dateTime(date).plus({ weeks }).toJSDate();
    }
    static dateBeforeWeeks(weeks, date = new Date()) {
        return SanDateService.dateTime(date).minus({ weeks }).toJSDate();
    }
    static dateAfterMonths(months, date = new Date()) {
        return SanDateService.dateTime(date).plus({ months }).toJSDate();
    }
    static dateBeforeMonths(months, date = new Date()) {
        return SanDateService.dateTime(date).minus({ months }).toJSDate();
    }
    static dateAfterYears(years, date = new Date()) {
        return SanDateService.dateTime(date).plus({ years }).toJSDate();
    }
    static dateBeforeYears(years, date = new Date()) {
        return SanDateService.dateTime(date).minus({ years }).toJSDate();
    }
    static trunk(date = new Date()) {
        date = cloneDeep(date);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    static lastDayTime(date = new Date()) {
        date = cloneDeep(date);
        date.setHours(23, 59, 59, 999);
        return date;
    }
    static twoDigit(value) {
        return value < 10 ? value.toString() : `0${value.toString()}`;
    }
    static equal(date1, date2 = new Date(), dateOnly = true) {
        if (dateOnly) {
            date1 = SanDateService.trunk(date1);
            date2 = SanDateService.trunk(date2);
        }
        return date1.getTime() === date2.getTime();
    }
    static isCurrentMonth(date, monthDate) {
        monthDate = monthDate ?? SanDateService.trunk();
        return date.getMonth() === monthDate.getMonth() && date.getFullYear() === monthDate.getFullYear();
    }
    static periodOnDate(date = new Date(), start = new Date(), end = new Date()) {
        return date.getTime() <= start.getTime() && date.getTime() >= end.getTime();
    }
    static includes(date = new Date(), start = new Date(), end = new Date()) {
        return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
    }
    static inMinMax(date, min, max) {
        let valid = true;
        if ((min && max && min > max) || ObjectUtils.isNullOrUndefined(date)) { // Invalid interval or date
            return valid;
        }
        if (min || max) {
            if (min) {
                valid = date.getTime() >= min.getTime();
            }
            if (max) {
                valid = valid && date.getTime() <= max.getTime();
            }
        }
        return valid;
    }
    static hourInMinMax(hour, min, max) {
        let valid = true;
        if ((min && max && min > max) || ObjectUtils.isNullOrUndefined(hour)) { // Invalid interval or date
            return valid;
        }
        if (min || max) {
            if (min) {
                valid = hour >= min;
            }
            if (max) {
                valid = valid && hour <= max;
            }
        }
        return valid;
    }
    static generateWeekDates(date) {
        let start = SanDateService.trunk(SanDateService.firstDateOfWeek(date));
        const end = SanDateService.trunk(SanDateService.lastDateOfWeek(date));
        const days = [];
        while (start.getTime() <= end.getTime()) {
            days.push(cloneDeep(start));
            start = SanDateService.dateAfterDays(1, start);
        }
        return days;
    }
    static generateMonthDates(month, year) {
        const dates = [];
        let start = SanDateService.trunk(SanDateService.firstDateOfMonth(month, year));
        const dayNumber = SanDateService.dayNumber(start);
        // First day is Monday => start on monday if first day of month is another day
        if (dayNumber > 1) {
            start = SanDateService.dateBeforeDays(dayNumber - 1, start);
        }
        // We have 6 weeks on 7 days = 42 days => add 41 days on start date to have last date
        const last = SanDateService.dateAfterDays(41, start);
        for (let i = 0; i < 6 && start.getTime() <= last.getTime(); i++) { // weeks
            dates[i] = [];
            for (let j = 0; j < 7; j++) { // days
                dates[i][j] = cloneDeep(start);
                start = SanDateService.dateAfterDays(1, start);
            }
        }
        return dates;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateService, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.TranslateService }] });

class SanCalendarService {
    updateView = new BehaviorSubject(true);
    static getCoordinateFromHour(date, height, offset = CALENDAR_OFFSET) {
        const mn = date.getHours() * 60 + date.getMinutes();
        const endMn = 24 * 60;
        return (mn * height / endMn) + offset;
    }
    static getCurrentHourCoordinate(height, day) {
        const date = new Date();
        if ((!day || SanDateService.equal(day, date)) && height > 0) {
            return SanCalendarService.getCoordinateFromHour(date, height);
        }
        else {
            return 0;
        }
    }
    static getHourFromCoordinate(coordinate, height, date, offset = CALENDAR_OFFSET) {
        const mn = (coordinate - offset) * 24 * 60 / height;
        return SanDateService.dateTime(date).set({ hour: mn / 60, minute: mn % 60 }).toJSDate();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SanMenuComponent {
    static nextID = 0;
    id = `san-menu-${SanMenuComponent.nextID++}`;
    mainMenu;
    menuItems = [];
    triggerMenu = new EventEmitter();
    classes = '';
    data;
    clickOnMenu(m) {
        this.triggerMenu.next(m);
        if (m?.click) {
            m.click(this.data);
        }
    }
    isVisible(m) {
        if (m?.visibleFn) {
            return m.visibleFn(this.data);
        }
        return !Object.keys(m).includes('visible') || !!m.visible;
    }
    setData(data) {
        this.data = data;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanMenuComponent, selector: "san-menu", inputs: { menuItems: "menuItems", classes: "classes" }, outputs: { triggerMenu: "triggerMenu" }, viewQueries: [{ propertyName: "mainMenu", first: true, predicate: ["mainMenu"], descendants: true, static: true }], ngImport: i0, template: "<ng-template #mainMenu>\n  <div [id]=\"id\" *ngIf=\"menuItems.length\" class=\"san-menu {{classes}}\" fxLayout=\"column\" fxLayoutAlign=\"start start\"\n    cdkMenu>\n    <ng-container *ngFor=\"let m of menuItems;let last = last; let i=index;\">\n      <ng-container *ngIf=\"isVisible(m)\">\n        <ng-container *ngIf=\"!m.items?.length else withItems;\">\n          <div id=\"{{id}}-item-{{i}}\" class=\"san-menu-item\" [class.separator]=\"!last && !!m.separator\"\n            (click)=\"clickOnMenu(m)\" fxLayout=\"row\" fxLayoutAlign=\"start center\" cdkMenuItem>\n            <img alt=\"Icon\" *ngIf=\"m.icon?.length\" class=\"btnFlag\" [src]=\"m.icon\" />\n            <span>{{m.label | translate}}</span>\n          </div>\n        </ng-container>\n        <ng-template #withItems>\n          <div id=\"{{id}}-item-{{i}}\" class=\"san-menu-item\" [class.separator]=\"!last && !!m.separator\" fxLayout=\"row\"\n            fxLayoutAlign=\"start center\" cdkMenuItem [cdkMenuTriggerFor]=\"subMenuItems.mainMenu\">\n            <img alt=\"Icon\" *ngIf=\"m.icon?.length\" class=\"btnFlag\" [src]=\"m.icon\" />\n            <span>{{m.label | translate}}</span>\n          </div>\n          <san-menu #subMenuItems [menuItems]=\"m.items\"></san-menu>\n        </ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-template>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i3$3.CdkMenu, selector: "[cdkMenu]", outputs: ["closed"], exportAs: ["cdkMenu"] }, { kind: "directive", type: i3$3.CdkMenuItem, selector: "[cdkMenuItem]", inputs: ["cdkMenuItemDisabled", "cdkMenuitemTypeaheadLabel"], outputs: ["cdkMenuItemTriggered"], exportAs: ["cdkMenuItem"] }, { kind: "directive", type: i3$3.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "component", type: SanMenuComponent, selector: "san-menu", inputs: ["menuItems", "classes"], outputs: ["triggerMenu"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-menu', template: "<ng-template #mainMenu>\n  <div [id]=\"id\" *ngIf=\"menuItems.length\" class=\"san-menu {{classes}}\" fxLayout=\"column\" fxLayoutAlign=\"start start\"\n    cdkMenu>\n    <ng-container *ngFor=\"let m of menuItems;let last = last; let i=index;\">\n      <ng-container *ngIf=\"isVisible(m)\">\n        <ng-container *ngIf=\"!m.items?.length else withItems;\">\n          <div id=\"{{id}}-item-{{i}}\" class=\"san-menu-item\" [class.separator]=\"!last && !!m.separator\"\n            (click)=\"clickOnMenu(m)\" fxLayout=\"row\" fxLayoutAlign=\"start center\" cdkMenuItem>\n            <img alt=\"Icon\" *ngIf=\"m.icon?.length\" class=\"btnFlag\" [src]=\"m.icon\" />\n            <span>{{m.label | translate}}</span>\n          </div>\n        </ng-container>\n        <ng-template #withItems>\n          <div id=\"{{id}}-item-{{i}}\" class=\"san-menu-item\" [class.separator]=\"!last && !!m.separator\" fxLayout=\"row\"\n            fxLayoutAlign=\"start center\" cdkMenuItem [cdkMenuTriggerFor]=\"subMenuItems.mainMenu\">\n            <img alt=\"Icon\" *ngIf=\"m.icon?.length\" class=\"btnFlag\" [src]=\"m.icon\" />\n            <span>{{m.label | translate}}</span>\n          </div>\n          <san-menu #subMenuItems [menuItems]=\"m.items\"></san-menu>\n        </ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-template>" }]
        }], propDecorators: { mainMenu: [{
                type: ViewChild,
                args: ['mainMenu', { static: true }]
            }], menuItems: [{
                type: Input
            }], triggerMenu: [{
                type: Output
            }], classes: [{
                type: Input
            }] } });

class SanRectComponent {
    x;
    y;
    r = 0;
    width;
    height;
    classes = '';
    content;
    title;
    color;
    selected = false;
    menu = [];
    openMenuEvent = new EventEmitter();
    get visible() {
        return this.width > 0 || this.height > 0;
    }
    get fill() {
        return this.color ?? 'rgb(0,191,165)';
    }
    get tooltip() {
        return this.title ?? (this.content ?? '');
    }
    openMenu() {
        if (this.menu?.filter(m => m.visible !== false)?.length) {
            this.openMenuEvent.next();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanRectComponent, selector: "[san-rect]", inputs: { x: "x", y: "y", r: "r", width: "width", height: "height", classes: "classes", content: "content", title: "title", color: "color", selected: "selected", menu: "menu" }, outputs: { openMenuEvent: "openMenuEvent" }, ngImport: i0, template: "<svg:rect *ngIf=\"visible\" [attr.x]=\"x\" [attr.y]=\"y\" [attr.width]=\"width\" [attr.height]=\"height\"\n  [ngStyle]=\"{'fill': fill , 'stroke': 'rgba(0, 0, 0, 0.6)' }\" class=\"san-rect {{classes}}\"\n  [class.selected-rect]=\"selected\">\n</svg:rect>\n<svg:foreignObject [attr.x]=\"x+2\" [attr.y]=\"y\" [attr.width]=\"width\" [attr.height]=\"height\">\n  <xhtml:div [cdkContextMenuTriggerFor]=\"menuActions.mainMenu\" (cdkContextMenuOpened)=\"openMenu()\"\n    class=\"full-width full-height\" [class.text-white]=\"selected\" [title]=\"tooltip\" fxLayout=\"column\"\n    fxLayoutAlign=\"center center\">\n    {{content ?? ''}}\n  </xhtml:div>\n</svg:foreignObject>\n\n<san-menu #menuActions [menuItems]=\"menu\"></san-menu>", styles: [".san-rect{stroke-width:.1;fill-opacity:.5;stroke-opacity:.8}.selected-rect{stroke-width:.5;stroke-opacity:1;stroke:var(--warn-color)!important;fill:var(--warn-color)!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i3$4.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { kind: "directive", type: i3$3.CdkContextMenuTrigger, selector: "[cdkContextMenuTriggerFor]", inputs: ["cdkContextMenuTriggerFor", "cdkContextMenuPosition", "cdkContextMenuTriggerData", "cdkContextMenuDisabled"], outputs: ["cdkContextMenuOpened", "cdkContextMenuClosed"], exportAs: ["cdkContextMenuTriggerFor"] }, { kind: "component", type: SanMenuComponent, selector: "san-menu", inputs: ["menuItems", "classes"], outputs: ["triggerMenu"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRectComponent, decorators: [{
            type: Component,
            args: [{ selector: '[san-rect]', template: "<svg:rect *ngIf=\"visible\" [attr.x]=\"x\" [attr.y]=\"y\" [attr.width]=\"width\" [attr.height]=\"height\"\n  [ngStyle]=\"{'fill': fill , 'stroke': 'rgba(0, 0, 0, 0.6)' }\" class=\"san-rect {{classes}}\"\n  [class.selected-rect]=\"selected\">\n</svg:rect>\n<svg:foreignObject [attr.x]=\"x+2\" [attr.y]=\"y\" [attr.width]=\"width\" [attr.height]=\"height\">\n  <xhtml:div [cdkContextMenuTriggerFor]=\"menuActions.mainMenu\" (cdkContextMenuOpened)=\"openMenu()\"\n    class=\"full-width full-height\" [class.text-white]=\"selected\" [title]=\"tooltip\" fxLayout=\"column\"\n    fxLayoutAlign=\"center center\">\n    {{content ?? ''}}\n  </xhtml:div>\n</svg:foreignObject>\n\n<san-menu #menuActions [menuItems]=\"menu\"></san-menu>", styles: [".san-rect{stroke-width:.1;fill-opacity:.5;stroke-opacity:.8}.selected-rect{stroke-width:.5;stroke-opacity:1;stroke:var(--warn-color)!important;fill:var(--warn-color)!important}\n"] }]
        }], propDecorators: { x: [{
                type: Input
            }], y: [{
                type: Input
            }], r: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], classes: [{
                type: Input
            }], content: [{
                type: Input
            }], title: [{
                type: Input
            }], color: [{
                type: Input
            }], selected: [{
                type: Input
            }], menu: [{
                type: Input
            }], openMenuEvent: [{
                type: Output
            }] } });

class SanDayCellComponent extends BaseComponent {
    calendarService;
    changeDect;
    ngZone;
    templateService;
    day;
    currentEvent;
    showLines = true;
    menu = [];
    addOnDblClick;
    readonly = false;
    set refreshView(refresh) {
        this.calendarService.updateView.next(refresh);
    }
    daySvg;
    addingEvent = new EventEmitter();
    clickOnEvent = new EventEmitter();
    dbClickOnEvent = new EventEmitter();
    events = [];
    hoursCoordinates = [];
    currentHourCoordinate = 0;
    width = 0;
    height = 0;
    interval = null;
    svgClass = 'san-day-cell-svg';
    constructor(calendarService, changeDect, ngZone, templateService) {
        super();
        this.calendarService = calendarService;
        this.changeDect = changeDect;
        this.ngZone = ngZone;
        this.templateService = templateService;
    }
    ngOnChanges(changes) {
        if (changes.day) {
            this.computeEvents();
        }
    }
    get isToday() {
        return SanDateService.equal(this.day.date, new Date());
    }
    get isCurrentEvent() {
        return this.currentEvent?.start?.getTime()?.toString();
    }
    setViewSize() {
        if (this.daySvg?.nativeElement) {
            this.width = this.daySvg.nativeElement.clientWidth;
            this.height = this.daySvg.nativeElement.clientHeight;
        }
    }
    updateCurrentHour() {
        this.currentHourCoordinate = SanCalendarService.getCurrentHourCoordinate(this.height, this.day.date);
    }
    drawHourLines() {
        this.setViewSize();
        if (this.height > 0 && this.showLines) {
            const height = this.height / 24;
            this.hoursCoordinates = ObjectUtils.generateArray(0, 24).map((h, i) => height * i + CALENDAR_OFFSET);
        }
        else {
            this.hoursCoordinates = [];
        }
    }
    ngOnInit() {
        this.calendarService.updateView.asObservable().pipe(takeUntil(this.destroy), debounceTime(500), filter(compute => compute)).subscribe(() => {
            this.updateCurrentHour();
            this.computeEvents();
        });
        this.drawHourLines();
        this.ngZone.runOutsideAngular(() => this.interval = setInterval(() => this.updateCurrentHour(), 30000));
    }
    computeEvents() {
        this.setViewSize();
        let events = [];
        if (this.height > 0 && this.width > 0 && this.day?.events?.length) {
            events = this.day.events.map(p => {
                const y = SanCalendarService.getCoordinateFromHour(p.start, this.height);
                const y2 = SanCalendarService.getCoordinateFromHour(p.end, this.height);
                const height = y2 - y;
                let title = null;
                if (p.titleFn && p.data) {
                    title = p.titleFn(p.data);
                }
                else if (p.title?.length) {
                    title = p.title;
                }
                const content = cloneDeep(title);
                if (!ObjectUtils.hasProperty(p, 'showTime') || p.showTime) {
                    title = `${SanDateService.formatJS(p.start, 'HH:mm')} - ${SanDateService.formatJS(p.end, 'HH:mm')} ${title ?? ''}`;
                }
                return { ...p, id: p.start.getTime().toString(), y, height, title, content };
            });
        }
        this.events = cloneDeep(events);
        this.changeDect.detectChanges();
    }
    handleDblClick(event) {
        const target = event?.target;
        if (target?.id?.toString()?.includes(this.svgClass)) {
            const dimension = target.getBoundingClientRect() ?? null;
            if (dimension) {
                const y = event.clientY - dimension.top;
                const date = SanCalendarService.getHourFromCoordinate(y, this.height, this.day.date);
                this.addingEvent.next(date);
            }
        }
    }
    handlePriodClick(period, double = false) {
        this.currentEvent = period;
        this.clickOnEvent.next(period);
        if (double) {
            this.dbClickOnEvent.next(period);
        }
    }
    handleClick(event) {
        if (event.target?.getAttribute('class')?.includes(this.svgClass)) {
            this.handlePriodClick(null);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        clearInterval(this.interval);
        this.events = [];
        this.currentHourCoordinate = 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDayCellComponent, deps: [{ token: SanCalendarService }, { token: i0.ChangeDetectorRef }, { token: i0.NgZone }, { token: SanTemplateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanDayCellComponent, selector: "san-day-cell", inputs: { day: "day", currentEvent: "currentEvent", showLines: "showLines", menu: "menu", addOnDblClick: "addOnDblClick", readonly: "readonly", refreshView: "refreshView" }, outputs: { addingEvent: "addingEvent", clickOnEvent: "clickOnEvent", dbClickOnEvent: "dbClickOnEvent" }, viewQueries: [{ propertyName: "daySvg", first: true, predicate: ["daySvg"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<svg #daySvg id=\"{{svgClass}}-{{day.date.getTime()}}\" [class]=\"svgClass\" (click)=\"handleClick($event)\"\n  (dblclick)=\"handleDblClick($event)\" width=\"100%\" height=\"100%\">\n\n  <svg:line *ngFor=\"let hourCoord of hoursCoordinates;\" [attr.x1]=\"0\" [attr.y1]=\"hourCoord\" [attr.x2]=\"width\"\n    [attr.y2]=\"hourCoord\" class=\"hour-line\" />\n\n  <svg:g class=\"pointer period-rect\" *ngFor=\"let p of events;trackBy:templateService.trackByFn;\" san-rect [x]=\"0\"\n    [y]=\"p.y\" [r]=\"5\" [width]=\"width\" [height]=\"p.height\" [content]=\"p.content\" [title]=\"p.title\"\n    (click)=\"handlePriodClick(p)\" (dblclick)=\"handlePriodClick(p,true)\" [menu]=\"menu\"\n    (openMenuEvent)=\"handlePriodClick(p)\" [selected]=\"p.id === isCurrentEvent\" [color]=\"p.color\"></svg:g>\n\n  <svg:line *ngIf=\"currentHourCoordinate && isToday\" [attr.x1]=\"0\" [attr.y1]=\"currentHourCoordinate\" [attr.x2]=\"width\"\n    [attr.y2]=\"currentHourCoordinate\" class=\"current-hour-line\" />\n\n</svg>", styles: [".hour-line{stroke:var(--warn-color);stroke-width:.1}.current-hour-line{stroke:var(--warn-color);stroke-width:2}\n"], dependencies: [{ kind: "component", type: SanRectComponent, selector: "[san-rect]", inputs: ["x", "y", "r", "width", "height", "classes", "content", "title", "color", "selected", "menu"], outputs: ["openMenuEvent"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDayCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-day-cell', template: "<svg #daySvg id=\"{{svgClass}}-{{day.date.getTime()}}\" [class]=\"svgClass\" (click)=\"handleClick($event)\"\n  (dblclick)=\"handleDblClick($event)\" width=\"100%\" height=\"100%\">\n\n  <svg:line *ngFor=\"let hourCoord of hoursCoordinates;\" [attr.x1]=\"0\" [attr.y1]=\"hourCoord\" [attr.x2]=\"width\"\n    [attr.y2]=\"hourCoord\" class=\"hour-line\" />\n\n  <svg:g class=\"pointer period-rect\" *ngFor=\"let p of events;trackBy:templateService.trackByFn;\" san-rect [x]=\"0\"\n    [y]=\"p.y\" [r]=\"5\" [width]=\"width\" [height]=\"p.height\" [content]=\"p.content\" [title]=\"p.title\"\n    (click)=\"handlePriodClick(p)\" (dblclick)=\"handlePriodClick(p,true)\" [menu]=\"menu\"\n    (openMenuEvent)=\"handlePriodClick(p)\" [selected]=\"p.id === isCurrentEvent\" [color]=\"p.color\"></svg:g>\n\n  <svg:line *ngIf=\"currentHourCoordinate && isToday\" [attr.x1]=\"0\" [attr.y1]=\"currentHourCoordinate\" [attr.x2]=\"width\"\n    [attr.y2]=\"currentHourCoordinate\" class=\"current-hour-line\" />\n\n</svg>", styles: [".hour-line{stroke:var(--warn-color);stroke-width:.1}.current-hour-line{stroke:var(--warn-color);stroke-width:2}\n"] }]
        }], ctorParameters: () => [{ type: SanCalendarService }, { type: i0.ChangeDetectorRef }, { type: i0.NgZone }, { type: SanTemplateService }], propDecorators: { day: [{
                type: Input
            }], currentEvent: [{
                type: Input
            }], showLines: [{
                type: Input
            }], menu: [{
                type: Input
            }], addOnDblClick: [{
                type: Input
            }], readonly: [{
                type: Input
            }], refreshView: [{
                type: Input
            }], daySvg: [{
                type: ViewChild,
                args: ['daySvg', { static: true }]
            }], addingEvent: [{
                type: Output
            }], clickOnEvent: [{
                type: Output
            }], dbClickOnEvent: [{
                type: Output
            }] } });

class SanMonthDayCellComponent {
    templateService;
    days;
    monthDate;
    currentEvent;
    menu = [];
    addOnDblClick;
    readonly = false;
    addingEvent = new EventEmitter();
    clickOnEvent = new EventEmitter();
    dbClickOnEvent = new EventEmitter();
    IconName = IconName;
    constructor(templateService) {
        this.templateService = templateService;
    }
    get weekDays() {
        return this.days?.length > 0 ? this.days[0].map(d => SanDateService.dayNumber(d.date)) : [];
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMonthDayCellComponent, deps: [{ token: SanTemplateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanMonthDayCellComponent, selector: "san-month-day-cell", inputs: { days: "days", monthDate: "monthDate", currentEvent: "currentEvent", menu: "menu", addOnDblClick: "addOnDblClick", readonly: "readonly" }, outputs: { addingEvent: "addingEvent", clickOnEvent: "clickOnEvent", dbClickOnEvent: "dbClickOnEvent" }, ngImport: i0, template: "<div class=\"full-width san-month-days\">\n  <table class=\"table-month-days\">\n    <thead>\n      <th *ngFor=\"let date of weekDays;\" class=\"many-days\">\n        {{'shared.calendar.days.' + date + '.short' | translate}}\n      </th>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let dates of days;let lastRow = last;trackBy:templateService.trackByFn;\">\n        <td class=\"day-col\" [class.out-of-month]=\"!(day.date|isCurrentMonth:monthDate)\"\n          *ngFor=\"let day of dates;let lastCol = last;trackBy:templateService.trackByFn;\">\n          <div [class.today]=\"day.date|isToday\">{{day.date.getDate()}}</div>\n          <san-day-cell [day]=\"day\" [currentEvent]=\"currentEvent\" [showLines]=\"false\" [addOnDblClick]=\"addOnDblClick\"\n            [readonly]=\"readonly\" [menu]=\"menu\" (addingEvent)=\"addingEvent.next($event);\"\n            (clickOnEvent)=\"clickOnEvent.next($event)\" (dbClickOnEvent)=\"dbClickOnEvent.next($event)\"\n            [refreshView]=\"lastCol && lastRow\"></san-day-cell>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [":host{--day-table-width: 99.8%;--day-cell-border: .5px solid var(--accent-color);--day-cell-width: var(--day-table-width)}.san-month-days{height:700px;overflow:auto;border-bottom:var(--day-cell-border)}.table-month-days{width:var(--day-table-width);border-collapse:collapse;margin:2px;position:relative}.table-month-days th,.table-month-days td{padding:5px;border:var(--day-cell-border);border-bottom:0px}.table-month-days th{position:-webkit-sticky;position:sticky;top:0;background-color:var(--accent-color);color:var(--white-color)}.table-month-days .many-days{width:calc(var(--day-cell-width) / 7)}.table-month-days .today{color:var(--accent-color);font-weight:700}.table-month-days .out-of-month{color:var(--accent-warn);opacity:.5}.table-month-days td.day-col{height:100px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: SanDayCellComponent, selector: "san-day-cell", inputs: ["day", "currentEvent", "showLines", "menu", "addOnDblClick", "readonly", "refreshView"], outputs: ["addingEvent", "clickOnEvent", "dbClickOnEvent"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: DateIsTodayPipe, name: "isToday" }, { kind: "pipe", type: DateIsCurrentMonthPipe, name: "isCurrentMonth" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMonthDayCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-month-day-cell', template: "<div class=\"full-width san-month-days\">\n  <table class=\"table-month-days\">\n    <thead>\n      <th *ngFor=\"let date of weekDays;\" class=\"many-days\">\n        {{'shared.calendar.days.' + date + '.short' | translate}}\n      </th>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let dates of days;let lastRow = last;trackBy:templateService.trackByFn;\">\n        <td class=\"day-col\" [class.out-of-month]=\"!(day.date|isCurrentMonth:monthDate)\"\n          *ngFor=\"let day of dates;let lastCol = last;trackBy:templateService.trackByFn;\">\n          <div [class.today]=\"day.date|isToday\">{{day.date.getDate()}}</div>\n          <san-day-cell [day]=\"day\" [currentEvent]=\"currentEvent\" [showLines]=\"false\" [addOnDblClick]=\"addOnDblClick\"\n            [readonly]=\"readonly\" [menu]=\"menu\" (addingEvent)=\"addingEvent.next($event);\"\n            (clickOnEvent)=\"clickOnEvent.next($event)\" (dbClickOnEvent)=\"dbClickOnEvent.next($event)\"\n            [refreshView]=\"lastCol && lastRow\"></san-day-cell>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [":host{--day-table-width: 99.8%;--day-cell-border: .5px solid var(--accent-color);--day-cell-width: var(--day-table-width)}.san-month-days{height:700px;overflow:auto;border-bottom:var(--day-cell-border)}.table-month-days{width:var(--day-table-width);border-collapse:collapse;margin:2px;position:relative}.table-month-days th,.table-month-days td{padding:5px;border:var(--day-cell-border);border-bottom:0px}.table-month-days th{position:-webkit-sticky;position:sticky;top:0;background-color:var(--accent-color);color:var(--white-color)}.table-month-days .many-days{width:calc(var(--day-cell-width) / 7)}.table-month-days .today{color:var(--accent-color);font-weight:700}.table-month-days .out-of-month{color:var(--accent-warn);opacity:.5}.table-month-days td.day-col{height:100px}\n"] }]
        }], ctorParameters: () => [{ type: SanTemplateService }], propDecorators: { days: [{
                type: Input
            }], monthDate: [{
                type: Input
            }], currentEvent: [{
                type: Input
            }], menu: [{
                type: Input
            }], addOnDblClick: [{
                type: Input
            }], readonly: [{
                type: Input
            }], addingEvent: [{
                type: Output
            }], clickOnEvent: [{
                type: Output
            }], dbClickOnEvent: [{
                type: Output
            }] } });

class SanSelectComponent extends BaseFormControl {
    injector;
    templateService;
    set labelField(field) {
        this.labelIndex = field?.length ? field : 'label';
    }
    set valueField(field) {
        this.valueIndex = field?.length ? field : 'value';
    }
    options = [];
    globalErrors;
    manageObject = false;
    showPlaceholder = true;
    wrapper;
    selected;
    width;
    labelIndex = 'label';
    valueIndex = 'value';
    constructor(injector, templateService) {
        super(injector);
        this.injector = injector;
        this.templateService = templateService;
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes.options) {
            this.select(this.selected);
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.computeMenuWidth();
    }
    writeValue(value) {
        if (this.manageObject || !this.options?.length) {
            this.selected = value;
        }
        else {
            this.selected = this.options?.find(o => o[this.valueIndex] === value);
        }
        this.value = this.selectedValue;
    }
    computeMenuWidth() {
        this.width = this.wrapper.nativeElement.getBoundingClientRect().width;
    }
    get selectedLabel() {
        return this.selected && this.selected[this.valueIndex] ? this.selected[this.labelIndex] : '';
    }
    get selectedValue() {
        return !this.manageObject && this.selected ? this.selected[this.valueIndex] : this.selected;
    }
    select(option) {
        this.selected = option;
        this.value = this.selectedValue;
        this.onChangeValue();
    }
    onWinResize() {
        this.wrapper.nativeElement.click();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectComponent, deps: [{ token: i0.Injector }, { token: SanTemplateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanSelectComponent, selector: "san-select", inputs: { labelField: "labelField", valueField: "valueField", options: "options", globalErrors: "globalErrors", manageObject: "manageObject", showPlaceholder: "showPlaceholder" }, host: { listeners: { "window:resize": "onWinResize()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanSelectComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" [class.disabled]=\"readonly\" fxLayoutAlign=\"space-around start\"\n  class=\"san-select control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input class=\"san-form-control-input san-select-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\"\n      [value]=\"selectedLabel | translate\"\n      [placeholder]=\"this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)\"\n      [readonly]=\"true\" (blur)=\"onBlur()\" [required]=\"isRequired\" [cdkMenuTriggerFor]=\"menu\" />\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template #menu>\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" class=\"san-select-options full-width\"\n      cdkMenu>\n      <span *ngIf=\"showPlaceholder\" class=\"option pointer full-width placeholder\" (click)=\"select(null)\" cdkMenuItem>\n        {{ this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)}}\n      </span>\n      <span class=\"option pointer full-width\" (click)=\"select(op)\"\n        *ngFor=\"let op of options;trackBy:templateService.trackByFn\" cdkMenuItem>{{op[labelIndex] | translate}}</span>\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i3$3.CdkMenu, selector: "[cdkMenu]", outputs: ["closed"], exportAs: ["cdkMenu"] }, { kind: "directive", type: i3$3.CdkMenuItem, selector: "[cdkMenuItem]", inputs: ["cdkMenuItemDisabled", "cdkMenuitemTypeaheadLabel"], outputs: ["cdkMenuItemTriggered"], exportAs: ["cdkMenuItem"] }, { kind: "directive", type: i3$3.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-select', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanSelectComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" [class.disabled]=\"readonly\" fxLayoutAlign=\"space-around start\"\n  class=\"san-select control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input class=\"san-form-control-input san-select-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\"\n      [value]=\"selectedLabel | translate\"\n      [placeholder]=\"this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)\"\n      [readonly]=\"true\" (blur)=\"onBlur()\" [required]=\"isRequired\" [cdkMenuTriggerFor]=\"menu\" />\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template #menu>\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" class=\"san-select-options full-width\"\n      cdkMenu>\n      <span *ngIf=\"showPlaceholder\" class=\"option pointer full-width placeholder\" (click)=\"select(null)\" cdkMenuItem>\n        {{ this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)}}\n      </span>\n      <span class=\"option pointer full-width\" (click)=\"select(op)\"\n        *ngFor=\"let op of options;trackBy:templateService.trackByFn\" cdkMenuItem>{{op[labelIndex] | translate}}</span>\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: SanTemplateService }], propDecorators: { labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], options: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], manageObject: [{
                type: Input
            }], showPlaceholder: [{
                type: Input
            }], wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class SanDatePickerComponent {
    date = new Date();
    minDate;
    maxDate;
    dateChange = new EventEmitter();
    currentMonth = SanDateService.currentMonth();
    currentYear = SanDateService.currentYear();
    dates = [];
    days = [];
    months = ObjectUtils.generateArray(1, 13).map(m => ({ value: m, label: `shared.calendar.months.${m}.long` }));
    years = [];
    IconName = IconName;
    ngOnChanges(changes) {
        if (changes.date) {
            this.updateDates();
        }
    }
    ngOnInit() {
        this.generateYears();
        this.generateDate();
    }
    updateDates() {
        const dateTime = SanDateService.dateTime(this.date ?? new Date());
        this.currentMonth = dateTime.month;
        this.currentYear = dateTime.year;
        this.generateYears();
        this.generateDate();
    }
    generateDate() {
        const dates = SanDateService.generateMonthDates(this.currentMonth, this.currentYear);
        this.days = dates[0].map(d => SanDateService.dayNumber(d));
        this.dates = dates;
    }
    generateYears() {
        this.years = ObjectUtils.generateArray(this.currentYear - 20, this.currentYear + 21).map(y => ({ value: y, label: y }));
    }
    selectYear(year) {
        this.currentYear = year;
        this.generateYears();
        this.generateDate();
    }
    changeMonth(next = true) {
        const date = next ? SanDateService.nextMonth(this.currentMonth, this.currentYear) : SanDateService.previousMonth(this.currentMonth, this.currentYear);
        this.currentMonth = date.getMonth() + 1;
        this.currentYear = date.getFullYear();
        this.generateDate();
    }
    changeYear(next = true) {
        this.currentYear = next ? this.currentYear + 1 : this.currentYear - 1;
        this.generateYears();
        this.generateDate();
    }
    selectable(day) {
        return SanDateService.inMinMax(day, this.minDate, this.maxDate);
    }
    isSelected(day) {
        return SanDateService.equal(day, this.date ?? new Date());
    }
    isOutOfMonth(date) {
        const dt = SanDateService.dateTime(date);
        return dt.month !== this.currentMonth || dt.year !== this.currentYear;
    }
    select(day) {
        if (this.selectable(day)) {
            this.date = day;
            this.dateChange.next(this.date);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDatePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanDatePickerComponent, selector: "san-date-picker", inputs: { date: "date", minDate: "minDate", maxDate: "maxDate" }, outputs: { dateChange: "dateChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"san-date-picker\">\n  <div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n    <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"space-between center\">\n      <san-icon [title]=\"'shared.calendar.previousYear' | translate\" [name]=\"IconName.DOUBLE_BACK\" size=\"lg\"\n        classes=\"text-primary\" (onclick)=\"changeYear(false)\"></san-icon>\n      <san-icon [title]=\"'shared.calendar.previousMonth' | translate\" [name]=\"IconName.PREVIOUS\"\n        (onclick)=\"changeMonth(false)\" classes=\"text-primary\"></san-icon>\n      <san-select class=\"months\" [options]=\"months\" [(ngModel)]=\"currentMonth\" [showPlaceholder]=\"false\"\n        [required]=\"true\" (ngModelChange)=\"generateDate()\"></san-select>\n      <san-select class=\"years\" [options]=\"years\" [showPlaceholder]=\"false\" [manageObject]=\"false\" [required]=\"true\"\n        (ngModelChange)=\"selectYear($event)\" [(ngModel)]=\"currentYear\"></san-select>\n      <san-icon [title]=\"'shared.calendar.nextMonth' | translate\" [name]=\"IconName.NEXT\" (onclick)=\"changeMonth()\"\n        classes=\"text-primary\"></san-icon>\n      <san-icon [title]=\"'shared.calendar.nextYear' | translate\" [name]=\"IconName.DOUBLE_NEXT\" size=\"lg\"\n        classes=\"text-primary\" (onclick)=\"changeYear()\"></san-icon>\n    </div>\n    <div fxLayout=\"row\" class=\"nameRows\" fxLayoutAlign=\"start center\">\n      <div *ngFor=\"let day of days;\" class=\"dayName\">\n        {{'shared.calendar.days.' + day + '.short' | translate}}\n      </div>\n    </div>\n    <div *ngFor=\"let week of dates;\">\n      <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n        <div class=\"day pointer\" *ngFor=\"let day of week;\" [class.today]=\"day|isToday\"\n          [class.exclude]=\"!selectable(day)\" [class.out-of-month]=\"isOutOfMonth(day)\" [class.selected]=\"isSelected(day)\"\n          (click)=\"select(day)\">\n          {{day|date:'d'}}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>", dependencies: [{ kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanSelectComponent, selector: "san-select", inputs: ["labelField", "valueField", "options", "globalErrors", "manageObject", "showPlaceholder"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: DateIsTodayPipe, name: "isToday" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-date-picker', template: "<div class=\"san-date-picker\">\n  <div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n    <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"space-between center\">\n      <san-icon [title]=\"'shared.calendar.previousYear' | translate\" [name]=\"IconName.DOUBLE_BACK\" size=\"lg\"\n        classes=\"text-primary\" (onclick)=\"changeYear(false)\"></san-icon>\n      <san-icon [title]=\"'shared.calendar.previousMonth' | translate\" [name]=\"IconName.PREVIOUS\"\n        (onclick)=\"changeMonth(false)\" classes=\"text-primary\"></san-icon>\n      <san-select class=\"months\" [options]=\"months\" [(ngModel)]=\"currentMonth\" [showPlaceholder]=\"false\"\n        [required]=\"true\" (ngModelChange)=\"generateDate()\"></san-select>\n      <san-select class=\"years\" [options]=\"years\" [showPlaceholder]=\"false\" [manageObject]=\"false\" [required]=\"true\"\n        (ngModelChange)=\"selectYear($event)\" [(ngModel)]=\"currentYear\"></san-select>\n      <san-icon [title]=\"'shared.calendar.nextMonth' | translate\" [name]=\"IconName.NEXT\" (onclick)=\"changeMonth()\"\n        classes=\"text-primary\"></san-icon>\n      <san-icon [title]=\"'shared.calendar.nextYear' | translate\" [name]=\"IconName.DOUBLE_NEXT\" size=\"lg\"\n        classes=\"text-primary\" (onclick)=\"changeYear()\"></san-icon>\n    </div>\n    <div fxLayout=\"row\" class=\"nameRows\" fxLayoutAlign=\"start center\">\n      <div *ngFor=\"let day of days;\" class=\"dayName\">\n        {{'shared.calendar.days.' + day + '.short' | translate}}\n      </div>\n    </div>\n    <div *ngFor=\"let week of dates;\">\n      <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n        <div class=\"day pointer\" *ngFor=\"let day of week;\" [class.today]=\"day|isToday\"\n          [class.exclude]=\"!selectable(day)\" [class.out-of-month]=\"isOutOfMonth(day)\" [class.selected]=\"isSelected(day)\"\n          (click)=\"select(day)\">\n          {{day|date:'d'}}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>" }]
        }], propDecorators: { date: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], dateChange: [{
                type: Output
            }] } });

class SanTimeCellComponent {
    timeSvg;
    times;
    ngOnInit() {
        if (this.timeSvg?.nativeElement) {
            const height = this.timeSvg.nativeElement.clientHeight / 24;
            this.times = ObjectUtils.generateArray(0, 24).map((h, i) => ({ y: height * i + CALENDAR_OFFSET, hour: h }));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTimeCellComponent, selector: "san-time-cell", viewQueries: [{ propertyName: "timeSvg", first: true, predicate: ["timeSvg"], descendants: true, static: true }], ngImport: i0, template: "<svg #timeSvg width=\"100%\" height=\"100%\">\n\n  <svg:text *ngFor=\"let time of times\" [attr.x]=\"0\" [attr.y]=\"time.y\">{{time.hour|number:'2.0-0'}}:00</svg:text>\n\n</svg>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-time-cell', template: "<svg #timeSvg width=\"100%\" height=\"100%\">\n\n  <svg:text *ngFor=\"let time of times\" [attr.x]=\"0\" [attr.y]=\"time.y\">{{time.hour|number:'2.0-0'}}:00</svg:text>\n\n</svg>" }]
        }], propDecorators: { timeSvg: [{
                type: ViewChild,
                args: ['timeSvg', { static: true }]
            }] } });

class SanWeekDayCellComponent {
    templateService;
    days;
    currentEvent;
    menu = [];
    addOnDblClick;
    readonly = false;
    timeCol;
    addingEvent = new EventEmitter();
    clickOnEvent = new EventEmitter();
    dbClickOnEvent = new EventEmitter();
    IconName = IconName;
    singleColWidth = null;
    constructor(templateService) {
        this.templateService = templateService;
    }
    get single() {
        this.singleColWidth = document.documentElement.clientWidth - this.timeCol.nativeElement.getBoundingClientRect().right - 10;
        return this.days.length === 1;
    }
    getDayNum(day) {
        return SanDateService.dayNumber(day);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanWeekDayCellComponent, deps: [{ token: SanTemplateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanWeekDayCellComponent, selector: "san-week-day-cell", inputs: { days: "days", currentEvent: "currentEvent", menu: "menu", addOnDblClick: "addOnDblClick", readonly: "readonly" }, outputs: { addingEvent: "addingEvent", clickOnEvent: "clickOnEvent", dbClickOnEvent: "dbClickOnEvent" }, viewQueries: [{ propertyName: "timeCol", first: true, predicate: ["timeCol"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"full-width san-week-days\">\n  <table class=\"table-week-days\">\n    <thead>\n      <th #timeCol class=\"day-time\">\n        <san-icon id=\"calendar-time-icon\" color=\"white\" [name]=\"IconName.TIME\"></san-icon>\n      </th>\n      <th [class.single-day]=\"single\" [class.many-days]=\"!single\" *ngFor=\"let day of days;\"\n        [ngStyle]=\"{'width': single ? (singleColWidth + 'px'): null }\" [title]=\"day.date|date:'dd/MM/yyyy'\">\n        {{'shared.calendar.days.' + getDayNum(day.date) + '.short' | translate}} {{day.date.getDate()}}\n      </th>\n    </thead>\n    <tbody>\n      <tr>\n        <td class=\"day-col\">\n          <san-time-cell></san-time-cell>\n        </td>\n        <td class=\"day-col\" *ngFor=\"let day of days;let last = last;trackBy:templateService.trackByFn;\">\n          <san-day-cell [day]=\"day\" [currentEvent]=\"currentEvent\" [addOnDblClick]=\"addOnDblClick\" [readonly]=\"readonly\"\n            [menu]=\"menu\" (addingEvent)=\"addingEvent.next($event)\" (clickOnEvent)=\"clickOnEvent.next($event);\"\n            (dbClickOnEvent)=\"dbClickOnEvent.next($event)\" [refreshView]=\"last\"></san-day-cell>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [":host{--day-table-width: 99.8%;--day-time-width: 40px;--day-cell-border: .5px solid var(--accent-color);--day-cell-width: calc(var(--day-table-width) - var(--day-time-width))}.san-week-days{height:700px;overflow:auto;border-bottom:var(--day-cell-border)}.table-week-days{width:var(--day-table-width);border-collapse:collapse;margin:2px;position:relative}.table-week-days th,.table-week-days td{padding:5px;border:var(--day-cell-border);border-bottom:0px}.table-week-days th{position:-webkit-sticky;position:sticky;top:0;background-color:var(--accent-color);color:var(--white-color)}.table-week-days th.day-time{width:var(--day-time-width)}.table-week-days .many-days{width:calc(var(--day-cell-width) / 7)}.table-week-days .single-day{width:var(--day-cell-width)}.table-week-days td.day-col{height:1800px}\n"], dependencies: [{ kind: "directive", type: i3$4.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: SanDayCellComponent, selector: "san-day-cell", inputs: ["day", "currentEvent", "showLines", "menu", "addOnDblClick", "readonly", "refreshView"], outputs: ["addingEvent", "clickOnEvent", "dbClickOnEvent"] }, { kind: "component", type: SanTimeCellComponent, selector: "san-time-cell" }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanWeekDayCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-week-day-cell', template: "<div class=\"full-width san-week-days\">\n  <table class=\"table-week-days\">\n    <thead>\n      <th #timeCol class=\"day-time\">\n        <san-icon id=\"calendar-time-icon\" color=\"white\" [name]=\"IconName.TIME\"></san-icon>\n      </th>\n      <th [class.single-day]=\"single\" [class.many-days]=\"!single\" *ngFor=\"let day of days;\"\n        [ngStyle]=\"{'width': single ? (singleColWidth + 'px'): null }\" [title]=\"day.date|date:'dd/MM/yyyy'\">\n        {{'shared.calendar.days.' + getDayNum(day.date) + '.short' | translate}} {{day.date.getDate()}}\n      </th>\n    </thead>\n    <tbody>\n      <tr>\n        <td class=\"day-col\">\n          <san-time-cell></san-time-cell>\n        </td>\n        <td class=\"day-col\" *ngFor=\"let day of days;let last = last;trackBy:templateService.trackByFn;\">\n          <san-day-cell [day]=\"day\" [currentEvent]=\"currentEvent\" [addOnDblClick]=\"addOnDblClick\" [readonly]=\"readonly\"\n            [menu]=\"menu\" (addingEvent)=\"addingEvent.next($event)\" (clickOnEvent)=\"clickOnEvent.next($event);\"\n            (dbClickOnEvent)=\"dbClickOnEvent.next($event)\" [refreshView]=\"last\"></san-day-cell>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>", styles: [":host{--day-table-width: 99.8%;--day-time-width: 40px;--day-cell-border: .5px solid var(--accent-color);--day-cell-width: calc(var(--day-table-width) - var(--day-time-width))}.san-week-days{height:700px;overflow:auto;border-bottom:var(--day-cell-border)}.table-week-days{width:var(--day-table-width);border-collapse:collapse;margin:2px;position:relative}.table-week-days th,.table-week-days td{padding:5px;border:var(--day-cell-border);border-bottom:0px}.table-week-days th{position:-webkit-sticky;position:sticky;top:0;background-color:var(--accent-color);color:var(--white-color)}.table-week-days th.day-time{width:var(--day-time-width)}.table-week-days .many-days{width:calc(var(--day-cell-width) / 7)}.table-week-days .single-day{width:var(--day-cell-width)}.table-week-days td.day-col{height:1800px}\n"] }]
        }], ctorParameters: () => [{ type: SanTemplateService }], propDecorators: { days: [{
                type: Input
            }], currentEvent: [{
                type: Input
            }], menu: [{
                type: Input
            }], addOnDblClick: [{
                type: Input
            }], readonly: [{
                type: Input
            }], timeCol: [{
                type: ViewChild,
                args: ['timeCol', { static: true }]
            }], addingEvent: [{
                type: Output
            }], clickOnEvent: [{
                type: Output
            }], dbClickOnEvent: [{
                type: Output
            }] } });

class SanCalendarComponent extends BaseComponent {
    calendarService;
    translationService;
    idControl = 'san-calendar';
    mode = SanCalendarMode.WEEK;
    date = new Date();
    menu = [];
    readonly = false;
    addOnDblClick = true;
    events = [];
    currentEvent;
    addingEvent = new EventEmitter();
    clickOnEvent = new EventEmitter();
    dbClickOnEvent = new EventEmitter();
    periodChange = new EventEmitter();
    calendar;
    IconName = IconName;
    SanCalendarMode = SanCalendarMode;
    days = [];
    monthDays = [];
    pickerState = false;
    pickerPosition = OVERLAY_POSITIONS;
    startDate;
    endDate;
    constructor(calendarService, translationService) {
        super();
        this.calendarService = calendarService;
        this.translationService = translationService;
    }
    ngOnChanges(changes) {
        if (changes) {
            if (changes.date) {
                this.handleSelectedDate(SanDateService.trunk(this.date));
            }
            if (changes.mode || changes.events) {
                this.display(this.mode);
            }
        }
    }
    ngOnInit() {
        this.mode = this.mode ?? SanCalendarMode.WEEK;
        this.setStartDate();
        this.setEndDate();
        this.display();
        this.calendarService.updateView.pipe(debounceTime(500), takeUntil(this.destroy), map(() => this.calendar?.nativeElement?.clientWidth), filter(width => width <= 300 && this.mode !== SanCalendarMode.DAY)).subscribe(() => this.selectMode(SanCalendarMode.DAY));
    }
    setStartDate() {
        const date = SanDateService.trunk(this.date);
        if (this.mode === SanCalendarMode.DAY) {
            this.startDate = date;
        }
        else {
            this.startDate = this.mode === SanCalendarMode.WEEK ? SanDateService.firstDateOfWeek(date) : SanDateService.firstDayOfMonth(date);
        }
    }
    setEndDate() {
        const date = SanDateService.trunk(this.date);
        this.endDate = this.mode === SanCalendarMode.WEEK ? SanDateService.lastDateOfWeek(date) : SanDateService.lastDayOfMonth(date);
    }
    get monthLabel() {
        return `${this.translationService.instant(`shared.calendar.months.${this.startDate.getMonth() + 1}.long`)} ${this.startDate.getFullYear()}`;
    }
    handleSelectedDate(date) {
        this.date = date;
        this.pickerState = false;
        this.setStartDate();
        this.setEndDate();
        this.notify();
        this.display();
    }
    selectMode(mode) {
        if (this.mode !== mode) {
            this.mode = mode;
            this.setStartDate();
            this.setEndDate();
            this.display();
        }
    }
    newEvent(date) {
        if (!this.readonly) {
            this.addingEvent.next(date ?? new Date());
        }
    }
    handleEventClick(p) {
        this.currentEvent = p;
        this.clickOnEvent.next(p);
    }
    display(mode) {
        this.mode = mode ?? this.mode;
        let days = [];
        if (this.mode === SanCalendarMode.MONTH) {
            days = SanDateService.generateMonthDates(this.date.getMonth() + 1, this.date.getFullYear());
            this.monthDays = cloneDeep(days).map(date => cloneDeep(date).map(day => ({
                date: day,
                events: cloneDeep(this.events).filter(p => SanDateService.equal(p.start, day))
            })));
        }
        else {
            days = [this.date];
            if (this.mode === SanCalendarMode.WEEK) {
                days = SanDateService.generateWeekDates(this.date);
            }
            else {
                this.startDate = this.date;
            }
            this.days = cloneDeep(days).map(date => ({
                date,
                events: cloneDeep(this.events).filter(p => SanDateService.equal(p.start, date))
            }));
        }
        this.calendarService.updateView.next(true);
    }
    backToday() {
        const date = SanDateService.trunk();
        if (!SanDateService.includes(date, this.startDate, this.endDate)) {
            this.date = date;
            this.setStartDate();
            this.setEndDate();
            this.notify();
            this.display();
        }
    }
    nextPeriod() {
        switch (this.mode) {
            case SanCalendarMode.WEEK:
                this.date = SanDateService.dateAfterDays(7, this.endDate);
                break;
            case SanCalendarMode.MONTH:
                this.date = SanDateService.dateAfterDays(1, SanDateService.lastDayOfMonth(this.endDate));
                break;
            default:
                this.date = SanDateService.dateAfterDays(1, this.date);
                break;
        }
        this.setStartDate();
        this.setEndDate();
        this.notify();
        this.display();
    }
    previousPeriod() {
        switch (this.mode) {
            case SanCalendarMode.WEEK:
                this.date = SanDateService.dateBeforeDays(7, this.endDate);
                break;
            case SanCalendarMode.MONTH:
                this.date = SanDateService.dateBeforeDays(1, SanDateService.firstDayOfMonth(this.endDate));
                break;
            default:
                this.date = SanDateService.dateBeforeDays(1, this.date);
                break;
        }
        this.setStartDate();
        this.setEndDate();
        this.notify();
        this.display();
    }
    notify() {
        this.periodChange.next({ start: this.startDate, end: this.endDate });
    }
    onWindowResize() {
        this.calendarService.updateView.next(true);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarComponent, deps: [{ token: SanCalendarService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanCalendarComponent, selector: "san-calendar", inputs: { idControl: "idControl", mode: "mode", date: "date", menu: "menu", readonly: "readonly", addOnDblClick: "addOnDblClick", events: "events", currentEvent: "currentEvent" }, outputs: { addingEvent: "addingEvent", clickOnEvent: "clickOnEvent", dbClickOnEvent: "dbClickOnEvent", periodChange: "periodChange" }, host: { listeners: { "window:resize": "onWindowResize($event)" } }, viewQueries: [{ propertyName: "calendar", first: true, predicate: ["calendar"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div #calendar fxLayout=\"column\" class=\"san-calendar full-width\" fxLayoutAlign=\"start start\">\n\n  <div class=\"full-width calendar-navigator\" fxLayout=\"row\" fxLayout.lt-sm=\"column\" fxLayoutAlign=\"start center\">\n\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n      <san-icon title=\"{{'shared.calendar.previousPeriod' | translate}}\" id=\"{{idControl}}-previousPeriod\"\n        [name]=\"IconName.ANGLE_LEFT\" color=\"accent\" size=\"lg\" (onclick)=\"previousPeriod()\"></san-icon>\n\n      <h3 class=\"text-accent\">{{mode !== SanCalendarMode.MONTH ? (startDate | date:'dd/MM/yyyy') : monthLabel }}</h3>\n      <ng-container *ngIf=\"mode === SanCalendarMode.WEEK\">\n        <h3 class=\"text-accent\">&nbsp; - {{endDate | date:'dd/MM/yyyy' }}</h3>\n      </ng-container>\n\n      <san-icon title=\"{{'shared.calendar.nextPeriod' | translate}}\" [name]=\"IconName.ANGLE_RIGHT\" color=\"accent\"\n        id=\"{{idControl}}-nextPeriod\" size=\"lg\" (onclick)=\"nextPeriod()\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.select-date' | translate}}\" cdkOverlayOrigin #datePickerBtn=\"cdkOverlayOrigin\"\n        id=\"{{idControl}}-select-date\" (onclick)=\"pickerState = !pickerState\" [name]=\"IconName.CALENDAR_MONTH\"\n        color=\"primary\" size=\"lg\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.today' | translate}}\" [name]=\"IconName.CALENDAR\" (onclick)=\"backToday()\"\n        id=\"{{idControl}}-today\" size=\"lg\" color=\"alert\"></san-icon>\n\n    </div>\n\n    <div class=\"app-spacer\"></div>\n\n    <div fxLayout=\"row\" fxLayoutAlign=\"end center\">\n\n      <san-icon *ngIf=\"!readonly\" title=\"{{'shared.calendar.add-event' | translate}}\" [name]=\"IconName.PLUS_CIRCLE\"\n        id=\"{{idControl}}-day-add\" (onclick)=\"newEvent()\" color=\"info\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.day-view' | translate}}\" [name]=\"IconName.CALENDAR_DAY\"\n        id=\"{{idControl}}-day-view\" (onclick)=\"selectMode(SanCalendarMode.DAY)\" color=\"accent\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.week-view' | translate}}\" [name]=\"IconName.CALENDAR_WEEK\"\n        id=\"{{idControl}}-week-view\" (onclick)=\"selectMode(SanCalendarMode.WEEK)\" color=\"primary\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.month-view' | translate}}\" [name]=\"IconName.CALENDAR_MONTH\"\n        id=\"{{idControl}}-month-view\" (onclick)=\"selectMode(SanCalendarMode.MONTH)\" color=\"warn\"></san-icon>\n    </div>\n  </div>\n\n  <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"start start\">\n\n    <san-week-day-cell *ngIf=\"mode !== SanCalendarMode.MONTH\" [days]=\"days\" [addOnDblClick]=\"addOnDblClick\"\n      [currentEvent]=\"currentEvent\" [readonly]=\"readonly\" [menu]=\"menu\" (addingEvent)=\"newEvent($event)\"\n      (dbClickOnEvent)=\"dbClickOnEvent.next($event)\" (clickOnEvent)=\"handleEventClick($event);\">\n    </san-week-day-cell>\n\n    <san-month-day-cell *ngIf=\"mode === SanCalendarMode.MONTH\" [days]=\"monthDays\" [addOnDblClick]=\"addOnDblClick\"\n      [readonly]=\"readonly\" [menu]=\"menu\" [monthDate]=\"startDate\" (addingEvent)=\"newEvent($event)\"\n      [currentEvent]=\"currentEvent\" (dbClickOnEvent)=\"dbClickOnEvent.next($event)\"\n      (clickOnEvent)=\"handleEventClick($event);\">\n    </san-month-day-cell>\n\n  </div>\n\n</div>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"datePickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-date-picker [date]=\"date\" (dateChange)=\"handleSelectedDate($event)\"></san-date-picker>\n</ng-template>", dependencies: [{ kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "component", type: SanDatePickerComponent, selector: "san-date-picker", inputs: ["date", "minDate", "maxDate"], outputs: ["dateChange"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$2.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: SanMonthDayCellComponent, selector: "san-month-day-cell", inputs: ["days", "monthDate", "currentEvent", "menu", "addOnDblClick", "readonly"], outputs: ["addingEvent", "clickOnEvent", "dbClickOnEvent"] }, { kind: "component", type: SanWeekDayCellComponent, selector: "san-week-day-cell", inputs: ["days", "currentEvent", "menu", "addOnDblClick", "readonly"], outputs: ["addingEvent", "clickOnEvent", "dbClickOnEvent"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-calendar', template: "<div #calendar fxLayout=\"column\" class=\"san-calendar full-width\" fxLayoutAlign=\"start start\">\n\n  <div class=\"full-width calendar-navigator\" fxLayout=\"row\" fxLayout.lt-sm=\"column\" fxLayoutAlign=\"start center\">\n\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n      <san-icon title=\"{{'shared.calendar.previousPeriod' | translate}}\" id=\"{{idControl}}-previousPeriod\"\n        [name]=\"IconName.ANGLE_LEFT\" color=\"accent\" size=\"lg\" (onclick)=\"previousPeriod()\"></san-icon>\n\n      <h3 class=\"text-accent\">{{mode !== SanCalendarMode.MONTH ? (startDate | date:'dd/MM/yyyy') : monthLabel }}</h3>\n      <ng-container *ngIf=\"mode === SanCalendarMode.WEEK\">\n        <h3 class=\"text-accent\">&nbsp; - {{endDate | date:'dd/MM/yyyy' }}</h3>\n      </ng-container>\n\n      <san-icon title=\"{{'shared.calendar.nextPeriod' | translate}}\" [name]=\"IconName.ANGLE_RIGHT\" color=\"accent\"\n        id=\"{{idControl}}-nextPeriod\" size=\"lg\" (onclick)=\"nextPeriod()\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.select-date' | translate}}\" cdkOverlayOrigin #datePickerBtn=\"cdkOverlayOrigin\"\n        id=\"{{idControl}}-select-date\" (onclick)=\"pickerState = !pickerState\" [name]=\"IconName.CALENDAR_MONTH\"\n        color=\"primary\" size=\"lg\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.today' | translate}}\" [name]=\"IconName.CALENDAR\" (onclick)=\"backToday()\"\n        id=\"{{idControl}}-today\" size=\"lg\" color=\"alert\"></san-icon>\n\n    </div>\n\n    <div class=\"app-spacer\"></div>\n\n    <div fxLayout=\"row\" fxLayoutAlign=\"end center\">\n\n      <san-icon *ngIf=\"!readonly\" title=\"{{'shared.calendar.add-event' | translate}}\" [name]=\"IconName.PLUS_CIRCLE\"\n        id=\"{{idControl}}-day-add\" (onclick)=\"newEvent()\" color=\"info\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.day-view' | translate}}\" [name]=\"IconName.CALENDAR_DAY\"\n        id=\"{{idControl}}-day-view\" (onclick)=\"selectMode(SanCalendarMode.DAY)\" color=\"accent\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.week-view' | translate}}\" [name]=\"IconName.CALENDAR_WEEK\"\n        id=\"{{idControl}}-week-view\" (onclick)=\"selectMode(SanCalendarMode.WEEK)\" color=\"primary\"></san-icon>\n\n      <san-icon title=\"{{'shared.calendar.month-view' | translate}}\" [name]=\"IconName.CALENDAR_MONTH\"\n        id=\"{{idControl}}-month-view\" (onclick)=\"selectMode(SanCalendarMode.MONTH)\" color=\"warn\"></san-icon>\n    </div>\n  </div>\n\n  <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"start start\">\n\n    <san-week-day-cell *ngIf=\"mode !== SanCalendarMode.MONTH\" [days]=\"days\" [addOnDblClick]=\"addOnDblClick\"\n      [currentEvent]=\"currentEvent\" [readonly]=\"readonly\" [menu]=\"menu\" (addingEvent)=\"newEvent($event)\"\n      (dbClickOnEvent)=\"dbClickOnEvent.next($event)\" (clickOnEvent)=\"handleEventClick($event);\">\n    </san-week-day-cell>\n\n    <san-month-day-cell *ngIf=\"mode === SanCalendarMode.MONTH\" [days]=\"monthDays\" [addOnDblClick]=\"addOnDblClick\"\n      [readonly]=\"readonly\" [menu]=\"menu\" [monthDate]=\"startDate\" (addingEvent)=\"newEvent($event)\"\n      [currentEvent]=\"currentEvent\" (dbClickOnEvent)=\"dbClickOnEvent.next($event)\"\n      (clickOnEvent)=\"handleEventClick($event);\">\n    </san-month-day-cell>\n\n  </div>\n\n</div>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"datePickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-date-picker [date]=\"date\" (dateChange)=\"handleSelectedDate($event)\"></san-date-picker>\n</ng-template>" }]
        }], ctorParameters: () => [{ type: SanCalendarService }, { type: i1.TranslateService }], propDecorators: { idControl: [{
                type: Input
            }], mode: [{
                type: Input
            }], date: [{
                type: Input
            }], menu: [{
                type: Input
            }], readonly: [{
                type: Input
            }], addOnDblClick: [{
                type: Input
            }], events: [{
                type: Input
            }], currentEvent: [{
                type: Input
            }], addingEvent: [{
                type: Output
            }], clickOnEvent: [{
                type: Output
            }], dbClickOnEvent: [{
                type: Output
            }], periodChange: [{
                type: Output
            }], calendar: [{
                type: ViewChild,
                args: ['calendar', { static: true }]
            }], onWindowResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class SanTimePickerComponent {
    date = new Date();
    showSeconds = false;
    minHour = 0;
    maxHour = 24;
    hourChange = new EventEmitter();
    currentHour = SanDateService.currentHour();
    currentMinute = SanDateService.currentMinute();
    currentSecond = SanDateService.currentSecond();
    hours = ObjectUtils.generateArray(0, 24, 1);
    units = ObjectUtils.generateArray(0, 60, 1);
    IconName = IconName;
    format = '2.0';
    ngOnChanges(changes) {
        if (changes.date) {
            this.updateTimes();
        }
    }
    updateTimes() {
        const dateTime = SanDateService.dateTime(this.date ?? new Date());
        this.currentHour = dateTime.hour;
        this.currentMinute = dateTime.minute;
        this.currentSecond = dateTime.second;
        this.date = dateTime.toJSDate();
    }
    select(value, units) {
        if (units === 'h' && this.validHour(value)) {
            this.date.setHours(value);
            this.hourChange.next({ date: this.date });
        }
        else {
            if (units === 'm') {
                this.date.setMinutes(value);
            }
            else {
                this.date.setSeconds(value);
            }
            this.hourChange.next({ date: this.date });
        }
    }
    validHour(h) {
        return SanDateService.hourInMinMax(h, this.minHour, this.maxHour);
    }
    close() {
        this.hourChange.next({ date: this.date, close: true });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTimePickerComponent, selector: "san-time-picker", inputs: { date: "date", showSeconds: "showSeconds", minHour: "minHour", maxHour: "maxHour" }, outputs: { hourChange: "hourChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"san-time-picker\">\n  <div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n    <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n      <label class=\"text-primary small-mg\">{{'shared.heures'|translate}}</label>\n      <san-icon (onclick)=\"close()\" color=\"primary\" [name]=\"IconName.CLOSE\" size=\"sm\"></san-icon>\n    </div>\n    <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n      <div class=\"small-pd pointer\" (click)=\"select(h,'h')\" [class.selected]=\"h === currentHour\"\n        [class.exclude]=\"!validHour(h)\" *ngFor=\"let h of hours;\">{{h | number:format}}\n      </div>\n    </div>\n    <label class=\"text-primary small-mg\">{{'shared.minutes'|translate}}</label>\n    <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n      <div class=\"small-pd pointer\" (click)=\"select(m,'m')\" [class.selected]=\"m === currentMinute\"\n        *ngFor=\"let m of units;\">{{m | number:format}}</div>\n    </div>\n    <ng-container *ngIf=\"showSeconds\">\n      <label class=\"text-primary small-mg\">{{'shared.secondes'|translate}}</label>\n      <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n        <div class=\"small-pd pointer\" (click)=\"select(s,'s')\" [class.selected]=\"s === currentSecond\"\n          *ngFor=\"let s of units;\">{{s | number:format}}</div>\n      </div>\n    </ng-container>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-time-picker', template: "<div class=\"san-time-picker\">\n  <div fxLayout=\"column\" fxLayoutAlign=\"start start\">\n    <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\">\n      <label class=\"text-primary small-mg\">{{'shared.heures'|translate}}</label>\n      <san-icon (onclick)=\"close()\" color=\"primary\" [name]=\"IconName.CLOSE\" size=\"sm\"></san-icon>\n    </div>\n    <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n      <div class=\"small-pd pointer\" (click)=\"select(h,'h')\" [class.selected]=\"h === currentHour\"\n        [class.exclude]=\"!validHour(h)\" *ngFor=\"let h of hours;\">{{h | number:format}}\n      </div>\n    </div>\n    <label class=\"text-primary small-mg\">{{'shared.minutes'|translate}}</label>\n    <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n      <div class=\"small-pd pointer\" (click)=\"select(m,'m')\" [class.selected]=\"m === currentMinute\"\n        *ngFor=\"let m of units;\">{{m | number:format}}</div>\n    </div>\n    <ng-container *ngIf=\"showSeconds\">\n      <label class=\"text-primary small-mg\">{{'shared.secondes'|translate}}</label>\n      <div fxLayout=\"row wrap\" class=\"full-width\" fxLayoutAlign=\"start center\">\n        <div class=\"small-pd pointer\" (click)=\"select(s,'s')\" [class.selected]=\"s === currentSecond\"\n          *ngFor=\"let s of units;\">{{s | number:format}}</div>\n      </div>\n    </ng-container>\n  </div>\n</div>" }]
        }], propDecorators: { date: [{
                type: Input
            }], showSeconds: [{
                type: Input
            }], minHour: [{
                type: Input
            }], maxHour: [{
                type: Input
            }], hourChange: [{
                type: Output
            }] } });

class SanTimePickerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerModule, declarations: [SanTimePickerComponent], imports: [CommonModule, i1.TranslateModule, SanIconModule,
            FlexLayoutModule], exports: [SanTimePickerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerModule, imports: [CommonModule,
            TranslateModule.forChild(),
            SanIconModule,
            FlexLayoutModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        SanIconModule,
                        FlexLayoutModule
                    ],
                    declarations: [
                        SanTimePickerComponent
                    ],
                    exports: [
                        SanTimePickerComponent
                    ]
                }]
        }] });

class SanSelectModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanSelectModule, declarations: [SanSelectComponent], imports: [i1.TranslateModule, SanFormErrorsModule,
            SanIconModule,
            CdkMenuModule], exports: [SanSelectComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule,
            SanIconModule,
            CdkMenuModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule,
                        SanIconModule,
                        CdkMenuModule
                    ],
                    declarations: [
                        SanSelectComponent
                    ],
                    exports: [
                        SanSelectComponent
                    ]
                }]
        }] });

class SanCustomValidators {
    static dateValidator(dateValue) {
        return (control) => {
            const date = dateValue.getValue();
            if (date?.length && !control.value) {
                return { notDateTime: { value: date } };
            }
            return null;
        };
    }
    static hoursValidator(hourValue, min, max) {
        return (control) => {
            const date = hourValue.getValue();
            const value = control?.value;
            const intervalValid = value && value?.getHours() >= min && value?.getHours() <= max;
            if (date?.length && !(value && intervalValid)) {
                return { notDateTime: { value: date } };
            }
            return null;
        };
    }
    static emailValidator() {
        return (control) => {
            if (control.value?.length && !SanValidatorService.isEmail(control.value.toString())) {
                return { email: { value: control.value } };
            }
            return null;
        };
    }
    static telValidator() {
        return (control) => {
            if (control.value?.length && !SanValidatorService.isNumber(control.value.toString())) {
                return { tel: { value: control.value } };
            }
            return null;
        };
    }
    static numberValidator() {
        return (control) => {
            if (control.value?.length && !SanValidatorService.isNumber(control.value.toString())) {
                return { notNumber: { value: control.value } };
            }
            return null;
        };
    }
    static decimalValidator() {
        return (control) => {
            const value = control.value;
            if (value?.length && !SanValidatorService.isDecimal(value)) {
                return { notDecimal: { value: control.value } };
            }
            return null;
        };
    }
    static confirmValidator(controlName, compareName, isConfirmation = true, value) {
        return (control) => {
            const ctl = control.get(controlName);
            const cmp = compareName ? control.get(compareName).value : value;
            if (ctl?.value?.toString().length && cmp?.toString().length && ctl.value !== cmp) {
                return isConfirmation ? { notSame: { value: false } } : { notEqual: { value: false } };
            }
            return null;
        };
    }
    static maxFilesValidator(maxFiles$) {
        return (control) => {
            return control.valueChanges.pipe(distinctUntilChanged(), withLatestFrom(maxFiles$), map(([files, maxFiles]) => files?.length > maxFiles ? { maxFilesError: true } : null)).pipe(first());
        };
    }
    static totalSizeFilesValidator(totalSize$) {
        return (control) => {
            return control.valueChanges.pipe(distinctUntilChanged(), withLatestFrom(totalSize$), map(([files, totalSize]) => SanFileService.totalSize(files) > totalSize ? { totalSizeFilesError: true } : null)).pipe(first());
        };
    }
    static filesValidator(fileItems$) {
        return (control) => {
            return control.valueChanges.pipe(distinctUntilChanged(), map(() => fileItems$.getValue().some(f => !!f.message?.length) ? { filesError: true } : null)).pipe(first());
        };
    }
}

class SanDateComponent extends BaseFormControl {
    injector;
    dateService;
    dateOnly = true;
    showSeconds = false;
    minDate;
    maxDate;
    minHour = 0;
    maxHour = 24;
    globalErrors;
    IconName = IconName;
    pickerState = false;
    timePickerState = false;
    pickerPosition = [
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
        { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
    ];
    dateValue = new BehaviorSubject(null);
    constructor(injector, dateService) {
        super(injector);
        this.injector = injector;
        this.dateService = dateService;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.field.addValidators(SanCustomValidators.dateValidator(this.dateValue));
    }
    writeValue(obj) {
        if (obj) {
            if (this.selectable(obj)) {
                const value = this.dateService.format(obj, this.format);
                this.dateValue.next(value);
                this.value = obj;
            }
        }
        else {
            this.value = obj;
        }
    }
    get format() {
        if (!this.dateOnly) {
            return this.showSeconds ? FormatDate.DayMonthYearHourMinSec : FormatDate.DayMonthYearHourMin;
        }
        return FormatDate.DayMonthYear;
    }
    get maxsize() {
        return this.dateService.getDateSize(this.format);
    }
    selectable(date) {
        return SanDateService.inMinMax(date, this.minDate, this.maxDate);
    }
    computeDate(event) {
        const date = event.target.value;
        const value = this.dateService.transform(date, this.format);
        if (this.selectable(value)) {
            this.value = value;
        }
        else {
            this.value = null;
        }
        this.dateValue.next(date);
        this.field.markAsTouched();
    }
    handleSelected(date) {
        this.setUnits(date, 'date');
        this.pickerState = false;
    }
    handleSelectedTime(event) {
        this.setUnits(event.date, 'hours');
        if (event?.close) {
            this.timePickerState = false;
        }
    }
    setUnits(date, unit) {
        if (this.value) {
            if (unit === 'date') {
                this.value.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
            }
            else {
                this.value.setHours(date.getHours(), date.getMinutes(), date.getSeconds());
            }
        }
        else {
            this.value = date;
        }
        this.value = cloneDeep(this.value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateComponent, deps: [{ token: i0.Injector }, { token: SanDateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanDateComponent, selector: "san-date", inputs: { dateOnly: "dateOnly", showSeconds: "showSeconds", minDate: "minDate", maxDate: "maxDate", minHour: "minHour", maxHour: "maxHour", globalErrors: "globalErrors" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanDateComponent),
                multi: true
            }
        ], usesInheritance: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-date-input control-margin {{classes}}\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n\n    <input [hidden]=\"true\" class=\"san-form-control-input icon-info\" type=\"text\" [id]=\"idControl+'value'\"\n      [name]=\"idControl+'name'\" (change)=\"onChangeValue()\" [(ngModel)]=\"value\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <input class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\" type=\"text\" #valueInput\n      [id]=\"idControl\" [name]=\"idControl\" (blur)=\"computeDate($event)\" [attr.maxlength]=\"maxsize\"\n      [value]=\"value | synDate:format\" [placeholder]=\"(('shared.dateFormat.'+format) | translate)|uppercase\"\n      [disabled]=\"readonly\" [required]=\"isRequired\" />\n\n    <san-icon *ngIf=\"canClear(valueInput.value)\" (onclick)=\"clearValue(valueInput);dateValue.next(null);\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\" button\" (click)=\"pickerState = !pickerState\" cdkOverlayOrigin #datePickerBtn=\"cdkOverlayOrigin\"\n      [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n      <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"IconName.CALENDAR_MONTH\"></san-icon>\n    </button>\n\n    <ng-container *ngIf=\"!dateOnly\">\n      &nbsp;\n      <button type=\"button\" (click)=\"timePickerState = !timePickerState\" cdkOverlayOrigin\n        #hourPickerBtn=\"cdkOverlayOrigin\" [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n        <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\" [name]=\"IconName.TIME\"></san-icon>\n      </button>\n\n      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"hourPickerBtn\"\n        [cdkConnectedOverlayHasBackdrop]=\"true\" cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n        (backdropClick)=\"timePickerState = false\" [cdkConnectedOverlayPositions]=\"pickerPosition\"\n        [cdkConnectedOverlayOpen]=\"timePickerState\">\n        <san-time-picker [date]=\"value\" [showSeconds]=\"showSeconds\" [maxHour]=\"maxHour\" [minHour]=\"minHour\"\n          (hourChange)=\"handleSelectedTime($event)\"></san-time-picker>\n      </ng-template>\n\n    </ng-container>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"datePickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-date-picker [date]=\"value\" [minDate]=\"minDate\" [maxDate]=\"maxDate\"\n    (dateChange)=\"handleSelected($event)\"></san-date-picker>\n</ng-template>", dependencies: [{ kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanTimePickerComponent, selector: "san-time-picker", inputs: ["date", "showSeconds", "minHour", "maxHour"], outputs: ["hourChange"] }, { kind: "directive", type: i1$2.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$2.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "component", type: SanDatePickerComponent, selector: "san-date-picker", inputs: ["date", "minDate", "maxDate"], outputs: ["dateChange"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: DatePipe, name: "synDate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-date', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanDateComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-date-input control-margin {{classes}}\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n\n    <input [hidden]=\"true\" class=\"san-form-control-input icon-info\" type=\"text\" [id]=\"idControl+'value'\"\n      [name]=\"idControl+'name'\" (change)=\"onChangeValue()\" [(ngModel)]=\"value\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <input class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\" type=\"text\" #valueInput\n      [id]=\"idControl\" [name]=\"idControl\" (blur)=\"computeDate($event)\" [attr.maxlength]=\"maxsize\"\n      [value]=\"value | synDate:format\" [placeholder]=\"(('shared.dateFormat.'+format) | translate)|uppercase\"\n      [disabled]=\"readonly\" [required]=\"isRequired\" />\n\n    <san-icon *ngIf=\"canClear(valueInput.value)\" (onclick)=\"clearValue(valueInput);dateValue.next(null);\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\" button\" (click)=\"pickerState = !pickerState\" cdkOverlayOrigin #datePickerBtn=\"cdkOverlayOrigin\"\n      [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n      <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"IconName.CALENDAR_MONTH\"></san-icon>\n    </button>\n\n    <ng-container *ngIf=\"!dateOnly\">\n      &nbsp;\n      <button type=\"button\" (click)=\"timePickerState = !timePickerState\" cdkOverlayOrigin\n        #hourPickerBtn=\"cdkOverlayOrigin\" [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n        <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\" [name]=\"IconName.TIME\"></san-icon>\n      </button>\n\n      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"hourPickerBtn\"\n        [cdkConnectedOverlayHasBackdrop]=\"true\" cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n        (backdropClick)=\"timePickerState = false\" [cdkConnectedOverlayPositions]=\"pickerPosition\"\n        [cdkConnectedOverlayOpen]=\"timePickerState\">\n        <san-time-picker [date]=\"value\" [showSeconds]=\"showSeconds\" [maxHour]=\"maxHour\" [minHour]=\"minHour\"\n          (hourChange)=\"handleSelectedTime($event)\"></san-time-picker>\n      </ng-template>\n\n    </ng-container>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"datePickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-date-picker [date]=\"value\" [minDate]=\"minDate\" [maxDate]=\"maxDate\"\n    (dateChange)=\"handleSelected($event)\"></san-date-picker>\n</ng-template>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: SanDateService }], propDecorators: { dateOnly: [{
                type: Input
            }], showSeconds: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], minHour: [{
                type: Input
            }], maxHour: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }] } });

class SanDateModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanDateModule, declarations: [SanDateComponent,
            SanDatePickerComponent], imports: [i1.TranslateModule, SanIconModule,
            SanFormErrorsModule,
            SanPipeModule,
            SanTimePickerModule,
            SanSelectModule,
            OverlayModule], exports: [SanDateComponent,
            SanDatePickerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateModule, imports: [TranslateModule.forChild(),
            SanIconModule,
            SanFormErrorsModule,
            SanPipeModule,
            SanTimePickerModule,
            SanSelectModule,
            OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanIconModule,
                        SanFormErrorsModule,
                        SanPipeModule,
                        SanTimePickerModule,
                        SanSelectModule,
                        OverlayModule
                    ],
                    declarations: [
                        SanDateComponent,
                        SanDatePickerComponent
                    ],
                    exports: [
                        SanDateComponent,
                        SanDatePickerComponent
                    ]
                }]
        }] });

class SanMenuModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanMenuModule, declarations: [SanMenuComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule,
            CdkMenuModule], exports: [SanMenuComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMenuModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule,
            CdkMenuModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule,
                        CdkMenuModule
                    ],
                    declarations: [
                        SanMenuComponent
                    ],
                    exports: [
                        SanMenuComponent
                    ]
                }]
        }] });

class SanSvgModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSvgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanSvgModule, declarations: [SanRectComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            CdkMenuModule,
            SanMenuModule,
            SanIconModule], exports: [SanRectComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSvgModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            CdkMenuModule,
            SanMenuModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSvgModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        CdkMenuModule,
                        SanMenuModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanRectComponent
                    ],
                    exports: [
                        SanRectComponent
                    ]
                }]
        }] });

class SanCalendarModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarModule, declarations: [SanCalendarComponent,
            SanDayCellComponent,
            SanMonthDayCellComponent,
            SanTimeCellComponent,
            SanWeekDayCellComponent], imports: [i1.TranslateModule, FlexLayoutModule,
            SanIconModule,
            SanDateModule,
            FormsModule,
            ReactiveFormsModule,
            SanPipeModule,
            SanSvgModule,
            CommonModule,
            OverlayModule], exports: [SanCalendarComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarModule, imports: [TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule,
            SanDateModule,
            FormsModule,
            ReactiveFormsModule,
            SanPipeModule,
            SanSvgModule,
            CommonModule,
            OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCalendarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule,
                        SanDateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        SanPipeModule,
                        SanSvgModule,
                        CommonModule,
                        OverlayModule
                    ],
                    declarations: [
                        SanCalendarComponent,
                        SanDayCellComponent,
                        SanMonthDayCellComponent,
                        SanTimeCellComponent,
                        SanWeekDayCellComponent
                    ],
                    exports: [
                        SanCalendarComponent
                    ]
                }]
        }] });

class SanCardComponent {
    header;
    hasFooter = true;
    width = 'auto';
    icon = IconName.FILE;
    footerAlign = 'end';
    classes = '';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanCardComponent, selector: "san-card", inputs: { header: "header", hasFooter: "hasFooter", width: "width", icon: "icon", footerAlign: "footerAlign", classes: "classes" }, ngImport: i0, template: "<div class=\"san-card {{classes}}\" [style.width]=\"width\">\n  <div *ngIf=\"header?.length\" class=\"card-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <san-icon *ngIf=\"icon\" [clickable]=\"false\" [name]=\"icon\"></san-icon> <span>{{header | translate}}</span>\n  </div>\n  <div class=\"card-body\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"card-footer\" fxLayout=\"row\" fxLayoutAlign=\"end center\">\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-card', template: "<div class=\"san-card {{classes}}\" [style.width]=\"width\">\n  <div *ngIf=\"header?.length\" class=\"card-header\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <san-icon *ngIf=\"icon\" [clickable]=\"false\" [name]=\"icon\"></san-icon> <span>{{header | translate}}</span>\n  </div>\n  <div class=\"card-body\">\n    <ng-content select=\"[content]\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"card-footer\" fxLayout=\"row\" fxLayoutAlign=\"end center\">\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>" }]
        }], propDecorators: { header: [{
                type: Input
            }], hasFooter: [{
                type: Input
            }], width: [{
                type: Input
            }], icon: [{
                type: Input
            }], footerAlign: [{
                type: Input
            }], classes: [{
                type: Input
            }] } });

class SanCardModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanCardModule, declarations: [SanCardComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule], exports: [SanCardComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCardModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanCardComponent
                    ],
                    exports: [
                        SanCardComponent
                    ]
                }]
        }] });

class SanCheckBoxComponent extends BaseFormControl {
    injector;
    indeterminate = false;
    labelPosition = 'before';
    valueChange = new EventEmitter();
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    writeValue(value) {
        this.value = value;
    }
    get labelBefore() {
        return this.label?.length && this.labelPosition === 'before';
    }
    get labelAfter() {
        return this.label?.length && this.labelPosition === 'after';
    }
    handleValue() {
        this.valueChange.next(this.value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckBoxComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanCheckBoxComponent, selector: "san-checkbox", inputs: { indeterminate: "indeterminate", labelPosition: "labelPosition" }, outputs: { valueChange: "valueChange" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanCheckBoxComponent),
                multi: true
            }
        ], usesInheritance: true, ngImport: i0, template: "<div fxLayout=\"row\" class=\"san-checkbox control-margin {{classes}}\" fxLayoutAlign=\"start center\">\n  <label class=\"check-label\" [class.label-required]=\"isRequired\" *ngIf=\"labelBefore\" [for]=\"idControl\">{{label |\n    translate}}&nbsp;</label>\n  <label class=\"checkbox-control\">\n    <input [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\" (change)=\"handleValue()\"\n      [(ngModel)]=\"value\" [indeterminate]=\"indeterminate\" [disabled]=\"readonly\" />\n    <div class=\"control_indicator\"></div>\n  </label>\n  <label class=\"check-label\" *ngIf=\"labelAfter\" [for]=\"idControl\">&nbsp;{{label | translate}}</label>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-checkbox', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanCheckBoxComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"row\" class=\"san-checkbox control-margin {{classes}}\" fxLayoutAlign=\"start center\">\n  <label class=\"check-label\" [class.label-required]=\"isRequired\" *ngIf=\"labelBefore\" [for]=\"idControl\">{{label |\n    translate}}&nbsp;</label>\n  <label class=\"checkbox-control\">\n    <input [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\" (change)=\"handleValue()\"\n      [(ngModel)]=\"value\" [indeterminate]=\"indeterminate\" [disabled]=\"readonly\" />\n    <div class=\"control_indicator\"></div>\n  </label>\n  <label class=\"check-label\" *ngIf=\"labelAfter\" [for]=\"idControl\">&nbsp;{{label | translate}}</label>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { indeterminate: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class SanCheckListComponent {
    items;
    globalSelection = false;
    labelPosition = 'after';
    idControl = 'check-list';
    selectionChange = new EventEmitter();
    selectedItemsChange = new EventEmitter();
    checkAll = false;
    blockChange = false;
    selectAll(state) {
        if (!this.blockChange) {
            this.items.forEach(it => it.checked = state);
            this.selectedItemsChange.next(state ? this.items : []);
        }
        this.blockChange = false;
    }
    select(item) {
        this.selectionChange.next(item);
        const selected = this.items.filter(it => it.checked);
        this.selectedItemsChange.next(selected);
        this.blockChange = true;
        this.checkAll = this.items.every(it => it.checked);
    }
    ngOnDestroy() {
        this.selectedItemsChange.complete();
        this.selectionChange.complete();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanCheckListComponent, selector: "san-check-list", inputs: { items: "items", globalSelection: "globalSelection", labelPosition: "labelPosition", idControl: "idControl" }, outputs: { selectionChange: "selectionChange", selectedItemsChange: "selectedItemsChange" }, ngImport: i0, template: "<div *ngIf=\"items?.length\" class=\"san-check-list\" fxLayout=\"column\" fxLayoutAlign=\"start start\">\n  <div *ngIf=\"globalSelection\">\n    <san-checkbox [idControl]=\"idControl\" [(ngModel)]=\"checkAll\" [ngModelOptions]=\"{ standalone: true }\"\n      (ngModelChange)=\"selectAll($event)\" label=\"shared.tout-selectionner\" labelPosition=\"after\"></san-checkbox>\n  </div>\n  <div class=\"basic-overflow\" fxLayout=\"column\" fxLayoutAlign=\"start start\" [class.san-ml]=\"globalSelection\">\n    <san-checkbox *ngFor=\"let item of items;\" idControl=\"check-list-item-{{item.value}}\" [(ngModel)]=\"item.checked\"\n      (ngModelChange)=\"select(item)\" [label]=\"item.label\" [labelPosition]=\"labelPosition\"></san-checkbox>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanCheckBoxComponent, selector: "san-checkbox", inputs: ["indeterminate", "labelPosition"], outputs: ["valueChange"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-check-list', template: "<div *ngIf=\"items?.length\" class=\"san-check-list\" fxLayout=\"column\" fxLayoutAlign=\"start start\">\n  <div *ngIf=\"globalSelection\">\n    <san-checkbox [idControl]=\"idControl\" [(ngModel)]=\"checkAll\" [ngModelOptions]=\"{ standalone: true }\"\n      (ngModelChange)=\"selectAll($event)\" label=\"shared.tout-selectionner\" labelPosition=\"after\"></san-checkbox>\n  </div>\n  <div class=\"basic-overflow\" fxLayout=\"column\" fxLayoutAlign=\"start start\" [class.san-ml]=\"globalSelection\">\n    <san-checkbox *ngFor=\"let item of items;\" idControl=\"check-list-item-{{item.value}}\" [(ngModel)]=\"item.checked\"\n      (ngModelChange)=\"select(item)\" [label]=\"item.label\" [labelPosition]=\"labelPosition\"></san-checkbox>\n  </div>\n</div>" }]
        }], propDecorators: { items: [{
                type: Input
            }], globalSelection: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], idControl: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }], selectedItemsChange: [{
                type: Output
            }] } });

class SanCheckboxModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanCheckboxModule, declarations: [SanCheckBoxComponent], imports: [i1.TranslateModule, SanFormErrorsModule], exports: [SanCheckBoxComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckboxModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule
                    ],
                    declarations: [
                        SanCheckBoxComponent
                    ],
                    exports: [
                        SanCheckBoxComponent
                    ]
                }]
        }] });

class SanCheckListModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListModule, declarations: [SanCheckListComponent], imports: [i1.TranslateModule, SanFormErrorsModule,
            SanCheckboxModule,
            SanIconModule], exports: [SanCheckListComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule,
            SanCheckboxModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanCheckListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule,
                        SanCheckboxModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanCheckListComponent
                    ],
                    exports: [
                        SanCheckListComponent
                    ]
                }]
        }] });

class SanModalModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanModalModule, declarations: [SanModalComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            DragDropModule], exports: [SanModalComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanModalModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            DragDropModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        DragDropModule
                    ],
                    declarations: [
                        SanModalComponent
                    ],
                    exports: [
                        SanModalComponent
                    ]
                }]
        }] });

class SanDialogModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanDialogModule, declarations: [SanDialogComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanButtonIconModule,
            SanModalModule], exports: [SanDialogComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanButtonIconModule,
            SanModalModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanButtonIconModule,
                        SanModalModule
                    ],
                    declarations: [
                        SanDialogComponent
                    ],
                    exports: [
                        SanDialogComponent
                    ]
                }]
        }] });

class FilterUtils {
    filter = { criteria: { field: null, operator: null, type: null, value: null }, condition: null, subFilters: [] };
    currentFilter = { field: null, operator: null, type: null, value: null };
    validFilter() {
        return !!(this.currentFilter?.field && this.currentFilter?.operator);
    }
    clearValue(val) {
        switch (this.currentFilter.type) {
            case SearchType.STRING:
                val = val ?? '';
                break;
            case SearchType.NUMBER:
                val = isNaN(val) ? 0 : Number(val);
                break;
            case SearchType.BOOLEEN:
                val = val ?? false;
                break;
            case SearchType.DATE:
                val = val ?? new Date();
                break;
            default:
                val = null;
                break;
        }
        return val;
    }
    stringFilter(field) {
        this.currentFilter.field = field;
        this.currentFilter.type = SearchType.STRING;
        return this;
    }
    booleenFilter(field) {
        this.currentFilter.field = field;
        this.currentFilter.type = SearchType.BOOLEEN;
        return this;
    }
    numericFilter(field) {
        this.currentFilter.field = field;
        this.currentFilter.type = SearchType.NUMBER;
        return this;
    }
    dateFilter(field) {
        this.currentFilter.field = field;
        this.currentFilter.type = SearchType.DATE;
        return this;
    }
    equal(value) {
        this.currentFilter.operator = SearchOperator.EQUAL;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    superior(value) {
        this.currentFilter.operator = SearchOperator.SUPERIOR;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    inferior(value) {
        this.currentFilter.operator = SearchOperator.INFERIOR;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    superiorEqual(value) {
        this.currentFilter.operator = SearchOperator.SUPERIOR_EQUAL;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    inferiorEqual(value) {
        this.currentFilter.operator = SearchOperator.INFERIOR_EQUAL;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    contains(value) {
        this.currentFilter.operator = SearchOperator.CONTAINS;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    startWith(value) {
        this.currentFilter.operator = SearchOperator.STARTS_WITH;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    finishWith(value) {
        this.currentFilter.operator = SearchOperator.FINISH_WITH;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    differentTo(value) {
        this.currentFilter.operator = SearchOperator.DIFFERENT;
        this.currentFilter.value = this.clearValue(value);
        return this;
    }
    includes(value) {
        this.currentFilter.operator = SearchOperator.INCLUDES;
        this.currentFilter.value = value.map(v => this.clearValue(v));
        return this;
    }
    notIncludes(value) {
        this.currentFilter.operator = SearchOperator.NOT_INCLUDES;
        this.currentFilter.value = value.map(v => this.clearValue(v));
        return this;
    }
    between(startValue, endValue) {
        this.currentFilter.operator = SearchOperator.BETWEEN;
        this.currentFilter.value = [this.clearValue(startValue), this.clearValue(endValue)];
        return this;
    }
    isNotNull() {
        this.currentFilter.operator = SearchOperator.NOT_NULL;
        return this;
    }
    isNull() {
        this.currentFilter.operator = SearchOperator.IS_NULL;
        return this;
    }
    add() {
        if (this.validFilter()) {
            this.filter.criteria = _.cloneDeep(this.currentFilter);
            this.currentFilter.field = null;
        }
        return this;
    }
    get() {
        if (this.validFilter()) {
            this.add();
        }
        return _.cloneDeep(this.filter);
    }
    static generateFilter(condition) {
        return { filters: [], condition: condition ?? SearchCondition.AND };
    }
    static generateSubFilter(condition) {
        return { subFilters: [], condition: condition ?? SearchCondition.AND, criteria: null };
    }
}

class SanEditorComponent extends BaseFormControl {
    injector;
    disabledToolbar = false;
    globalErrors;
    maxLength;
    allValues = [];
    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': this.allValues }, { 'background': this.allValues }],
            [{ 'font': this.allValues }],
            [{ 'align': this.allValues }],
            ['clean']
        ]
    };
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.maxLength) {
            this.field.addValidators(Validators.maxLength(this.maxLength));
        }
        else {
            this.field.removeValidators(Validators.maxLength(0));
        }
    }
    writeValue(obj) {
        this.value = obj ?? '';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanEditorComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanEditorComponent, selector: "san-editor", inputs: { disabledToolbar: "disabledToolbar", globalErrors: "globalErrors", maxLength: "maxLength" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanEditorComponent),
                multi: true
            }
        ], usesInheritance: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-editor\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}\n  </label>\n  <quill-editor [class.has-errors]=\"errors && field.touched\" [classes]=\"classes\" [(ngModel)]=\"value\"\n    [disabled]=\"readonly\" [trimOnValidation]=\"true\" [placeholder]=\"placeholder\" [name]=\"idControl\" (onBlur)=\"onBlur()\"\n    [maxLength]=\"maxLength\" [required]=\"isRequired\" [modules]=\"modules\"></quill-editor>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: i5.QuillEditorComponent, selector: "quill-editor" }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-editor', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanEditorComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-editor\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}\n  </label>\n  <quill-editor [class.has-errors]=\"errors && field.touched\" [classes]=\"classes\" [(ngModel)]=\"value\"\n    [disabled]=\"readonly\" [trimOnValidation]=\"true\" [placeholder]=\"placeholder\" [name]=\"idControl\" (onBlur)=\"onBlur()\"\n    [maxLength]=\"maxLength\" [required]=\"isRequired\" [modules]=\"modules\"></quill-editor>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { disabledToolbar: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], maxLength: [{
                type: Input
            }] } });

class SanEditorModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanEditorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanEditorModule, declarations: [SanEditorComponent], imports: [CommonModule, i1.TranslateModule, FormsModule,
            FlexLayoutModule,
            SanFormErrorsModule, i5.QuillModule], exports: [SanEditorComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanEditorModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FormsModule,
            FlexLayoutModule,
            SanFormErrorsModule,
            QuillModule.forRoot({
                format: 'html',
                defaultEmptyValue: '',
                sanitize: true,
                theme: 'snow',
            })] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanEditorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FormsModule,
                        FlexLayoutModule,
                        SanFormErrorsModule,
                        QuillModule.forRoot({
                            format: 'html',
                            defaultEmptyValue: '',
                            sanitize: true,
                            theme: 'snow',
                        })
                    ],
                    declarations: [
                        SanEditorComponent
                    ],
                    exports: [
                        SanEditorComponent
                    ]
                }]
        }] });

class SanFileUploadComponent extends BaseFormControl {
    injector;
    translationService;
    extensions = [];
    set maxSize(size) {
        this.maxSizeSubject.next(size ?? 1);
    }
    set maxFiles(max) {
        this.maxFilesSubject.next(max ?? 1);
    }
    set totalSize(total) {
        total = total ? total : this.calculatedTotal;
        this.totalSizeSubject.next(total);
    }
    withPreview = true;
    globalErrors;
    currentFile;
    IconName = IconName;
    files = [];
    filesSubject = new BehaviorSubject([]);
    maxSizeSubject = new BehaviorSubject(1);
    maxFilesSubject = new BehaviorSubject(1);
    totalSizeSubject = new BehaviorSubject(1);
    constructor(injector, translationService) {
        super(injector);
        this.injector = injector;
        this.translationService = translationService;
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.field?.addAsyncValidators([
            SanCustomValidators.maxFilesValidator(this.maxFilesSubject),
            SanCustomValidators.filesValidator(this.filesSubject),
            SanCustomValidators.totalSizeFilesValidator(this.totalSizeSubject)
        ]);
    }
    get calculatedTotal() {
        const total = this.maxFilesSubject.getValue() * this.maxSizeSubject.getValue();
        return total < 50 ? total : 50;
    }
    writeValue(files) {
        this.value = files;
    }
    get multiple() {
        return this.maxFilesSubject.getValue() > 1;
    }
    get accept() {
        return this.extensions?.length ? this.extensions.filter(ext => ext?.length).map(ex => `*.${ex.toLowerCase()}`).join(',') : 'image/*';
    }
    checkExtension(extension) {
        return this.extensions?.length ? this.extensions.some(ext => ext.toLowerCase() === extension) : true;
    }
    updateValue() {
        if (this.files?.length) {
            this.value = this.files.map(f => f.file);
            this.currentFile = this.files[0];
        }
        else {
            this.value = null;
            this.currentFile = null;
        }
        this.filesSubject.next(this.files);
        this.onChangeValue();
    }
    handleFiles(event) {
        const files = event.target?.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            let message = null;
            const extension = file.name.split('.').pop().toLowerCase();
            if (!this.checkExtension(extension)) { // extension KO
                message = this.translationService.instant('validation.incorrectFileFormat');
            }
            else if (SanFileService.convertSize(file.size) > this.maxSizeSubject.getValue()) { // file too lourd
                message = this.translationService.instant('validation.fileTooLourd');
            }
            this.files.push({ id: _.uniqueId('file'), file, url: URL.createObjectURL(file), message: message });
        }
        this.updateValue();
    }
    deleteFile(item) {
        this.files = this.files.filter(f => f.id !== item.id);
        this.updateValue();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.field?.clearAsyncValidators();
        this.maxFilesSubject.unsubscribe();
        this.maxSizeSubject.unsubscribe();
        this.totalSizeSubject.unsubscribe();
        this.filesSubject.unsubscribe();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadComponent, deps: [{ token: i0.Injector }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanFileUploadComponent, selector: "san-file-upload", inputs: { extensions: "extensions", maxSize: "maxSize", maxFiles: "maxFiles", totalSize: "totalSize", withPreview: "withPreview", globalErrors: "globalErrors" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanFileUploadComponent),
                multi: true
            }
        ], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-file-upload {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <input [hidden]=\"true\" #fileInput type=\"file\" name=\"files{{idControl}}\" id=\"files{{idControl}}\" [accept]=\"accept\"\n    (change)=\"handleFiles($event);\" [multiple]=\"multiple\" />\n\n  <div class=\"preview picture\" fxLayout=\"row\" fxLayoutAlign=\"center center\" *ngIf=\"withPreview\">\n    <ng-container *ngIf=\"currentFile?.url else preview\">\n      <img class=\"picture\" [src]=\"currentFile?.url | previewFile\" alt=\"{{'fichier.preview'|translate}}\" />\n    </ng-container>\n    <ng-template #preview>\n      <san-icon [clickable]=\"false\" [name]=\"IconName.FILE_IMAGE\" size=\"2xl\" color=\"accent\"></san-icon>\n    </ng-template>\n  </div>\n\n  <div *ngIf=\"files?.length\" fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"full-width files-list\">\n    <div *ngFor=\"let item of files;\" (click)=\"currentFile = item\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\"\n      class=\"fileItem small-font pointer full-width\" [class.selected]=\"currentFile?.id === item.id\">\n      <span [class.text-warn]=\"item.message?.length\">\n        <span *ngIf=\"item.message?.length\">&#9888;</span>\n        {{item.file.name}} - {{item.file.size| fileSize}}\n        <span *ngIf=\"item.message?.length\"> : {{item.message}}</span>\n      </span>\n      <san-icon (onclick)=\"deleteFile(item)\" [title]=\"'shared.supprimer'|translate\" [name]=\"IconName.CLOSE\"\n        classes=\"text-warn\">\n      </san-icon>\n    </div>\n  </div>\n\n  <san-button class=\"choose-file-btn\" color=\"primary\"\n    [label]=\"(multiple ? 'fichier.messageChoixMultiple' : 'fichier.messageChoix') | translate\"\n    (onclick)=\"fileInput.click()\">\n  </san-button>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SanButtonComponent, selector: "san-button", inputs: ["idControl", "color", "label", "disabled", "borderless", "upper", "classes"], outputs: ["onclick"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: PreviewFilePipe, name: "previewFile" }, { kind: "pipe", type: FileSizePipe, name: "fileSize" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-file-upload', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanFileUploadComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-file-upload {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <input [hidden]=\"true\" #fileInput type=\"file\" name=\"files{{idControl}}\" id=\"files{{idControl}}\" [accept]=\"accept\"\n    (change)=\"handleFiles($event);\" [multiple]=\"multiple\" />\n\n  <div class=\"preview picture\" fxLayout=\"row\" fxLayoutAlign=\"center center\" *ngIf=\"withPreview\">\n    <ng-container *ngIf=\"currentFile?.url else preview\">\n      <img class=\"picture\" [src]=\"currentFile?.url | previewFile\" alt=\"{{'fichier.preview'|translate}}\" />\n    </ng-container>\n    <ng-template #preview>\n      <san-icon [clickable]=\"false\" [name]=\"IconName.FILE_IMAGE\" size=\"2xl\" color=\"accent\"></san-icon>\n    </ng-template>\n  </div>\n\n  <div *ngIf=\"files?.length\" fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"full-width files-list\">\n    <div *ngFor=\"let item of files;\" (click)=\"currentFile = item\" fxLayout=\"row\" fxLayoutAlign=\"space-between center\"\n      class=\"fileItem small-font pointer full-width\" [class.selected]=\"currentFile?.id === item.id\">\n      <span [class.text-warn]=\"item.message?.length\">\n        <span *ngIf=\"item.message?.length\">&#9888;</span>\n        {{item.file.name}} - {{item.file.size| fileSize}}\n        <span *ngIf=\"item.message?.length\"> : {{item.message}}</span>\n      </span>\n      <san-icon (onclick)=\"deleteFile(item)\" [title]=\"'shared.supprimer'|translate\" [name]=\"IconName.CLOSE\"\n        classes=\"text-warn\">\n      </san-icon>\n    </div>\n  </div>\n\n  <san-button class=\"choose-file-btn\" color=\"primary\"\n    [label]=\"(multiple ? 'fichier.messageChoixMultiple' : 'fichier.messageChoix') | translate\"\n    (onclick)=\"fileInput.click()\">\n  </san-button>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: i1.TranslateService }], propDecorators: { extensions: [{
                type: Input
            }], maxSize: [{
                type: Input
            }], maxFiles: [{
                type: Input
            }], totalSize: [{
                type: Input
            }], withPreview: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }] } });

class SanUploadDialogComponent extends BaseDialogComponent {
    injector;
    uploadForm;
    IconName = IconName;
    content;
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.content = this.data?.content;
    }
    ngOnInit() {
        this.uploadForm = new FormGroup({
            files: new FormControl(null, Validators.required)
        });
    }
    get extensions() {
        return this.content?.extensions ?? [];
    }
    get totalSize() {
        return this.content?.totalSize ?? 1;
    }
    get maxFiles() {
        return this.content?.maxFiles ?? 1;
    }
    get maxSize() {
        return this.content?.maxSize ?? 1;
    }
    get withPreview() {
        return this.content?.withPreview ?? true;
    }
    upload() {
        if (this.content?.uploadFn && this.uploadForm.valid) {
            const files = this.uploadForm.getRawValue().files;
            this.content.uploadFn(files).pipe(take(1))
                .subscribe(response => this.close({ content: { response, files } }));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanUploadDialogComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanUploadDialogComponent, selector: "san-upload-dialog", usesInheritance: true, ngImport: i0, template: "<san-modal [header]=\"data?.header ? data.header : 'shared.chargementFichier'\" [closable]=\"closeIcon\"\n  (closeModal)=\"close()\">\n  <div class=\"dialog-content\" content>\n    <form [formGroup]=\"uploadForm\">\n      <san-file-upload formControlName=\"files\" [withPreview]=\"withPreview\" [extensions]=\"extensions\"\n        [totalSize]=\"totalSize\" [maxFiles]=\"maxFiles\" [maxSize]=\"maxSize\"></san-file-upload>\n    </form>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"end center\" footer>\n    <san-button-icon color=\"warn\" label=\"shared.annuler\" [icon]=\"IconName.CLOSE_CIRCLE\" (onclick)=\"close()\">\n    </san-button-icon>\n    <san-button-icon color=\"primary\" label=\"shared.charger\" [icon]=\"IconName.FILE_ADD\" [disabled]=\"uploadForm.invalid\"\n      (onclick)=\"upload()\">\n    </san-button-icon>\n  </div>\n</san-modal>", styles: [""], dependencies: [{ kind: "component", type: SanButtonIconComponent, selector: "san-button-icon", inputs: ["idControl", "color", "label", "icon", "disabled", "borderless", "upper", "iconSize", "classes"], outputs: ["onclick"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanModalComponent, selector: "san-modal", inputs: ["header", "hasFooter", "draggable", "closable"], outputs: ["closeModal"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: SanFileUploadComponent, selector: "san-file-upload", inputs: ["extensions", "maxSize", "maxFiles", "totalSize", "withPreview", "globalErrors"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanUploadDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-upload-dialog', template: "<san-modal [header]=\"data?.header ? data.header : 'shared.chargementFichier'\" [closable]=\"closeIcon\"\n  (closeModal)=\"close()\">\n  <div class=\"dialog-content\" content>\n    <form [formGroup]=\"uploadForm\">\n      <san-file-upload formControlName=\"files\" [withPreview]=\"withPreview\" [extensions]=\"extensions\"\n        [totalSize]=\"totalSize\" [maxFiles]=\"maxFiles\" [maxSize]=\"maxSize\"></san-file-upload>\n    </form>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"end center\" footer>\n    <san-button-icon color=\"warn\" label=\"shared.annuler\" [icon]=\"IconName.CLOSE_CIRCLE\" (onclick)=\"close()\">\n    </san-button-icon>\n    <san-button-icon color=\"primary\" label=\"shared.charger\" [icon]=\"IconName.FILE_ADD\" [disabled]=\"uploadForm.invalid\"\n      (onclick)=\"upload()\">\n    </san-button-icon>\n  </div>\n</san-modal>" }]
        }], ctorParameters: () => [{ type: i0.Injector }] });

class SanFileUploadModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadModule, declarations: [SanFileUploadComponent,
            SanUploadDialogComponent], imports: [CommonModule, i1.TranslateModule, SanButtonModule,
            SanButtonIconModule,
            FlexLayoutModule,
            SanIconModule,
            SanModalModule,
            SanFormErrorsModule,
            SanPipeModule], exports: [SanFileUploadComponent,
            SanUploadDialogComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadModule, imports: [CommonModule,
            TranslateModule.forChild(),
            SanButtonModule,
            SanButtonIconModule,
            FlexLayoutModule,
            SanIconModule,
            SanModalModule,
            SanFormErrorsModule,
            SanPipeModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        SanButtonModule,
                        SanButtonIconModule,
                        FlexLayoutModule,
                        SanIconModule,
                        SanModalModule,
                        SanFormErrorsModule,
                        SanPipeModule
                    ],
                    declarations: [
                        SanFileUploadComponent,
                        SanUploadDialogComponent
                    ],
                    exports: [
                        SanFileUploadComponent,
                        SanUploadDialogComponent
                    ]
                }]
        }] });

class SanInputComponent extends BaseFormControl {
    injector;
    pattern;
    maxLength;
    minLength;
    cols = 10;
    rows = 5;
    type = 'text';
    globalErrors;
    IconName = IconName;
    valueInput = null;
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    baseValidators() {
        switch (this.type) {
            case 'number':
                this.field?.addValidators(SanCustomValidators.numberValidator());
                break;
            case 'decimal':
                this.field?.addValidators(SanCustomValidators.decimalValidator());
                break;
            case 'tel':
                this.minLength = this.minLength ?? 10;
                this.field?.addValidators(SanCustomValidators.telValidator());
                break;
            case 'email':
                this.field?.addValidators(SanCustomValidators.emailValidator());
                break;
            default:
                break;
        }
    }
    updateControlStates() {
        if (this.field) {
            if (this.minLength) {
                this.field.addValidators(Validators.minLength(this.minLength));
            }
            else {
                this.field.removeValidators(Validators.minLength(0));
            }
            if (this.maxLength) {
                this.field.addValidators(Validators.maxLength(this.maxLength));
            }
            else {
                this.field.removeValidators(Validators.maxLength(0));
            }
            if (this.pattern) {
                this.field.addValidators(Validators.pattern(this.pattern));
            }
            else {
                this.field.removeValidators(Validators.pattern(null));
            }
        }
    }
    ngOnChanges(changes) {
        if (changes) {
            super.ngOnChanges(changes);
            this.updateControlStates();
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.baseValidators();
        this.updateControlStates();
        this.valueInput = document.getElementById(this.idControl);
    }
    writeValue(value) {
        this.value = value;
    }
    get inputType() {
        return ['number', 'tel', 'decimal'].includes(this.type) ? 'text' : this.type;
    }
    get textarea() {
        return this.type === 'textarea';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInputComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanInputComponent, selector: "san-input", inputs: { pattern: "pattern", maxLength: "maxLength", minLength: "minLength", cols: "cols", rows: "rows", type: "type", globalErrors: "globalErrors" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanInputComponent),
                multi: true
            }
        ], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-input {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n    <input *ngIf=\"!textarea\" class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\"\n      [type]=\"inputType\" [maxlength]=\"maxLength\" [id]=\"idControl\" [name]=\"idControl\" (change)=\"onChangeValue()\"\n      (keyup)=\"onKeyup()\" (blur)=\"onBlur()\" [(ngModel)]=\"value\" [placeholder]=\"placeholder\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <textarea *ngIf=\"textarea\" class=\"san-form-control-input textarea\" [rows]=\"rows\" [cols]=\"cols\"\n      [class.has-errors]=\"errors && field.touched\" [maxlength]=\"maxLength\" [id]=\"idControl\" [name]=\"idControl\"\n      (change)=\"onChangeValue()\" (keyup)=\"onKeyup()\" (blur)=\"onBlur()\" [(ngModel)]=\"value\" [placeholder]=\"placeholder\"\n      [disabled]=\"readonly\" [required]=\"isRequired\"></textarea>\n\n    <san-icon *ngIf=\"canClear(valueInput?.value) && !textarea\" (onclick)=\"clearValue(valueInput)\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" *ngIf=\"(suffix?.length || withIcon) && !textarea\" (click)=\"suffixClick()\"\n      class=\"input-suffix-btn pointer\" [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanInputComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-input {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n    <input *ngIf=\"!textarea\" class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\"\n      [type]=\"inputType\" [maxlength]=\"maxLength\" [id]=\"idControl\" [name]=\"idControl\" (change)=\"onChangeValue()\"\n      (keyup)=\"onKeyup()\" (blur)=\"onBlur()\" [(ngModel)]=\"value\" [placeholder]=\"placeholder\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <textarea *ngIf=\"textarea\" class=\"san-form-control-input textarea\" [rows]=\"rows\" [cols]=\"cols\"\n      [class.has-errors]=\"errors && field.touched\" [maxlength]=\"maxLength\" [id]=\"idControl\" [name]=\"idControl\"\n      (change)=\"onChangeValue()\" (keyup)=\"onKeyup()\" (blur)=\"onBlur()\" [(ngModel)]=\"value\" [placeholder]=\"placeholder\"\n      [disabled]=\"readonly\" [required]=\"isRequired\"></textarea>\n\n    <san-icon *ngIf=\"canClear(valueInput?.value) && !textarea\" (onclick)=\"clearValue(valueInput)\"\n      classes=\"text-accent clear-icon\" size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" *ngIf=\"(suffix?.length || withIcon) && !textarea\" (click)=\"suffixClick()\"\n      class=\"input-suffix-btn pointer\" [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { pattern: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], minLength: [{
                type: Input
            }], cols: [{
                type: Input
            }], rows: [{
                type: Input
            }], type: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }] } });

class SanInputModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanInputModule, declarations: [SanInputComponent], imports: [i1.TranslateModule, SanFormErrorsModule,
            SanIconModule], exports: [SanInputComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInputModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanInputComponent
                    ],
                    exports: [
                        SanInputComponent
                    ]
                }]
        }] });

class SanListViewComponent extends BaseComponent {
    direction = 'horizontal';
    items = [];
    customActions = [];
    IconName = IconName;
    selectItem = new EventEmitter();
    delete = new EventEmitter();
    validate = new EventEmitter();
    view = new EventEmitter();
    duplicate = new EventEmitter();
    edit = new EventEmitter();
    toggle = new EventEmitter();
    ListItemAction = ListItemAction;
    handleEvent = new Subject();
    itemMenu;
    constructor() {
        super();
        this.handleEvent.pipe(distinctUntilChanged(), takeUntil(this.destroy), debounceTime(500)).
            subscribe(({ item, type }) => this.emitAction(item, type));
    }
    get layout() {
        return this.direction === 'horizontal' ? 'row wrap' : 'column';
    }
    get align() {
        if (this.direction === 'horizontal') {
            return 'start start';
        }
        else {
            const space = 'space-around';
            return this.direction === 'vertical' ? `${space} start` : `${space} stretch`;
        }
    }
    selectedItem(item) {
        this.itemMenu.setData(item);
        this.selectItem.next(item);
    }
    toggleItem(item) {
        item.checked = !item.checked;
        this.action(item, ListItemAction.TOGGLE);
    }
    action(item, type) {
        this.handleEvent.next({ item, type });
    }
    emitAction(item, type) {
        switch (type) {
            case ListItemAction.VIEW:
                this.view.next(item);
                break;
            case ListItemAction.VALIDATE:
                this.validate.next(item);
                break;
            case ListItemAction.EDIT:
                this.edit.next(item);
                break;
            case ListItemAction.DUPLICATE:
                this.duplicate.next(item);
                break;
            case ListItemAction.TOGGLE:
                this.toggle.next(item);
                break;
            case ListItemAction.DELETE:
                this.delete.next(item);
                break;
            default:
                console.warn('Unkown action...');
                break;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanListViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanListViewComponent, selector: "san-list-view", inputs: { direction: "direction", items: "items", customActions: "customActions" }, outputs: { selectItem: "selectItem", delete: "delete", validate: "validate", view: "view", duplicate: "duplicate", edit: "edit", toggle: "toggle" }, viewQueries: [{ propertyName: "itemMenu", first: true, predicate: ["menuActions"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<ol class=\"san-list\" *ngIf=\"items?.length\" [fxLayout]=\"layout\" [fxLayoutAlign]=\"align\">\n  <ng-container *ngFor=\"let item of items;\">\n    <li *ngIf=\"!item?.hidden\" cd fxLayout=\"row\" fxLayoutGap=\"20px\" fxLayoutAlign=\"space-between center\"\n      [class.disabled]=\"item?.disabled\" [class.selected]=\"item?.selected\" (click)=\"selectedItem(item)\"\n      [ngStyle]=\"{'border-color': item?.color?.length ? item.color : null }\">\n\n      <div [innerHTML]=\"item.label | translate\"></div>\n\n      <div fxLayout=\"row\" fxLayoutAlign=\"end center\" *ngIf=\"item.actions?.length || customActions?.length\">\n\n        <ng-container *ngIf=\"item | hasItemAction:ListItemAction.TOGGLE\">\n          <san-icon [title]=\"'shared.desactiver' | translate\" *ngIf=\"item.checked\" [name]=\"IconName.TOGGLE_ON\" size=\"xl\"\n            color=\"accent\" (onclick)=\"toggleItem(item)\"></san-icon>\n\n          <san-icon [title]=\"'shared.activer' | translate\" *ngIf=\"!item.checked\" [name]=\"IconName.TOGGLE_OFF\" size=\"xl\"\n            color=\"warn\" (onclick)=\"toggleItem(item)\"></san-icon>\n        </ng-container>\n\n        <san-icon [title]=\"'shared.afficher' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.VIEW\"\n          [name]=\"IconName.EYE\" size=\"lg\" color=\"accent\" (onclick)=\"action(item,ListItemAction.VIEW)\"></san-icon>\n\n        <san-icon [title]=\"'shared.valider' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.VALIDATE\"\n          [name]=\"IconName.CHECK\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.VALIDATE)\"></san-icon>\n\n        <san-icon [title]=\"'shared.modifier' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.EDIT\"\n          [name]=\"IconName.EDIT\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.EDIT)\"></san-icon>\n\n        <san-icon [title]=\"'shared.dupliquer' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.DUPLICATE\"\n          [name]=\"IconName.COPY\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.DUPLICATE)\"></san-icon>\n\n        <san-icon [title]=\"'shared.supprimer' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.DELETE\"\n          [name]=\"IconName.CLOSE\" size=\"lg\" color=\"warn\" (onclick)=\"action(item,ListItemAction.DELETE)\"></san-icon>\n\n        <san-icon *ngIf=\"customActions?.length\" [name]=\"IconName.MENU\" (cdkMenuOpened)=\"selectedItem(item)\"\n          [cdkMenuTriggerFor]=\"menuActions.mainMenu\"></san-icon>\n\n      </div>\n    </li>\n  </ng-container>\n</ol>\n<san-menu #menuActions [menuItems]=\"customActions\"></san-menu>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i3$4.DefaultStyleDirective, selector: "  [ngStyle],  [ngStyle.xs], [ngStyle.sm], [ngStyle.md], [ngStyle.lg], [ngStyle.xl],  [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],  [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]", inputs: ["ngStyle", "ngStyle.xs", "ngStyle.sm", "ngStyle.md", "ngStyle.lg", "ngStyle.xl", "ngStyle.lt-sm", "ngStyle.lt-md", "ngStyle.lt-lg", "ngStyle.lt-xl", "ngStyle.gt-xs", "ngStyle.gt-sm", "ngStyle.gt-md", "ngStyle.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i3$3.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "component", type: SanMenuComponent, selector: "san-menu", inputs: ["menuItems", "classes"], outputs: ["triggerMenu"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: HasItemActionPipe, name: "hasItemAction" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanListViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-list-view', template: "<ol class=\"san-list\" *ngIf=\"items?.length\" [fxLayout]=\"layout\" [fxLayoutAlign]=\"align\">\n  <ng-container *ngFor=\"let item of items;\">\n    <li *ngIf=\"!item?.hidden\" cd fxLayout=\"row\" fxLayoutGap=\"20px\" fxLayoutAlign=\"space-between center\"\n      [class.disabled]=\"item?.disabled\" [class.selected]=\"item?.selected\" (click)=\"selectedItem(item)\"\n      [ngStyle]=\"{'border-color': item?.color?.length ? item.color : null }\">\n\n      <div [innerHTML]=\"item.label | translate\"></div>\n\n      <div fxLayout=\"row\" fxLayoutAlign=\"end center\" *ngIf=\"item.actions?.length || customActions?.length\">\n\n        <ng-container *ngIf=\"item | hasItemAction:ListItemAction.TOGGLE\">\n          <san-icon [title]=\"'shared.desactiver' | translate\" *ngIf=\"item.checked\" [name]=\"IconName.TOGGLE_ON\" size=\"xl\"\n            color=\"accent\" (onclick)=\"toggleItem(item)\"></san-icon>\n\n          <san-icon [title]=\"'shared.activer' | translate\" *ngIf=\"!item.checked\" [name]=\"IconName.TOGGLE_OFF\" size=\"xl\"\n            color=\"warn\" (onclick)=\"toggleItem(item)\"></san-icon>\n        </ng-container>\n\n        <san-icon [title]=\"'shared.afficher' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.VIEW\"\n          [name]=\"IconName.EYE\" size=\"lg\" color=\"accent\" (onclick)=\"action(item,ListItemAction.VIEW)\"></san-icon>\n\n        <san-icon [title]=\"'shared.valider' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.VALIDATE\"\n          [name]=\"IconName.CHECK\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.VALIDATE)\"></san-icon>\n\n        <san-icon [title]=\"'shared.modifier' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.EDIT\"\n          [name]=\"IconName.EDIT\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.EDIT)\"></san-icon>\n\n        <san-icon [title]=\"'shared.dupliquer' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.DUPLICATE\"\n          [name]=\"IconName.COPY\" size=\"lg\" color=\"primary\" (onclick)=\"action(item,ListItemAction.DUPLICATE)\"></san-icon>\n\n        <san-icon [title]=\"'shared.supprimer' | translate\" *ngIf=\"item | hasItemAction:ListItemAction.DELETE\"\n          [name]=\"IconName.CLOSE\" size=\"lg\" color=\"warn\" (onclick)=\"action(item,ListItemAction.DELETE)\"></san-icon>\n\n        <san-icon *ngIf=\"customActions?.length\" [name]=\"IconName.MENU\" (cdkMenuOpened)=\"selectedItem(item)\"\n          [cdkMenuTriggerFor]=\"menuActions.mainMenu\"></san-icon>\n\n      </div>\n    </li>\n  </ng-container>\n</ol>\n<san-menu #menuActions [menuItems]=\"customActions\"></san-menu>" }]
        }], ctorParameters: () => [], propDecorators: { direction: [{
                type: Input
            }], items: [{
                type: Input
            }], customActions: [{
                type: Input
            }], selectItem: [{
                type: Output
            }], delete: [{
                type: Output
            }], validate: [{
                type: Output
            }], view: [{
                type: Output
            }], duplicate: [{
                type: Output
            }], edit: [{
                type: Output
            }], toggle: [{
                type: Output
            }], itemMenu: [{
                type: ViewChild,
                args: ['menuActions', { static: true }]
            }] } });

class SanSlideToggleComponent extends BaseFormControl {
    injector;
    labelPosition = 'before';
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    writeValue(value) {
        this.value = value;
    }
    get labelBefore() {
        return this.label?.length && this.labelPosition === 'before';
    }
    get labelAfter() {
        return this.label?.length && this.labelPosition === 'after';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanSlideToggleComponent, selector: "san-slide-toggle", inputs: { labelPosition: "labelPosition" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanSlideToggleComponent),
                multi: true
            }
        ], usesInheritance: true, ngImport: i0, template: "<div class=\"san-slide-toggle form-margin {{classes}}\">\n  <span *ngIf=\"labelBefore\">{{label | translate}}&nbsp;</span>\n  <label class=\"toggler-wrapper pointer\" [class.disabled]=\"readonly\">\n    <input class=\"native-checkbox\" [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\"\n      [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <div class=\"toggler-slider\">\n      <div class=\"toggler-knob\"></div>\n    </div>\n  </label>\n  <span *ngIf=\"labelAfter\">&nbsp;{{label | translate}}</span>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-slide-toggle', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanSlideToggleComponent),
                            multi: true
                        }
                    ], template: "<div class=\"san-slide-toggle form-margin {{classes}}\">\n  <span *ngIf=\"labelBefore\">{{label | translate}}&nbsp;</span>\n  <label class=\"toggler-wrapper pointer\" [class.disabled]=\"readonly\">\n    <input class=\"native-checkbox\" [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\"\n      [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <div class=\"toggler-slider\">\n      <div class=\"toggler-knob\"></div>\n    </div>\n  </label>\n  <span *ngIf=\"labelAfter\">&nbsp;{{label | translate}}</span>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { labelPosition: [{
                type: Input
            }] } });

class SanSlideToggleModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleModule, declarations: [SanSlideToggleComponent], imports: [CommonModule,
            FormsModule, i1.TranslateModule, ReactiveFormsModule], exports: [SanSlideToggleComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleModule, imports: [CommonModule,
            FormsModule,
            TranslateModule.forChild(),
            ReactiveFormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSlideToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        TranslateModule.forChild(),
                        ReactiveFormsModule
                    ],
                    declarations: [
                        SanSlideToggleComponent
                    ],
                    exports: [
                        SanSlideToggleComponent
                    ]
                }]
        }] });

class SanListViewModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanListViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanListViewModule, declarations: [SanListViewComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule,
            SanSlideToggleModule,
            CdkMenuModule,
            SanMenuModule,
            SanPipeModule], exports: [SanListViewComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanListViewModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule,
            SanSlideToggleModule,
            CdkMenuModule,
            SanMenuModule,
            SanPipeModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanListViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SanListViewComponent
                    ],
                    exports: [
                        SanListViewComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule,
                        SanSlideToggleModule,
                        CdkMenuModule,
                        SanMenuModule,
                        SanPipeModule
                    ]
                }]
        }] });

class SanMultiSelectComponent extends BaseFormControl {
    injector;
    templateService;
    translateService;
    set labelField(field) {
        this.labelIndex = field?.length ? field : 'label';
    }
    set valueField(field) {
        this.valueIndex = field?.length ? field : 'value';
    }
    options = [];
    globalErrors;
    manageObject = false;
    maxLabels = 5;
    maxLabelSms = 'shared.elements-selectionnes';
    showPlaceholder = true;
    wrapper;
    selected = [];
    width;
    labelIndex = 'label';
    valueIndex = 'value';
    selectAll = false;
    constructor(injector, templateService, translateService) {
        super(injector);
        this.injector = injector;
        this.templateService = templateService;
        this.translateService = translateService;
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes.options && this.selected?.length) {
            this.selected = cloneDeep(this.options)?.filter(o => !!this.selected.find(s => o[this.valueIndex] === s[this.valueIndex]));
            this.value = this.selectedValues;
            this.onChangeValue();
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.computeMenuWidth();
    }
    writeValue(value) {
        if (this.manageObject || !this.options?.length) {
            this.selected = value;
        }
        else if (value?.length) {
            this.selected = cloneDeep(this.options)?.filter(o => value.includes(o[this.valueIndex]));
        }
        this.value = this.selectedValues;
    }
    computeMenuWidth() {
        this.width = this.wrapper.nativeElement.getBoundingClientRect().width;
    }
    get selectedLabels() {
        if (this.selected?.length > this.maxLabels) {
            return `${this.selected.length} ${this.translateService.instant(this.maxLabelSms)}`;
        }
        else {
            return this.selected?.length ? this.selected.map(s => this.translateService.instant(s[this.labelIndex])).join(', ') : '';
        }
    }
    get selectedValues() {
        return !this.manageObject && this.selected ? this.selected.map(v => v[this.valueIndex]) : this.selected;
    }
    getValue(op) {
        return !!this.selected?.find(s => s[this.valueIndex] === op[this.valueIndex]);
    }
    getFieldId(i) {
        return `ckb-mtls-${i}`;
    }
    select(option) {
        if (!this.selected) {
            this.selected = [];
        }
        const index = this.selected?.findIndex(s => s[this.valueIndex] === option[this.valueIndex]);
        if (index >= 0) {
            this.selected = cloneDeep(this.selected)?.filter(s => s[this.valueIndex] !== option[this.valueIndex]);
        }
        else {
            this.selected.push(option);
        }
        this.selectAll = this.options?.length && this.selected?.length === this.options.length;
        this.value = this.selectedValues;
        this.onChangeValue();
    }
    checkAll() {
        this.selectAll = !this.selectAll;
        this.selected = !this.selectAll ? [] : cloneDeep(this.options);
        this.value = this.selectedValues;
        this.onChangeValue();
    }
    onWinResize() {
        this.wrapper.nativeElement.click();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectComponent, deps: [{ token: i0.Injector }, { token: SanTemplateService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanMultiSelectComponent, selector: "san-multi-select", inputs: { labelField: "labelField", valueField: "valueField", options: "options", globalErrors: "globalErrors", manageObject: "manageObject", maxLabels: "maxLabels", maxLabelSms: "maxLabelSms", showPlaceholder: "showPlaceholder" }, host: { listeners: { "window:resize": "onWinResize()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanMultiSelectComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" [class.disabled]=\"readonly\" fxLayoutAlign=\"space-around start\"\n  class=\"san-select control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input class=\"san-form-control-input san-select-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\" [value]=\"selectedLabels\"\n      [placeholder]=\"this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)\"\n      [readonly]=\"true\" (blur)=\"onBlur()\" [required]=\"isRequired\" [cdkMenuTriggerFor]=\"menu\" />\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template #menu>\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" class=\"san-select-options full-width\"\n      cdkMenu>\n\n      <div fxLayout=\"row\" class=\"san-checkbox control-margin option pointer full-width\" fxLayoutAlign=\"start center\">\n        <label class=\"checkbox-control\">\n          <input [hidden]=\"true\" type=\"checkbox\" id=\"ms-cbx-all\" name=\"ms-cbx-all\" [ngModelOptions]=\"{standalone: true}\"\n            [ngModel]=\"selectAll\" (change)=\"checkAll();\" />\n          <div class=\"control_indicator\"></div>\n        </label>\n        <label class=\"check-label\" for=\"ms-cbx-all\">&nbsp;{{'shared.tout-selectionner' | translate}}</label>\n      </div>\n\n      <div *ngFor=\"let op of options;let i=index;trackBy:templateService.trackByFn\" fxLayout=\"row\"\n        class=\"san-checkbox control-margin option pointer full-width\" fxLayoutAlign=\"start center\">\n        <label class=\"checkbox-control\">\n          <input [hidden]=\"true\" type=\"checkbox\" [id]=\"getFieldId(i)\" [name]=\"getFieldId(i)\" [ngModel]=\"getValue(op)\"\n            [ngModelOptions]=\"{standalone: true}\" (change)=\"select(op)\" [disabled]=\"readonly\" />\n          <div class=\"control_indicator\"></div>\n        </label>\n        <label class=\"check-label\" [for]=\"getFieldId(i)\">&nbsp;{{op[labelIndex] | translate}}</label>\n      </div>\n\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i3$3.CdkMenu, selector: "[cdkMenu]", outputs: ["closed"], exportAs: ["cdkMenu"] }, { kind: "directive", type: i3$3.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-multi-select', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanMultiSelectComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" [class.disabled]=\"readonly\" fxLayoutAlign=\"space-around start\"\n  class=\"san-select control-margin {{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\" #wrapper>\n    <input class=\"san-form-control-input san-select-input icon-info pointer\" (click)=\"computeMenuWidth()\"\n      [class.has-errors]=\"errors && field.touched\" [id]=\"idControl\" [name]=\"idControl\" [value]=\"selectedLabels\"\n      [placeholder]=\"this.placeholder?.length ? this.placeholder : ('shared.selectionner' | translate)\"\n      [readonly]=\"true\" (blur)=\"onBlur()\" [required]=\"isRequired\" [cdkMenuTriggerFor]=\"menu\" />\n\n    <button type=\"button\" *ngIf=\"suffix?.length || withIcon\" (click)=\"suffixClick()\" class=\"input-suffix-btn pointer\"\n      [class.info-text]=\"!withIcon\" role=\"button\">\n      <ng-container *ngIf=\"!withIcon\">{{suffix}}</ng-container>\n      <san-icon [title]=\"suffix ?? ''\" *ngIf=\"withIcon\" classes=\"text-white suffix-icon\" size=\"lg\"\n        [name]=\"icon\"></san-icon>\n    </button>\n  </div>\n  <ng-template #menu>\n    <div fxLayout=\"column\" [style.width.px]=\"width\" fxLayoutAlign=\"start start\" class=\"san-select-options full-width\"\n      cdkMenu>\n\n      <div fxLayout=\"row\" class=\"san-checkbox control-margin option pointer full-width\" fxLayoutAlign=\"start center\">\n        <label class=\"checkbox-control\">\n          <input [hidden]=\"true\" type=\"checkbox\" id=\"ms-cbx-all\" name=\"ms-cbx-all\" [ngModelOptions]=\"{standalone: true}\"\n            [ngModel]=\"selectAll\" (change)=\"checkAll();\" />\n          <div class=\"control_indicator\"></div>\n        </label>\n        <label class=\"check-label\" for=\"ms-cbx-all\">&nbsp;{{'shared.tout-selectionner' | translate}}</label>\n      </div>\n\n      <div *ngFor=\"let op of options;let i=index;trackBy:templateService.trackByFn\" fxLayout=\"row\"\n        class=\"san-checkbox control-margin option pointer full-width\" fxLayoutAlign=\"start center\">\n        <label class=\"checkbox-control\">\n          <input [hidden]=\"true\" type=\"checkbox\" [id]=\"getFieldId(i)\" [name]=\"getFieldId(i)\" [ngModel]=\"getValue(op)\"\n            [ngModelOptions]=\"{standalone: true}\" (change)=\"select(op)\" [disabled]=\"readonly\" />\n          <div class=\"control_indicator\"></div>\n        </label>\n        <label class=\"check-label\" [for]=\"getFieldId(i)\">&nbsp;{{op[labelIndex] | translate}}</label>\n      </div>\n\n    </div>\n  </ng-template>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: SanTemplateService }, { type: i1.TranslateService }], propDecorators: { labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], options: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], manageObject: [{
                type: Input
            }], maxLabels: [{
                type: Input
            }], maxLabelSms: [{
                type: Input
            }], showPlaceholder: [{
                type: Input
            }], wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class SanMultiSelectModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectModule, declarations: [SanMultiSelectComponent], imports: [i1.TranslateModule, SanFormErrorsModule,
            SanCheckboxModule,
            SanIconModule,
            CdkMenuModule], exports: [SanMultiSelectComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule,
            SanCheckboxModule,
            SanIconModule,
            CdkMenuModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanMultiSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule,
                        SanCheckboxModule,
                        SanIconModule,
                        CdkMenuModule
                    ],
                    declarations: [
                        SanMultiSelectComponent
                    ],
                    exports: [
                        SanMultiSelectComponent
                    ]
                }]
        }] });

class SanPaginationComponent extends BaseComponent {
    page = new Page();
    nbItems;
    classes = '';
    pageChange = new EventEmitter();
    changePipeline = new Subject();
    IconName = IconName;
    sizeOptions = Object.values(PageSize)
        .filter(size => typeof size === 'number')
        .map(n => ({ value: +n, label: n.toString() }));
    firstChange = true;
    constructor() {
        super();
    }
    ngOnChanges(changes) {
        if (changes) {
            if (changes['nbItems']) {
                this.page.currentPage = 1;
                this.page.nbRows = this.nbItems ?? 0;
                this.page.nbPage = Math.ceil(this.page.nbRows / this.page.pageSize);
                if (this.nbItems === 0) {
                    this.firstChange = true;
                }
            }
        }
    }
    ngOnInit() {
        this.changePipeline.pipe(debounceTime(500), takeUntil(this.destroy)).subscribe(page => this.pageChange.next(Page.build(page)));
    }
    get minSize() {
        return Math.min(...(this.sizeOptions ?? []).map(s => s.value));
    }
    sizeChange(size) {
        if (!this.firstChange && size) {
            this.page.pageSize = size;
            this.page.currentPage = 1;
            this.page.nbPage = Math.ceil((this.page.nbRows ?? 0) / this.page.pageSize);
            this.changePipeline.next(this.page);
        }
        this.firstChange = false;
    }
    firstPage() {
        this.page.currentPage = 1;
        this.changePipeline.next(this.page);
    }
    previousPage() {
        this.page.currentPage--;
        this.changePipeline.next(this.page);
    }
    nextPage() {
        this.page.currentPage++;
        this.changePipeline.next(this.page);
    }
    lastPage() {
        this.page.currentPage = this.page.nbPage ?? 1;
        this.changePipeline.next(this.page);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.changePipeline.complete();
        this.pageChange.complete();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanPaginationComponent, selector: "san-pagination", inputs: { nbItems: "nbItems", classes: "classes" }, outputs: { pageChange: "pageChange" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"san-pagination {{classes}}\" *ngIf=\"nbItems > minSize\" fxLayout=\"row\" fxLayoutAlign=\"center center\">\n  <div style=\"width: 65px;\">\n    <san-select id=\"pagination-size\" [required]=\"true\" [showPlaceholder]=\"false\" [(ngModel)]=\"page.pageSize\"\n      [options]=\"sizeOptions\" (ngModelChange)=\"sizeChange($event)\">\n    </san-select>\n  </div>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.premier' | translate\" [disabled]=\"page.currentPage === 1\"\n    [name]=\"IconName.FIRST\" (onclick)=\"firstPage()\"></san-icon>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.precedent' | translate\"\n    [disabled]=\"page.currentPage === 1\" [name]=\"IconName.PREVIOUS\" (onclick)=\"previousPage()\"></san-icon>\n  <div class=\"small-font\">\n    p. {{page.currentPage}} / {{page.nbPage}}\n    ({{page.nbRows + ' ' + ('shared.pagination.elements'|translate)}})\n  </div>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.suivant' | translate\"\n    [disabled]=\"page.currentPage === page.nbPage\" [name]=\"IconName.NEXT\" (onclick)=\"nextPage()\"></san-icon>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.dernier' | translate\"\n    [disabled]=\"page.currentPage === page.nbPage\" [name]=\"IconName.LAST\" (onclick)=\"lastPage()\"></san-icon>\n</div>", styles: [".san-pagination{font-size:var(--font-size)-1}.san-pagination san-select{width:42px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "component", type: SanSelectComponent, selector: "san-select", inputs: ["labelField", "valueField", "options", "globalErrors", "manageObject", "showPlaceholder"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-pagination', template: "<div class=\"san-pagination {{classes}}\" *ngIf=\"nbItems > minSize\" fxLayout=\"row\" fxLayoutAlign=\"center center\">\n  <div style=\"width: 65px;\">\n    <san-select id=\"pagination-size\" [required]=\"true\" [showPlaceholder]=\"false\" [(ngModel)]=\"page.pageSize\"\n      [options]=\"sizeOptions\" (ngModelChange)=\"sizeChange($event)\">\n    </san-select>\n  </div>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.premier' | translate\" [disabled]=\"page.currentPage === 1\"\n    [name]=\"IconName.FIRST\" (onclick)=\"firstPage()\"></san-icon>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.precedent' | translate\"\n    [disabled]=\"page.currentPage === 1\" [name]=\"IconName.PREVIOUS\" (onclick)=\"previousPage()\"></san-icon>\n  <div class=\"small-font\">\n    p. {{page.currentPage}} / {{page.nbPage}}\n    ({{page.nbRows + ' ' + ('shared.pagination.elements'|translate)}})\n  </div>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.suivant' | translate\"\n    [disabled]=\"page.currentPage === page.nbPage\" [name]=\"IconName.NEXT\" (onclick)=\"nextPage()\"></san-icon>\n  <san-icon classes=\"text-primary\" [title]=\"'shared.pagination.dernier' | translate\"\n    [disabled]=\"page.currentPage === page.nbPage\" [name]=\"IconName.LAST\" (onclick)=\"lastPage()\"></san-icon>\n</div>", styles: [".san-pagination{font-size:var(--font-size)-1}.san-pagination san-select{width:42px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { nbItems: [{
                type: Input
            }], classes: [{
                type: Input
            }], pageChange: [{
                type: Output
            }] } });

class SanPaginationModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationModule, declarations: [SanPaginationComponent], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule,
            SanSelectModule,
            ReactiveFormsModule,
            FormsModule], exports: [SanPaginationComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule,
            SanSelectModule,
            ReactiveFormsModule,
            FormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule,
                        SanSelectModule,
                        ReactiveFormsModule,
                        FormsModule
                    ],
                    declarations: [
                        SanPaginationComponent
                    ],
                    exports: [
                        SanPaginationComponent
                    ]
                }]
        }] });

class SanRadioButtonComponent extends BaseFormControl {
    injector;
    options = [];
    direction = 'vertical';
    set labelField(field) {
        this.labelIndex = field?.length ? field : 'label';
    }
    set valueField(field) {
        this.valueIndex = field?.length ? field : 'value';
    }
    globalErrors;
    manageObject = false;
    selected;
    labelIndex = 'label';
    valueIndex = 'value';
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    ngOnChanges(changes) {
        if (changes) {
            super.ngOnChanges(changes);
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    writeValue(value) {
        this.selected = !this.manageObject ? this.options?.find(o => o[this.valueIndex] === value) : value;
        this.value = this.selectedValue;
    }
    get selectedLabel() {
        return this.selected && this.selected[this.valueIndex] ? this.selected[this.labelIndex] : '';
    }
    get selectedValue() {
        return !this.manageObject && this.selected ? this.selected[this.valueIndex] : this.selected;
    }
    get isVertical() {
        return this.direction === 'vertical';
    }
    get flexDirection() {
        return this.isVertical ? 'column' : 'row';
    }
    get flexAlign() {
        return this.isVertical ? 'space-around start' : 'space-between center';
    }
    isChecked(option) {
        return this.selected && this.selected[this.valueIndex] === option[this.valueIndex];
    }
    select(option) {
        this.selected = option;
        this.value = this.selectedValue;
        this.onChangeValue();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanRadioButtonComponent, selector: "san-radio-button", inputs: { options: "options", direction: "direction", labelField: "labelField", valueField: "valueField", globalErrors: "globalErrors", manageObject: "manageObject" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanRadioButtonComponent),
                multi: true
            }
        ], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"{{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div *ngIf=\"options?.length\" [fxLayout]=\"flexDirection\" [fxLayoutAlign]=\"flexAlign\"\n    class=\"full-width san-radio {{classes}}\" (mouseleave)=\"onBlur()\" [class.disabled]=\"readonly\">\n    <input [hidden]=\"true\" [id]=\"idControl\" [name]=\"idControl\" [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <div *ngFor=\"let op of options\" class=\"san-radio-option\" (click)=\"select(op)\">\n      <input [hidden]=\"true\" [id]=\"idControl+op[valueIndex]\" type=\"radio\" [name]=\"idControl\"\n        [checked]=\"isChecked(op)\" />\n      <span>{{op[labelIndex] | translate}}</span>\n    </div>\n    <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n    </san-form-errors>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-radio-button', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanRadioButtonComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"{{classes}}\">\n\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n\n  <div *ngIf=\"options?.length\" [fxLayout]=\"flexDirection\" [fxLayoutAlign]=\"flexAlign\"\n    class=\"full-width san-radio {{classes}}\" (mouseleave)=\"onBlur()\" [class.disabled]=\"readonly\">\n    <input [hidden]=\"true\" [id]=\"idControl\" [name]=\"idControl\" [(ngModel)]=\"value\" [disabled]=\"readonly\" />\n    <div *ngFor=\"let op of options\" class=\"san-radio-option\" (click)=\"select(op)\">\n      <input [hidden]=\"true\" [id]=\"idControl+op[valueIndex]\" type=\"radio\" [name]=\"idControl\"\n        [checked]=\"isChecked(op)\" />\n      <span>{{op[labelIndex] | translate}}</span>\n    </div>\n    <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n    </san-form-errors>\n  </div>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { options: [{
                type: Input
            }], direction: [{
                type: Input
            }], labelField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }], manageObject: [{
                type: Input
            }] } });

class SanRadioButtonModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonModule, declarations: [SanRadioButtonComponent], imports: [i1.TranslateModule, SanFormErrorsModule], exports: [SanRadioButtonComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonModule, imports: [TranslateModule.forChild(),
            SanFormErrorsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanRadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanFormErrorsModule
                    ],
                    declarations: [
                        SanRadioButtonComponent
                    ],
                    exports: [
                        SanRadioButtonComponent
                    ]
                }]
        }] });

class SanSelectionComponent {
    static nextID = 0;
    label;
    value = false;
    indeterminate = false;
    readonly = false;
    classes = '';
    labelPosition = 'before';
    idControl = `san-selection-${SanSelectionComponent.nextID++}`;
    valueChange = new EventEmitter();
    get labelBefore() {
        return this.label?.length && this.labelPosition === 'before';
    }
    get labelAfter() {
        return this.label?.length && this.labelPosition === 'after';
    }
    changeValue() {
        this.value = !this.value;
        this.valueChange.next(this.value);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanSelectionComponent, selector: "san-selection", inputs: { label: "label", value: "value", indeterminate: "indeterminate", readonly: "readonly", classes: "classes", labelPosition: "labelPosition", idControl: "idControl" }, outputs: { valueChange: "valueChange" }, ngImport: i0, template: "<div fxLayout=\"row\" class=\"san-selection control-margin {{classes}}\" fxLayoutAlign=\"start center\">\n  <label *ngIf=\"labelBefore\" [for]=\"idControl\">{{label | translate}}&nbsp;</label>\n  <label class=\"selection-control\">\n    <input [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\" [checked]=\"value\" [disabled]=\"readonly\"\n      [indeterminate]=\"indeterminate\" (change)=\"changeValue()\" />\n    <div class=\"control_indicator\"></div>\n  </label>\n  <label *ngIf=\"labelAfter\" [for]=\"idControl\">&nbsp;{{label | translate}}</label>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-selection', template: "<div fxLayout=\"row\" class=\"san-selection control-margin {{classes}}\" fxLayoutAlign=\"start center\">\n  <label *ngIf=\"labelBefore\" [for]=\"idControl\">{{label | translate}}&nbsp;</label>\n  <label class=\"selection-control\">\n    <input [hidden]=\"true\" type=\"checkbox\" [id]=\"idControl\" [name]=\"idControl\" [checked]=\"value\" [disabled]=\"readonly\"\n      [indeterminate]=\"indeterminate\" (change)=\"changeValue()\" />\n    <div class=\"control_indicator\"></div>\n  </label>\n  <label *ngIf=\"labelAfter\" [for]=\"idControl\">&nbsp;{{label | translate}}</label>\n</div>" }]
        }], propDecorators: { label: [{
                type: Input
            }], value: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], readonly: [{
                type: Input
            }], classes: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }], idControl: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class SanSelectionModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionModule, declarations: [SanSelectionComponent], imports: [CommonModule,
            FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule, i1.TranslateModule], exports: [SanSelectionComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionModule, imports: [CommonModule,
            FormsModule,
            FlexLayoutModule,
            ReactiveFormsModule,
            TranslateModule.forChild()] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanSelectionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        FlexLayoutModule,
                        ReactiveFormsModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [
                        SanSelectionComponent
                    ],
                    exports: [
                        SanSelectionComponent
                    ]
                }]
        }] });

class SanTimeComponent extends BaseFormControl {
    injector;
    dateService;
    showSeconds = false;
    minHour = 0;
    maxHour = 24;
    globalErrors;
    IconName = IconName;
    pickerState = false;
    pickerPosition = [
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
        { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
    ];
    hourValue = new BehaviorSubject(null);
    constructor(injector, dateService) {
        super(injector);
        this.injector = injector;
        this.dateService = dateService;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.field.addValidators(SanCustomValidators.hoursValidator(this.hourValue, this.minHour, this.maxHour));
    }
    writeValue(obj) {
        if (obj) {
            const value = this.dateService.format(obj, this.format);
            this.hourValue.next(value);
        }
        this.value = obj;
    }
    get format() {
        return this.showSeconds ? FormatDate.HourMinSec : FormatDate.HourMin;
    }
    get maxsize() {
        return this.dateService.getDateSize(this.format);
    }
    computeHour(event) {
        const hour = event.target.value;
        const parts = hour?.split(':');
        if (parts?.length > 1) {
            this.value = this.dateService.transform(hour, this.format);
        }
        else {
            this.value = null;
        }
        this.hourValue.next(hour);
        this.field.markAsTouched();
    }
    handleSelected(event) {
        this.value = event.date;
        if (event?.close) {
            this.pickerState = false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeComponent, deps: [{ token: i0.Injector }, { token: SanDateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTimeComponent, selector: "san-time", inputs: { showSeconds: "showSeconds", minHour: "minHour", maxHour: "maxHour", globalErrors: "globalErrors" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SanTimeComponent),
                multi: true
            }
        ], usesInheritance: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-time-input control-margin {{classes}}\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n\n    <input [hidden]=\"true\" class=\"san-form-control-input icon-info\" type=\"text\" [id]=\"idControl+'value'\"\n      [name]=\"idControl+'name'\" (change)=\"onChangeValue()\" [(ngModel)]=\"value\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <input #valueInput class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\" type=\"text\"\n      [id]=\"idControl\" [name]=\"idControl\" (blur)=\"computeHour($event)\" [attr.maxlength]=\"maxsize\"\n      [value]=\"value | synDate:format\" [placeholder]=\"(('shared.dateFormat.'+format) | translate)|uppercase\"\n      [disabled]=\"readonly\" [required]=\"isRequired\" />\n\n    <san-icon *ngIf=\"canClear(valueInput?.value)\" (onclick)=\"clearValue(valueInput)\" classes=\"text-accent clear-icon\"\n      size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" (click)=\"pickerState = !pickerState\" cdkOverlayOrigin #hourPickerBtn=\"cdkOverlayOrigin\"\n      [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n      <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\" [name]=\"IconName.TIME\"></san-icon>\n    </button>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"hourPickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-time-picker [date]=\"value\" [showSeconds]=\"showSeconds\" [maxHour]=\"maxHour\" [minHour]=\"minHour\"\n    (hourChange)=\"handleSelected($event)\"></san-time-picker>\n</ng-template>", dependencies: [{ kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanFormErrorsComponent, selector: "san-form-errors", inputs: ["field", "messageGroupKey", "globalErrors"] }, { kind: "component", type: SanTimePickerComponent, selector: "san-time-picker", inputs: ["date", "showSeconds", "minHour", "maxHour"], outputs: ["hourChange"] }, { kind: "directive", type: i1$2.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$2.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: DatePipe, name: "synDate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-time', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SanTimeComponent),
                            multi: true
                        }
                    ], template: "<div fxLayout=\"column\" fxLayoutAlign=\"space-around start\" class=\"san-time-input control-margin {{classes}}\">\n  <label class=\"form-label\" [class.label-required]=\"isRequired\" *ngIf=\"label?.length\" [for]=\"idControl\">\n    {{label | translate}}</label>\n  <div fxLayout=\"row\" class=\"full-width\" fxLayoutAlign=\"start center\">\n\n    <input [hidden]=\"true\" class=\"san-form-control-input icon-info\" type=\"text\" [id]=\"idControl+'value'\"\n      [name]=\"idControl+'name'\" (change)=\"onChangeValue()\" [(ngModel)]=\"value\" [disabled]=\"readonly\"\n      [required]=\"isRequired\" />\n\n    <input #valueInput class=\"san-form-control-input icon-info\" [class.has-errors]=\"errors && field.touched\" type=\"text\"\n      [id]=\"idControl\" [name]=\"idControl\" (blur)=\"computeHour($event)\" [attr.maxlength]=\"maxsize\"\n      [value]=\"value | synDate:format\" [placeholder]=\"(('shared.dateFormat.'+format) | translate)|uppercase\"\n      [disabled]=\"readonly\" [required]=\"isRequired\" />\n\n    <san-icon *ngIf=\"canClear(valueInput?.value)\" (onclick)=\"clearValue(valueInput)\" classes=\"text-accent clear-icon\"\n      size=\"sm\" [name]=\"IconName.CLOSE\"></san-icon>\n\n    <button type=\"button\" (click)=\"pickerState = !pickerState\" cdkOverlayOrigin #hourPickerBtn=\"cdkOverlayOrigin\"\n      [disabled]=\"readonly\" class=\"input-suffix-btn pointer\" role=\"button\">\n      <san-icon [disabled]=\"readonly\" classes=\"text-white suffix-icon\" size=\"lg\" [name]=\"IconName.TIME\"></san-icon>\n    </button>\n  </div>\n  <san-form-errors [field]=\"field\" [messageGroupKey]=\"messageGroupKey\" [globalErrors]=\"globalErrors\">\n  </san-form-errors>\n</div>\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"hourPickerBtn\" [cdkConnectedOverlayHasBackdrop]=\"true\"\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" (backdropClick)=\"pickerState = false\"\n  [cdkConnectedOverlayPositions]=\"pickerPosition\" [cdkConnectedOverlayOpen]=\"pickerState\">\n  <san-time-picker [date]=\"value\" [showSeconds]=\"showSeconds\" [maxHour]=\"maxHour\" [minHour]=\"minHour\"\n    (hourChange)=\"handleSelected($event)\"></san-time-picker>\n</ng-template>" }]
        }], ctorParameters: () => [{ type: i0.Injector }, { type: SanDateService }], propDecorators: { showSeconds: [{
                type: Input
            }], minHour: [{
                type: Input
            }], maxHour: [{
                type: Input
            }], globalErrors: [{
                type: Input
            }] } });

class SanTimeModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanTimeModule, declarations: [SanTimeComponent], imports: [i1.TranslateModule, SanIconModule,
            SanFormErrorsModule,
            SanPipeModule,
            SanTimePickerModule,
            OverlayModule], exports: [SanTimeComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeModule, imports: [TranslateModule.forChild(),
            SanIconModule,
            SanFormErrorsModule,
            SanPipeModule,
            SanTimePickerModule,
            OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTimeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        TranslateModule.forChild(),
                        SanIconModule,
                        SanFormErrorsModule,
                        SanPipeModule,
                        SanTimePickerModule,
                        OverlayModule
                    ],
                    declarations: [
                        SanTimeComponent
                    ],
                    exports: [
                        SanTimeComponent
                    ]
                }]
        }] });

class SanFormsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanFormsModule, imports: [CommonModule, i1.TranslateModule, FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanInputModule,
            SanButtonIconModule,
            SanButtonModule,
            SanCheckboxModule,
            SanDateModule,
            SanTimeModule,
            SanTimePickerModule,
            SanFormErrorsModule,
            SanRadioButtonModule,
            SanSelectModule,
            SanMultiSelectModule,
            SanButtonToggleModule,
            SanSelectionModule,
            SanSlideToggleModule,
            SanAutocompleteModule,
            SanEditorModule,
            SanCheckListModule], exports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanInputModule,
            SanButtonIconModule,
            SanButtonModule,
            SanCheckboxModule,
            SanDateModule,
            SanTimeModule,
            SanTimePickerModule,
            SanFormErrorsModule,
            SanRadioButtonModule,
            SanSelectModule,
            SanMultiSelectModule,
            SanButtonToggleModule,
            SanSelectionModule,
            SanSlideToggleModule,
            SanAutocompleteModule,
            SanEditorModule,
            SanCheckListModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormsModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanInputModule,
            SanButtonIconModule,
            SanButtonModule,
            SanCheckboxModule,
            SanDateModule,
            SanTimeModule,
            SanTimePickerModule,
            SanFormErrorsModule,
            SanRadioButtonModule,
            SanSelectModule,
            SanMultiSelectModule,
            SanButtonToggleModule,
            SanSelectionModule,
            SanSlideToggleModule,
            SanAutocompleteModule,
            SanEditorModule,
            SanCheckListModule, CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FlexLayoutModule,
            SanIconModule,
            SanInputModule,
            SanButtonIconModule,
            SanButtonModule,
            SanCheckboxModule,
            SanDateModule,
            SanTimeModule,
            SanTimePickerModule,
            SanFormErrorsModule,
            SanRadioButtonModule,
            SanSelectModule,
            SanMultiSelectModule,
            SanButtonToggleModule,
            SanSelectionModule,
            SanSlideToggleModule,
            SanAutocompleteModule,
            SanEditorModule,
            SanCheckListModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanFormsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FormsModule,
                        ReactiveFormsModule,
                        FlexLayoutModule,
                        SanIconModule,
                        SanInputModule,
                        SanButtonIconModule,
                        SanButtonModule,
                        SanCheckboxModule,
                        SanDateModule,
                        SanTimeModule,
                        SanTimePickerModule,
                        SanFormErrorsModule,
                        SanRadioButtonModule,
                        SanSelectModule,
                        SanMultiSelectModule,
                        SanButtonToggleModule,
                        SanSelectionModule,
                        SanSlideToggleModule,
                        SanAutocompleteModule,
                        SanEditorModule,
                        SanCheckListModule
                    ],
                    exports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FlexLayoutModule,
                        SanIconModule,
                        SanInputModule,
                        SanButtonIconModule,
                        SanButtonModule,
                        SanCheckboxModule,
                        SanDateModule,
                        SanTimeModule,
                        SanTimePickerModule,
                        SanFormErrorsModule,
                        SanRadioButtonModule,
                        SanSelectModule,
                        SanMultiSelectModule,
                        SanButtonToggleModule,
                        SanSelectionModule,
                        SanSlideToggleModule,
                        SanAutocompleteModule,
                        SanEditorModule,
                        SanCheckListModule
                    ],
                    providers: []
                }]
        }] });

class SanTableComponent extends BaseComponent {
    set data(data) {
        this.rows = data ?? [];
    }
    loading;
    showTitle = true;
    inlineSearch = true;
    internalSort = false;
    columns = [];
    nbItems;
    options;
    selectedRow;
    traductionGroup;
    globalMenu = [];
    rowCustomMenus = [];
    pageChange = new EventEmitter();
    rowClick = new EventEmitter();
    rowDblClick = new EventEmitter();
    eventAdd = new EventEmitter();
    eventDelete = new EventEmitter();
    eventEdit = new EventEmitter();
    eventDuplicate = new EventEmitter();
    searching = new EventEmitter();
    exporting = new EventEmitter();
    columnClick = new EventEmitter();
    sortByChange = new EventEmitter();
    selectedRows = new EventEmitter();
    rowMenu;
    taping = new Subject();
    selecting = new Subject();
    exportMenu = [];
    menu = [];
    term;
    dataColumns;
    ColumnType = ColumnType;
    initialization = true;
    showMenu = false;
    sortBy;
    rows;
    SortDirection = SortDirection;
    allChecked = false;
    IconName = IconName;
    constructor() {
        super();
    }
    ngOnChanges(changes) {
        if (changes) {
            if (changes['options'] || changes['menu'] || changes['rowCustomMenus']) {
                this.updateMenus();
            }
            if (changes['columns']) {
                this.updateColumns();
            }
        }
    }
    updateMenus() {
        this.showMenu = !!(this.options?.editMenu || this.rowCustomMenus?.length || this.options?.deleteMenu || this.options?.duplicateMenu || this.globalMenu?.length || this.options?.showCheckboxes);
        this.menu = [];
        if (this.showMenu) {
            if (this.options?.duplicateMenu) {
                this.menu.push({
                    id: this.menu.length,
                    label: 'shared.dupliquer',
                    visible: true,
                    click: () => this.newElement(this.selectedRow)
                });
            }
            if (this.options?.editMenu) {
                this.menu.push({
                    id: this.menu.length,
                    label: 'shared.modifier',
                    visible: true,
                    click: () => this.eventEdit.next(this.selectedRow)
                });
            }
            if (this.options?.deleteMenu) {
                this.menu.push({
                    id: this.menu.length,
                    label: 'shared.supprimer',
                    visible: true,
                    click: () => this.eventDelete.next(this.selectedRow)
                });
            }
        }
        if (this.rowCustomMenus?.length) {
            this.menu.push(...this.rowCustomMenus);
        }
        this.exportMenu = [];
        if (this.options?.exportTypes?.length) {
            const all = this.options.exportTypes.includes(ExportType.ALL);
            if (all || this.options.exportTypes.includes(ExportType.PDF)) {
                this.exportMenu.push({
                    id: 1, label: 'shared.exporterPDF', visible: true,
                    click: () => this.export(ExportType.PDF)
                });
            }
            if (all || this.options.exportTypes.includes(ExportType.CSV)) {
                this.exportMenu.push({
                    id: 2, label: 'shared.exporterCSV', visible: true,
                    click: () => this.export(ExportType.CSV)
                });
            }
        }
    }
    updateColumns() {
        this.dataColumns = _.cloneDeep(this.columns);
        this.columns = this.columns?.filter(c => ACTION_COL.field !== c.field);
        if (this.showMenu) {
            this.columns.unshift(ACTION_COL);
        }
    }
    ngOnInit() {
        this.taping.pipe(debounceTime(500), takeUntil(this.destroy)).subscribe(term => this.searching.next(term));
        this.selecting.pipe(debounceTime(500), takeUntil(this.destroy)).subscribe(rows => this.selectedRows.next(rows));
    }
    toggleCheckboxes(state) {
        this.allChecked = state;
        this.rows.forEach((r) => r.checked = state);
        this.selecting.next(state ? this.rows : []);
    }
    toggleCheckbox(i, state) {
        this.rows[i].checked = state;
        const data = this.rows.filter((r) => r.checked);
        this.allChecked = data.length === this.rows.length;
        this.selecting.next(data);
    }
    export(type) {
        this.exporting.next({ filter: this.term, sort: this.sortBy, type, columns: this.dataColumns });
    }
    formatDateValue(col, item) {
        return SanDateService.formatJS(_.get(item, col.field, null), col.format);
    }
    getColValue(col, item) {
        return col.displayFn ? col.displayFn(item) : _.get(item, col.field, '');
    }
    getBoolIcon(col, item) {
        return _.get(item, col.field, false) ? this.IconName.TOGGLE_ON : this.IconName.TOGGLE_OFF;
    }
    getColTitle(col, item) {
        return col.titleFn ? col.titleFn(item) : '';
    }
    clickAction(col, item) {
        return !!col.clickAction || (col?.clickActionFn && !!col?.clickActionFn(item));
    }
    getSortField(col) {
        return col.sortField ?? col.field;
    }
    getDirection(col) {
        if (this.sortBy) {
            return this.sortBy.field === this.getSortField(col) ? this.sortBy.direction : null;
        }
        return col.defaultSort ? SortDirection.ASC : null;
    }
    getIcon(col) {
        let direction = col.defaultSort ? SortDirection.ASC : null;
        if (this.sortBy) {
            direction = this.sortBy.field === this.getSortField(col) ? this.sortBy.direction : null;
        }
        if (direction === SortDirection.DESC) {
            return this.IconName.SORT_DOWN;
        }
        return direction === SortDirection.ASC ? this.IconName.SORT_UP : this.IconName.SORT;
    }
    sort(col) {
        this.sortBy = {
            field: this.getSortField(col),
            direction: this.getDirection(col) === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC
        };
        if (!this.internalSort) {
            this.sortByChange.next(this.sortBy);
        }
        else {
            this.rows = ObjectUtils.sort(this.rows, this.sortBy.field, this.sortBy.direction);
        }
    }
    get displayedColumns() {
        return this.columns.map(c => c.field);
    }
    newElement(item) {
        if (item) {
            this.eventDuplicate.next(item);
        }
        else {
            this.eventAdd.next();
        }
        this.selectedRow = null;
    }
    columnClicked(item, field) {
        this.columnClick.next({ field, item });
    }
    getSwitchType(col) {
        switch (col.type) {
            case ColumnType.EMAIL:
            case ColumnType.TEL:
            case ColumnType.LINK:
                return ColumnType.LINK;
            default:
                return col.type;
        }
    }
    getLinkIcon(col) {
        switch (col.type) {
            case ColumnType.EMAIL:
                return IconName.EMAIL;
            case ColumnType.TEL:
                return IconName.PHONE;
            default:
                return IconName.LINK;
        }
    }
    openLink(col, item) {
        const url = this.getColValue(col, item);
        switch (col.type) {
            case ColumnType.EMAIL:
                window.open(`mailto:${url}`, '_blank');
                break;
            case ColumnType.TEL:
                window.open(`tel:${url}`, '_blank');
                break;
            case ColumnType.LINK:
                window.open(url, '_blank');
                break;
            default:
                console.warn(`${url} is not a link`);
                break;
        }
    }
    rowClicked(item) {
        this.selectedRow = item;
        this.rowMenu.setData(item);
        this.rowClick.next(item);
    }
    rowDblClicked(item) {
        this.rowDblClick.next(item);
    }
    search(value) {
        if (!this.initialization) {
            this.taping.next(value);
        }
        this.initialization = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTableComponent, selector: "san-table", inputs: { data: "data", loading: "loading", showTitle: "showTitle", inlineSearch: "inlineSearch", internalSort: "internalSort", columns: "columns", nbItems: "nbItems", options: "options", selectedRow: "selectedRow", traductionGroup: "traductionGroup", globalMenu: "globalMenu", rowCustomMenus: "rowCustomMenus" }, outputs: { pageChange: "pageChange", rowClick: "rowClick", rowDblClick: "rowDblClick", eventAdd: "eventAdd", eventDelete: "eventDelete", eventEdit: "eventEdit", eventDuplicate: "eventDuplicate", searching: "searching", exporting: "exporting", columnClick: "columnClick", sortByChange: "sortByChange", selectedRows: "selectedRows" }, viewQueries: [{ propertyName: "rowMenu", first: true, predicate: ["menuActions"], descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div fxLayout=\"column\" fxLayoutAlign=\"start start\" fxLayoutGap=\"10px\">\n\n  <div *ngIf=\"showTitle\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <div class=\"table-title\">{{(traductionGroup + '.title') | translate}}</div>\n  </div>\n\n  <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"start end\">\n    <san-input *ngIf=\"inlineSearch\" [maxLength]=\"30\" [placeholder]=\"'shared.recherches'|translate\" [(ngModel)]=\"term\"\n      (ngModelChange)=\"search($event)\">\n    </san-input>\n    <span class=\"app-spacer\"></span>\n    <div fxLayout=\"row\" fxLayoutAlign=\"start end\">\n      <san-icon *ngIf=\"options?.addMenu\" [title]=\"'shared.nouvelElment' | translate\" classes=\"text-primary\"\n        (onclick)=\"newElement()\" [name]=\"IconName.PLUS\"></san-icon>\n\n      <san-icon *ngIf=\"exportMenu.length\" [title]=\"'shared.exporter' | translate\" classes=\"text-primary\"\n        [cdkMenuTriggerFor]=\"menuExportActions.mainMenu\" [name]=\"IconName.DOWNLOAD\"></san-icon>\n    </div>\n  </div>\n\n  <div class=\"table-container\" [isLoading]=\"loading\" tabindex=\"0\">\n    <table aria-describedby=\"datatable\" cdk-table [dataSource]=\"rows\">\n      <ng-container *ngIf=\"showMenu\" cdkColumnDef=\"actions\">\n        <th style=\"width: 50px;\" class=\"head-cell actions\" cdk-header-cell *cdkHeaderCellDef aria-label=\"row actions\">\n          <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n            <san-selection *ngIf=\"options?.showCheckboxes\" [value]=\"allChecked\"\n              (valueChange)=\"toggleCheckboxes($event)\"></san-selection>\n\n            <san-icon *ngIf=\"globalMenu.length\" [title]=\"'shared.plusActions' | translate\" [name]=\"IconName.MENU\"\n              [cdkMenuTriggerFor]=\"menuGlobalActions.mainMenu\"></san-icon>\n          </div>\n        </th>\n        <td class=\"row-cell\" cdk-cell *cdkCellDef=\"let item;let i = index;\">\n          <san-icon *ngIf=\"menu.length && !options?.showCheckboxes\" [name]=\"IconName.MENU\"\n            [cdkMenuTriggerFor]=\"menuActions.mainMenu\" (cdkMenuOpened)=\"rowClicked(item)\"></san-icon>\n\n          <span class=\"numero center\" *ngIf=\"!menu.length && !options?.showCheckboxes\">{{i+1}}</span>\n\n          <san-selection *ngIf=\"options?.showCheckboxes\" [value]=\"item.checked\"\n            (valueChange)=\"toggleCheckbox(i,$event)\"></san-selection>\n        </td>\n      </ng-container>\n\n      <!-- Column -->\n      <ng-container *ngFor=\"let col of dataColumns;\" [cdkColumnDef]=\"col.field\">\n        <th cdk-header-cell *cdkHeaderCellDef>\n          <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n            {{(traductionGroup +'.'+ col.field) | translate}}\n            <san-icon *ngIf=\"col.sortable || col.sortable !== false\" [name]=\"getIcon(col)\" (onclick)=\"sort(col)\"\n              classes=\"small-icon\"></san-icon>\n          </div>\n        </th>\n\n        <td class=\"row-cell\" [title]=\"getColTitle(col,item)\" cdk-cell *cdkCellDef=\"let item\">\n          <ng-container [ngSwitch]=\"getSwitchType(col)\">\n            <ng-container *ngSwitchCase=\"ColumnType.BOOLEEN\">\n              <san-icon [name]=\"getBoolIcon(col,item)\" [clickable]=\"clickAction(col,item)\"\n                (onclick)=\"columnClicked(item, col.field)\"\n                [classes]=\"!!item[col.field] ? 'text-primary' : 'text-warn'\"></san-icon>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"ColumnType.DATE\">\n              {{formatDateValue(col,item)}}\n            </ng-container>\n            <div *ngSwitchCase=\"ColumnType.HTML\" [innerHTML]=\"getColValue(col,item) | safeHtml\">\n            </div>\n            <ng-container *ngSwitchCase=\"ColumnType.LINK\">\n              <span *ngIf=\"getColValue(col,item)?.toString()?.trim()?.length\">\n                {{getColValue(col,item)}}\n                <san-icon class=\"text-info\" [name]=\"getLinkIcon(col)\" size=\"xs\"\n                  (onclick)=\"openLink(col,item)\"></san-icon>\n              </span>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              {{getColValue(col,item)}}\n            </ng-container>\n          </ng-container>\n        </td>\n      </ng-container>\n      <tr class=\"head-row\" cdk-header-row *cdkHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n      <tr class=\"body-row\" cdk-row [class.pointer]=\"options?.editMenu\" [class.row-selected]=\"selectedRow === row\"\n        *cdkRowDef=\"let row; columns: displayedColumns;\" (click)=\"rowClicked(row)\" (dblclick)=\"rowDblClicked(row)\">\n      </tr>\n\n      <tr class=\"body-row\" *cdkNoDataRow>\n        <td class=\"mat-cell center\" [attr.colspan]=\"displayedColumns.length\">\n          {{'shared.aucunElement' | translate}}\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <san-pagination class=\"san-pagination\" [class.hidden]=\"loading\" [nbItems]=\"nbItems\"\n    (pageChange)=\"pageChange.next($event);\"></san-pagination>\n</div>\n\n<san-menu #menuActions [menuItems]=\"menu\"></san-menu>\n<san-menu #menuGlobalActions [menuItems]=\"globalMenu\"></san-menu>\n<san-menu #menuExportActions [menuItems]=\"exportMenu\"></san-menu>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutGapDirective, selector: "  [fxLayoutGap], [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md],  [fxLayoutGap.lg], [fxLayoutGap.xl], [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md],  [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl], [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm],  [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]", inputs: ["fxLayoutGap", "fxLayoutGap.xs", "fxLayoutGap.sm", "fxLayoutGap.md", "fxLayoutGap.lg", "fxLayoutGap.xl", "fxLayoutGap.lt-sm", "fxLayoutGap.lt-md", "fxLayoutGap.lt-lg", "fxLayoutGap.lt-xl", "fxLayoutGap.gt-xs", "fxLayoutGap.gt-sm", "fxLayoutGap.gt-md", "fxLayoutGap.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "directive", type: SanLoaderDirective, selector: "[isLoading]", inputs: ["isLoading", "hasBackdrop"] }, { kind: "component", type: i6.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["cdkColumnDef", "sticky", "stickyEnd"] }, { kind: "directive", type: i6.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "directive", type: i6.CdkNoDataRow, selector: "ng-template[cdkNoDataRow]" }, { kind: "directive", type: i3$3.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "component", type: SanInputComponent, selector: "san-input", inputs: ["pattern", "maxLength", "minLength", "cols", "rows", "type", "globalErrors"] }, { kind: "component", type: SanSelectionComponent, selector: "san-selection", inputs: ["label", "value", "indeterminate", "readonly", "classes", "labelPosition", "idControl"], outputs: ["valueChange"] }, { kind: "component", type: SanPaginationComponent, selector: "san-pagination", inputs: ["nbItems", "classes"], outputs: ["pageChange"] }, { kind: "component", type: SanMenuComponent, selector: "san-menu", inputs: ["menuItems", "classes"], outputs: ["triggerMenu"] }, { kind: "pipe", type: SafeHtmlPipe, name: "safeHtml" }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-table', template: "<div fxLayout=\"column\" fxLayoutAlign=\"start start\" fxLayoutGap=\"10px\">\n\n  <div *ngIf=\"showTitle\" fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <div class=\"table-title\">{{(traductionGroup + '.title') | translate}}</div>\n  </div>\n\n  <div class=\"full-width\" fxLayout=\"row\" fxLayoutAlign=\"start end\">\n    <san-input *ngIf=\"inlineSearch\" [maxLength]=\"30\" [placeholder]=\"'shared.recherches'|translate\" [(ngModel)]=\"term\"\n      (ngModelChange)=\"search($event)\">\n    </san-input>\n    <span class=\"app-spacer\"></span>\n    <div fxLayout=\"row\" fxLayoutAlign=\"start end\">\n      <san-icon *ngIf=\"options?.addMenu\" [title]=\"'shared.nouvelElment' | translate\" classes=\"text-primary\"\n        (onclick)=\"newElement()\" [name]=\"IconName.PLUS\"></san-icon>\n\n      <san-icon *ngIf=\"exportMenu.length\" [title]=\"'shared.exporter' | translate\" classes=\"text-primary\"\n        [cdkMenuTriggerFor]=\"menuExportActions.mainMenu\" [name]=\"IconName.DOWNLOAD\"></san-icon>\n    </div>\n  </div>\n\n  <div class=\"table-container\" [isLoading]=\"loading\" tabindex=\"0\">\n    <table aria-describedby=\"datatable\" cdk-table [dataSource]=\"rows\">\n      <ng-container *ngIf=\"showMenu\" cdkColumnDef=\"actions\">\n        <th style=\"width: 50px;\" class=\"head-cell actions\" cdk-header-cell *cdkHeaderCellDef aria-label=\"row actions\">\n          <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n            <san-selection *ngIf=\"options?.showCheckboxes\" [value]=\"allChecked\"\n              (valueChange)=\"toggleCheckboxes($event)\"></san-selection>\n\n            <san-icon *ngIf=\"globalMenu.length\" [title]=\"'shared.plusActions' | translate\" [name]=\"IconName.MENU\"\n              [cdkMenuTriggerFor]=\"menuGlobalActions.mainMenu\"></san-icon>\n          </div>\n        </th>\n        <td class=\"row-cell\" cdk-cell *cdkCellDef=\"let item;let i = index;\">\n          <san-icon *ngIf=\"menu.length && !options?.showCheckboxes\" [name]=\"IconName.MENU\"\n            [cdkMenuTriggerFor]=\"menuActions.mainMenu\" (cdkMenuOpened)=\"rowClicked(item)\"></san-icon>\n\n          <span class=\"numero center\" *ngIf=\"!menu.length && !options?.showCheckboxes\">{{i+1}}</span>\n\n          <san-selection *ngIf=\"options?.showCheckboxes\" [value]=\"item.checked\"\n            (valueChange)=\"toggleCheckbox(i,$event)\"></san-selection>\n        </td>\n      </ng-container>\n\n      <!-- Column -->\n      <ng-container *ngFor=\"let col of dataColumns;\" [cdkColumnDef]=\"col.field\">\n        <th cdk-header-cell *cdkHeaderCellDef>\n          <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n            {{(traductionGroup +'.'+ col.field) | translate}}\n            <san-icon *ngIf=\"col.sortable || col.sortable !== false\" [name]=\"getIcon(col)\" (onclick)=\"sort(col)\"\n              classes=\"small-icon\"></san-icon>\n          </div>\n        </th>\n\n        <td class=\"row-cell\" [title]=\"getColTitle(col,item)\" cdk-cell *cdkCellDef=\"let item\">\n          <ng-container [ngSwitch]=\"getSwitchType(col)\">\n            <ng-container *ngSwitchCase=\"ColumnType.BOOLEEN\">\n              <san-icon [name]=\"getBoolIcon(col,item)\" [clickable]=\"clickAction(col,item)\"\n                (onclick)=\"columnClicked(item, col.field)\"\n                [classes]=\"!!item[col.field] ? 'text-primary' : 'text-warn'\"></san-icon>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"ColumnType.DATE\">\n              {{formatDateValue(col,item)}}\n            </ng-container>\n            <div *ngSwitchCase=\"ColumnType.HTML\" [innerHTML]=\"getColValue(col,item) | safeHtml\">\n            </div>\n            <ng-container *ngSwitchCase=\"ColumnType.LINK\">\n              <span *ngIf=\"getColValue(col,item)?.toString()?.trim()?.length\">\n                {{getColValue(col,item)}}\n                <san-icon class=\"text-info\" [name]=\"getLinkIcon(col)\" size=\"xs\"\n                  (onclick)=\"openLink(col,item)\"></san-icon>\n              </span>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              {{getColValue(col,item)}}\n            </ng-container>\n          </ng-container>\n        </td>\n      </ng-container>\n      <tr class=\"head-row\" cdk-header-row *cdkHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\n      <tr class=\"body-row\" cdk-row [class.pointer]=\"options?.editMenu\" [class.row-selected]=\"selectedRow === row\"\n        *cdkRowDef=\"let row; columns: displayedColumns;\" (click)=\"rowClicked(row)\" (dblclick)=\"rowDblClicked(row)\">\n      </tr>\n\n      <tr class=\"body-row\" *cdkNoDataRow>\n        <td class=\"mat-cell center\" [attr.colspan]=\"displayedColumns.length\">\n          {{'shared.aucunElement' | translate}}\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <san-pagination class=\"san-pagination\" [class.hidden]=\"loading\" [nbItems]=\"nbItems\"\n    (pageChange)=\"pageChange.next($event);\"></san-pagination>\n</div>\n\n<san-menu #menuActions [menuItems]=\"menu\"></san-menu>\n<san-menu #menuGlobalActions [menuItems]=\"globalMenu\"></san-menu>\n<san-menu #menuExportActions [menuItems]=\"exportMenu\"></san-menu>" }]
        }], ctorParameters: () => [], propDecorators: { data: [{
                type: Input
            }], loading: [{
                type: Input
            }], showTitle: [{
                type: Input
            }], inlineSearch: [{
                type: Input
            }], internalSort: [{
                type: Input
            }], columns: [{
                type: Input
            }], nbItems: [{
                type: Input
            }], options: [{
                type: Input
            }], selectedRow: [{
                type: Input
            }], traductionGroup: [{
                type: Input
            }], globalMenu: [{
                type: Input
            }], rowCustomMenus: [{
                type: Input
            }], pageChange: [{
                type: Output
            }], rowClick: [{
                type: Output
            }], rowDblClick: [{
                type: Output
            }], eventAdd: [{
                type: Output
            }], eventDelete: [{
                type: Output
            }], eventEdit: [{
                type: Output
            }], eventDuplicate: [{
                type: Output
            }], searching: [{
                type: Output
            }], exporting: [{
                type: Output
            }], columnClick: [{
                type: Output
            }], sortByChange: [{
                type: Output
            }], selectedRows: [{
                type: Output
            }], rowMenu: [{
                type: ViewChild,
                args: ['menuActions', { static: true }]
            }] } });

class SanTableModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanTableModule, declarations: [SanTableComponent], imports: [CommonModule,
            SanSharedModule,
            CdkTableModule, i1.TranslateModule, CdkMenuModule,
            SanIconModule,
            SanInputModule,
            SanSelectionModule,
            SanPaginationModule,
            SanMenuModule], exports: [SanTableComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTableModule, imports: [CommonModule,
            SanSharedModule,
            CdkTableModule,
            TranslateModule.forChild(),
            CdkMenuModule,
            SanIconModule,
            SanInputModule,
            SanSelectionModule,
            SanPaginationModule,
            SanMenuModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SanSharedModule,
                        CdkTableModule,
                        TranslateModule.forChild(),
                        CdkMenuModule,
                        SanIconModule,
                        SanInputModule,
                        SanSelectionModule,
                        SanPaginationModule,
                        SanMenuModule
                    ],
                    declarations: [
                        SanTableComponent
                    ],
                    exports: [
                        SanTableComponent
                    ]
                }]
        }] });

class SanTabComponent {
    label = 'Tab';
    icon;
    disabled;
    template;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTabComponent, selector: "san-tab", inputs: { label: "label", icon: "icon", disabled: "disabled" }, viewQueries: [{ propertyName: "template", first: true, predicate: ["template"], descendants: true, static: true }], ngImport: i0, template: "<ng-template #template>\n    <ng-content select=\"[content]\"></ng-content>\n</ng-template>" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-tab', template: "<ng-template #template>\n    <ng-content select=\"[content]\"></ng-content>\n</ng-template>" }]
        }], propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], disabled: [{
                type: Input
            }], template: [{
                type: ViewChild,
                args: ['template', { static: true }]
            }] } });

class SanTabsComponent {
    selectedIndex = 0;
    classes = '';
    selectedIndexChange = new EventEmitter();
    tabs;
    tabGroup;
    visibleTabs = [];
    IconName = IconName;
    displayLeft = false;
    displayRight = false;
    nbVisible = 0;
    width = 500;
    ngAfterViewInit() {
        const tm = setTimeout(() => {
            this.computeTabs();
            clearTimeout(tm);
        });
    }
    isSelected(index) {
        return this.selectedIndex === index;
    }
    isVisible(index) {
        return this.visibleTabs.includes(index);
    }
    select(index) {
        this.selectedIndex = index;
        this.selectedIndexChange.next(index);
    }
    nextTab() {
        const lastIndex = this.visibleTabs[this.visibleTabs.length - 1];
        const tabLength = this.tabs.length - 1;
        if (lastIndex < tabLength) {
            this.visibleTabs.push(lastIndex + 1);
            this.selectedIndex++;
            if (this.visibleTabs.length > this.nbVisible) {
                this.visibleTabs.shift();
            }
        }
        else if (this.selectedIndex < tabLength) {
            this.selectedIndex++;
        }
    }
    prevTab() {
        let firstIndex = this.visibleTabs[0];
        if (firstIndex > 0) {
            firstIndex--;
            this.visibleTabs.unshift(firstIndex);
            if (this.visibleTabs.length > this.nbVisible) {
                this.visibleTabs.pop();
            }
        }
        if (this.selectedIndex > 0) {
            this.selectedIndex--;
        }
    }
    computeTabs() {
        this.width = this.tabGroup.nativeElement.offsetWidth;
        const nb = this.tabs.length;
        this.nbVisible = Math.round(this.width / 50) - 2;
        this.displayLeft = nb > this.nbVisible;
        this.displayRight = this.displayLeft;
        if (!this.displayLeft) {
            this.nbVisible = nb;
        }
        this.visibleTabs = [];
        this.selectedIndex = 0;
        for (let i = this.selectedIndex; i < this.nbVisible; i++) {
            this.visibleTabs.push(i);
        }
    }
    ngOnDestroy() {
        this.tabs = null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTabsComponent, selector: "san-tabs", inputs: { selectedIndex: "selectedIndex", classes: "classes" }, outputs: { selectedIndexChange: "selectedIndexChange" }, queries: [{ propertyName: "tabs", predicate: SanTabComponent }], viewQueries: [{ propertyName: "tabGroup", first: true, predicate: ["tabGroup"], descendants: true, static: true }], ngImport: i0, template: "<div #tabGroup class=\"san-tab {{classes}}\">\n  <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <div *ngIf=\"displayLeft\" class=\"btn-nav\" (click)=\"prevTab()\">\n      <san-icon [name]=\"IconName.CHEVRON_LEFT\"></san-icon>\n    </div>\n    <ng-container *ngFor=\"let tab of tabs;let i=index\">\n      <div *ngIf=\"isVisible(i)\" fxLayout=\"row\" fxLayoutAlign=\"start center\" class=\"tab-nav\"\n        [class.currentNav]=\"isSelected(i)\" (click)=\"select(i)\" [class.disabled]=\"tab.disabled\">\n        <san-icon *ngIf=\"tab.icon && width >= 550\" [name]=\"tab.icon\" [classes]=\"!isSelected(i) ? 'text-accent':''\"\n          [clickable]=\"false\"></san-icon>\n        <span>{{tab.label | translate}}</span>\n        <input [hidden]=\"true\" name=\"nav\" type=\"radio\" class=\"nav-radio\" id=\"tab{{i}}\" [checked]=\"isSelected(i)\" />\n      </div>\n    </ng-container>\n    <div *ngIf=\"displayRight\" class=\"btn-nav\" (click)=\"nextTab()\">\n      <san-icon [name]=\"IconName.CHEVRON_RIGHT\"></san-icon>\n    </div>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"start start\" class=\"san-tab-content\">\n    <div *ngFor=\"let content of tabs;let j=index;\" [hidden]=\"!isSelected(j)\" class=\"page\"\n      [class.currentTab]=\"isSelected(j)\">\n      <div class=\"page-contents\">\n        <ng-template [ngTemplateOutlet]=\"content.template\"></ng-template>\n      </div>\n    </div>\n  </div>\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-tabs', template: "<div #tabGroup class=\"san-tab {{classes}}\">\n  <div fxLayout=\"row\" fxLayoutAlign=\"start center\">\n    <div *ngIf=\"displayLeft\" class=\"btn-nav\" (click)=\"prevTab()\">\n      <san-icon [name]=\"IconName.CHEVRON_LEFT\"></san-icon>\n    </div>\n    <ng-container *ngFor=\"let tab of tabs;let i=index\">\n      <div *ngIf=\"isVisible(i)\" fxLayout=\"row\" fxLayoutAlign=\"start center\" class=\"tab-nav\"\n        [class.currentNav]=\"isSelected(i)\" (click)=\"select(i)\" [class.disabled]=\"tab.disabled\">\n        <san-icon *ngIf=\"tab.icon && width >= 550\" [name]=\"tab.icon\" [classes]=\"!isSelected(i) ? 'text-accent':''\"\n          [clickable]=\"false\"></san-icon>\n        <span>{{tab.label | translate}}</span>\n        <input [hidden]=\"true\" name=\"nav\" type=\"radio\" class=\"nav-radio\" id=\"tab{{i}}\" [checked]=\"isSelected(i)\" />\n      </div>\n    </ng-container>\n    <div *ngIf=\"displayRight\" class=\"btn-nav\" (click)=\"nextTab()\">\n      <san-icon [name]=\"IconName.CHEVRON_RIGHT\"></san-icon>\n    </div>\n  </div>\n  <div fxLayout=\"row\" fxLayoutAlign=\"start start\" class=\"san-tab-content\">\n    <div *ngFor=\"let content of tabs;let j=index;\" [hidden]=\"!isSelected(j)\" class=\"page\"\n      [class.currentTab]=\"isSelected(j)\">\n      <div class=\"page-contents\">\n        <ng-template [ngTemplateOutlet]=\"content.template\"></ng-template>\n      </div>\n    </div>\n  </div>\n</div>" }]
        }], propDecorators: { selectedIndex: [{
                type: Input
            }], classes: [{
                type: Input
            }], selectedIndexChange: [{
                type: Output
            }], tabs: [{
                type: ContentChildren,
                args: [SanTabComponent]
            }], tabGroup: [{
                type: ViewChild,
                args: ['tabGroup', { static: true }]
            }] } });

class SanTabViewDirective {
    el;
    selectedIndex;
    constructor(el) {
        this.el = el;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabViewDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.0", type: SanTabViewDirective, selector: "[sanTabView]", inputs: { selectedIndex: "selectedIndex" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabViewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sanTabView]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { selectedIndex: [{
                type: Input
            }] } });

class SanTabsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanTabsModule, declarations: [SanTabComponent,
            SanTabsComponent,
            SanTabViewDirective], imports: [CommonModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule], exports: [SanTabComponent,
            SanTabsComponent,
            SanTabViewDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabsModule, imports: [CommonModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule
                    ],
                    declarations: [
                        SanTabComponent,
                        SanTabsComponent,
                        SanTabViewDirective
                    ],
                    exports: [
                        SanTabComponent,
                        SanTabsComponent,
                        SanTabViewDirective
                    ]
                }]
        }] });

class SanTreeComponent {
    treeService;
    treeData = [];
    checkedData = [];
    disabled = false;
    withCheckBox = true;
    expandOnInit;
    nodeChecked = new EventEmitter();
    IconName = IconName;
    selectedParent = null;
    treeControl = new NestedTreeControl(node => node.children ?? []);
    dataSource;
    constructor(treeService) {
        this.treeService = treeService;
    }
    ngOnChanges(changes) {
        if (changes) {
            if (changes['treeData']) {
                this.treeData = SanTreeService.updateLevel(this.treeData);
                this.dataSource = new ArrayDataSource(this.treeData);
                this.treeControl.dataNodes = this.treeData;
                this.expandNodes();
            }
            if (changes['checkedData']) {
                this.updateCheckedNodes();
            }
        }
    }
    /**
     * Expand tree nodes
     */
    expandNodes() {
        if (this.expandOnInit) {
            this.treeControl.expandAll();
        }
        else {
            this.dataNodes.filter(t => t.expand).forEach(n => this.treeControl.expand(n));
        }
    }
    unCheckAllNodes() {
        for (const n of this.dataNodes) {
            n.checked = false;
            SanTreeService.updateChildrenState(this.treeControl.getDescendants(n), false);
        }
    }
    /**
     * Update checked nodes
     */
    updateCheckedNodes() {
        this.unCheckAllNodes();
        const nodes = (this.checkedData ?? []).map(n => n.id);
        if (nodes.length) {
            for (const n of this.dataNodes) {
                n.checked = nodes.includes(n.id);
                this.treeControl.getDescendants(n).forEach(c => {
                    c.checked = nodes.includes(c.id);
                    this.checkAllParentsSelection(c);
                });
                this.checkAllParentsSelection(n);
            }
        }
    }
    /**
     * Whether all the descendants of the node are selected.
     * @param node
     * @returns
     */
    descendantsAllSelected(node) {
        return this.treeControl.getDescendants(node)?.every((child) => child.checked);
    }
    /**
     * Whether part of the descendants are selected
     * @param node
     * @returns
     */
    descendantsPartiallySelected(node) {
        const result = this.treeControl.getDescendants(node)?.some((child) => child.checked);
        return result && !this.descendantsAllSelected(node);
    }
    /**
     * Select/Deselect node
     * @param node
     */
    itemSelectionToggle(node, state) {
        node.checked = state;
        SanTreeService.updateChildrenState(this.treeControl.getDescendants(node), node.checked);
        this.checkAllParentsSelection(node);
        this.nodeChecked.next(node);
    }
    /**
     * Select/Deselect leaf node
     * @param node
     */
    leafItemSelectionToggle(node, state) {
        node.checked = state;
        this.checkAllParentsSelection(node);
        this.nodeChecked.next(node);
    }
    get dataNodes() {
        return this.treeControl.dataNodes ?? [];
    }
    /**
     * Checks all the parents when a leaf node is selected/unselected
     * @param node
     */
    checkAllParentsSelection(node) {
        let parent = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    }
    /**
     * Check root node checked state and change it accordingly
     * @param node
     */
    checkRootNodeSelection(node) {
        const descAllSelected = this.treeControl.getDescendants(node)?.every((child) => child.checked);
        if (node.checked && !descAllSelected) {
            node.checked = false;
        }
        else if (!node.checked && descAllSelected) {
            node.checked = true;
        }
    }
    /**
     * Get the parent node of a node
     * @param node
     * @returns
     */
    getParentNode(node) {
        return SanTreeService.findParent(node, this.dataNodes, null);
    }
    get checkedNodes() {
        const nodes = [];
        for (const node of this.dataNodes) {
            if (node.checked) {
                nodes.push(node);
            }
            nodes.push(...this.treeControl.getDescendants(node).filter(n => n.checked));
        }
        return nodes;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeComponent, deps: [{ token: SanTreeService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.0", type: SanTreeComponent, selector: "san-tree", inputs: { treeData: "treeData", checkedData: "checkedData", disabled: "disabled", withCheckBox: "withCheckBox", expandOnInit: "expandOnInit" }, outputs: { nodeChecked: "nodeChecked" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"tree-nodes\">\n    <cdk-tree [class.disabled]=\"disabled\" [dataSource]=\"dataSource\" [treeControl]=\"treeControl\">\n        <!-- This is the tree node template for leaf nodes -->\n        <cdk-nested-tree-node *cdkTreeNodeDef=\"let node\">\n            <div fxLayout=\"row\" fxLayoutAlign=\"start center\" [style.padding-left.px]=\"node.level*30\">\n                <san-selection *ngIf=\"withCheckBox\" idControl=\"tree-node-{{node.id}}\" [value]=\"node.checked\"\n                    (valueChange)=\"leafItemSelectionToggle(node,$event)\" labelPosition=\"after\"\n                    [label]=\"node.label | translate\" [readonly]=\"node.disabled\">\n                </san-selection>\n                <ng-container *ngIf=\"!withCheckBox\">{{node.label | translate}}</ng-container>\n            </div>\n        </cdk-nested-tree-node>\n        <!-- This is the tree node template for expandable nodes -->\n        <cdk-nested-tree-node *cdkTreeNodeDef=\"let node; when: treeService.hasChild\">\n            <div fxLayout=\"row\" fxLayoutAlign=\"start center\" [style.padding-left.px]=\"node.level*20\">\n                <san-icon cdkTreeNodeToggle [attr.aria-label]=\"node.label + ' ' + node.id\"\n                    [name]=\"treeControl.isExpanded(node) ? IconName.ANGLE_DOWN : IconName.ANGLE_RIGHT\" size=\"sm\"\n                    classes=\"expand\"></san-icon>\n                <san-selection *ngIf=\"withCheckBox\" [readonly]=\"node.disabled\" idControl=\"tree-node-{{node.id}}\"\n                    [value]=\"node.checked || descendantsAllSelected(node)\" labelPosition=\"after\"\n                    [label]=\"node.label | translate\" (valueChange)=\"itemSelectionToggle(node,$event)\"\n                    [indeterminate]=\"descendantsPartiallySelected(node)\"></san-selection>\n                <ng-container *ngIf=\"!withCheckBox\">{{node.label | translate}}</ng-container>\n            </div>\n            <div [hidden]=\"!treeControl.isExpanded(node)\" [class.childNodes]=\"treeControl.isExpanded(node)\">\n                <ng-container cdkTreeNodeOutlet></ng-container>\n            </div>\n        </cdk-nested-tree-node>\n    </cdk-tree>\n</div>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$5.CdkNestedTreeNode, selector: "cdk-nested-tree-node", exportAs: ["cdkNestedTreeNode"] }, { kind: "directive", type: i3$5.CdkTreeNodeDef, selector: "[cdkTreeNodeDef]", inputs: ["cdkTreeNodeDefWhen"] }, { kind: "directive", type: i3$5.CdkTreeNodeToggle, selector: "[cdkTreeNodeToggle]", inputs: ["cdkTreeNodeToggleRecursive"] }, { kind: "component", type: i3$5.CdkTree, selector: "cdk-tree", inputs: ["dataSource", "treeControl", "trackBy"], exportAs: ["cdkTree"] }, { kind: "directive", type: i3$5.CdkTreeNodeOutlet, selector: "[cdkTreeNodeOutlet]" }, { kind: "directive", type: i3.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i3.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: SanIconComponent, selector: "san-icon", inputs: ["name", "id", "style", "size", "classes", "color", "clickable", "disabled"], outputs: ["onclick"] }, { kind: "component", type: SanSelectionComponent, selector: "san-selection", inputs: ["label", "value", "indeterminate", "readonly", "classes", "labelPosition", "idControl"], outputs: ["valueChange"] }, { kind: "pipe", type: i1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'san-tree', template: "<div class=\"tree-nodes\">\n    <cdk-tree [class.disabled]=\"disabled\" [dataSource]=\"dataSource\" [treeControl]=\"treeControl\">\n        <!-- This is the tree node template for leaf nodes -->\n        <cdk-nested-tree-node *cdkTreeNodeDef=\"let node\">\n            <div fxLayout=\"row\" fxLayoutAlign=\"start center\" [style.padding-left.px]=\"node.level*30\">\n                <san-selection *ngIf=\"withCheckBox\" idControl=\"tree-node-{{node.id}}\" [value]=\"node.checked\"\n                    (valueChange)=\"leafItemSelectionToggle(node,$event)\" labelPosition=\"after\"\n                    [label]=\"node.label | translate\" [readonly]=\"node.disabled\">\n                </san-selection>\n                <ng-container *ngIf=\"!withCheckBox\">{{node.label | translate}}</ng-container>\n            </div>\n        </cdk-nested-tree-node>\n        <!-- This is the tree node template for expandable nodes -->\n        <cdk-nested-tree-node *cdkTreeNodeDef=\"let node; when: treeService.hasChild\">\n            <div fxLayout=\"row\" fxLayoutAlign=\"start center\" [style.padding-left.px]=\"node.level*20\">\n                <san-icon cdkTreeNodeToggle [attr.aria-label]=\"node.label + ' ' + node.id\"\n                    [name]=\"treeControl.isExpanded(node) ? IconName.ANGLE_DOWN : IconName.ANGLE_RIGHT\" size=\"sm\"\n                    classes=\"expand\"></san-icon>\n                <san-selection *ngIf=\"withCheckBox\" [readonly]=\"node.disabled\" idControl=\"tree-node-{{node.id}}\"\n                    [value]=\"node.checked || descendantsAllSelected(node)\" labelPosition=\"after\"\n                    [label]=\"node.label | translate\" (valueChange)=\"itemSelectionToggle(node,$event)\"\n                    [indeterminate]=\"descendantsPartiallySelected(node)\"></san-selection>\n                <ng-container *ngIf=\"!withCheckBox\">{{node.label | translate}}</ng-container>\n            </div>\n            <div [hidden]=\"!treeControl.isExpanded(node)\" [class.childNodes]=\"treeControl.isExpanded(node)\">\n                <ng-container cdkTreeNodeOutlet></ng-container>\n            </div>\n        </cdk-nested-tree-node>\n    </cdk-tree>\n</div>\n" }]
        }], ctorParameters: () => [{ type: SanTreeService }], propDecorators: { treeData: [{
                type: Input
            }], checkedData: [{
                type: Input
            }], disabled: [{
                type: Input
            }], withCheckBox: [{
                type: Input
            }], expandOnInit: [{
                type: Input
            }], nodeChecked: [{
                type: Output
            }] } });

class SanTreeModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.0", ngImport: i0, type: SanTreeModule, declarations: [SanTreeComponent], imports: [CommonModule,
            CdkTreeModule, i1.TranslateModule, FlexLayoutModule,
            SanIconModule,
            SanSelectionModule], exports: [SanTreeComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeModule, imports: [CommonModule,
            CdkTreeModule,
            TranslateModule.forChild(),
            FlexLayoutModule,
            SanIconModule,
            SanSelectionModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.0", ngImport: i0, type: SanTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CdkTreeModule,
                        TranslateModule.forChild(),
                        FlexLayoutModule,
                        SanIconModule,
                        SanSelectionModule
                    ],
                    declarations: [
                        SanTreeComponent
                    ],
                    exports: [
                        SanTreeComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ACTION_COL, BaseComponent, BaseDialogComponent, BaseFormControl, CALENDAR_OFFSET, ColumnType, DateIsCurrentMonthPipe, DateIsTodayPipe, DatePipe, DynamicOverlay, DynamicOverlayContainer, ExportType, FileSizePipe, FilterUtils, FormErrors, FormatDate, HasItemActionPipe, IconName, ListItemAction, OVERLAY_BTCO, OVERLAY_BTCR, OVERLAY_BTLF, OVERLAY_BTRG, OVERLAY_POSITIONS, OVERLAY_TPCO, OVERLAY_TPCR, OVERLAY_TPLF, OVERLAY_TPRG, ObjectUtils, Page, PageSize, PreviewFilePipe, SafeHtmlPipe, SafeUrlPipe, SanAutocompleteComponent, SanAutocompleteModule, SanBlocComponent, SanBlocModule, SanButtonComponent, SanButtonIconComponent, SanButtonIconModule, SanButtonModule, SanButtonToggleComponent, SanButtonToggleModule, SanCalendarComponent, SanCalendarMode, SanCalendarModule, SanCardComponent, SanCardModule, SanCheckBoxComponent, SanCheckListComponent, SanCheckListModule, SanCheckboxModule, SanCustomValidators, SanDateComponent, SanDateModule, SanDatePickerComponent, SanDateService, SanDayCellComponent, SanDialogComponent, SanDialogModule, SanDialogService, SanDividerComponent, SanEditorComponent, SanEditorModule, SanFileService, SanFileUploadComponent, SanFileUploadModule, SanFormErrorsComponent, SanFormErrorsModule, SanFormsModule, SanIconComponent, SanIconModule, SanInformationComponent, SanInputComponent, SanInputModule, SanListViewComponent, SanListViewModule, SanLoaderDirective, SanMenuComponent, SanMenuModule, SanModalComponent, SanModalModule, SanMonthDayCellComponent, SanMultiSelectComponent, SanMultiSelectModule, SanNavigationService, SanPaginationComponent, SanPaginationModule, SanPipeModule, SanRadioButtonComponent, SanRadioButtonModule, SanRectComponent, SanSelectComponent, SanSelectModule, SanSelectionComponent, SanSelectionModule, SanSharedModule, SanSlideToggleComponent, SanSlideToggleModule, SanSpinnerComponent, SanSvgModule, SanTabComponent, SanTabViewDirective, SanTableComponent, SanTableModule, SanTabsComponent, SanTabsModule, SanTemplateService, SanTimeComponent, SanTimeModule, SanTimePickerComponent, SanTimePickerModule, SanTreeComponent, SanTreeModule, SanTreeService, SanUploadDialogComponent, SanValidatorService, SearchCondition, SearchOperator, SearchType, SortDirection };
